// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"8CgKt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _feedView = require("./view/feed-view");
class AppShell extends (0, _lit.LitElement) {
    static get is() {
        return "app-shell";
    }
    constructor(){
        super();
        try {
            this.worker = new Worker(require("bd41e78b29b70e22"));
            console.debug("Registered service worker.");
        } catch (error) {
            console.error("Error registering service worker: ", error);
            return;
        }
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`<feed-view></feed-view>`;
    }
}
exports.default = AppShell;
customElements.define(AppShell.is, AppShell);

},{"lit":"aCmte","./view/feed-view":"8tMey","bd41e78b29b70e22":"26le1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCmte":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactiveElement = require("@lit/reactive-element");
var _litHtml = require("lit-html");
var _litElementJs = require("lit-element/lit-element.js");
parcelHelpers.exportAll(_litElementJs, exports);
var _isServerJs = require("lit-html/is-server.js");
parcelHelpers.exportAll(_isServerJs, exports);

},{"@lit/reactive-element":"hUcCl","lit-html":"4A25t","lit-element/lit-element.js":"8BOF1","lit-html/is-server.js":"2Mmwb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUcCl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSResult", ()=>(0, _cssTagJs.CSSResult));
parcelHelpers.export(exports, "adoptStyles", ()=>(0, _cssTagJs.adoptStyles));
parcelHelpers.export(exports, "css", ()=>(0, _cssTagJs.css));
parcelHelpers.export(exports, "getCompatibleStyle", ()=>(0, _cssTagJs.getCompatibleStyle));
parcelHelpers.export(exports, "supportsAdoptingStyleSheets", ()=>(0, _cssTagJs.supportsAdoptingStyleSheets));
parcelHelpers.export(exports, "unsafeCSS", ()=>(0, _cssTagJs.unsafeCSS));
parcelHelpers.export(exports, "ReactiveElement", ()=>u);
parcelHelpers.export(exports, "defaultConverter", ()=>n);
parcelHelpers.export(exports, "notEqual", ()=>a);
var _cssTagJs = require("./css-tag.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var s;
const e = window, r = e.trustedTypes, h = r ? r.emptyScript : "", o = e.reactiveElementPolyfillSupport, n = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, a = (t, i)=>i !== t && (i == i || t == t), l = {
    attribute: !0,
    type: String,
    converter: n,
    reflect: !1,
    hasChanged: a
}, d = "finalized";
class u extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || l;
    }
    static finalize() {
        if (this.hasOwnProperty(d)) return !1;
        this[d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, _cssTagJs.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, _cssTagJs.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    u() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, _cssTagJs.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : n).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : n;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || a)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
u[d] = !0, u.elementProperties = new Map, u.elementStyles = [], u.shadowRootOptions = {
    mode: "open"
}, null == o || o({
    ReactiveElement: u
}), (null !== (s = e.reactiveElementVersions) && void 0 !== s ? s : e.reactiveElementVersions = []).push("1.6.2");

},{"./css-tag.js":"gSCbb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSCbb":[function(require,module,exports) {
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSResult", ()=>o);
parcelHelpers.export(exports, "adoptStyles", ()=>S);
parcelHelpers.export(exports, "css", ()=>i);
parcelHelpers.export(exports, "getCompatibleStyle", ()=>c);
parcelHelpers.export(exports, "supportsAdoptingStyleSheets", ()=>e);
parcelHelpers.export(exports, "unsafeCSS", ()=>r);
const t = window, e = t.ShadowRoot && (void 0 === t.ShadyCSS || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s = Symbol(), n = new WeakMap;
class o {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if (e && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const r = (t)=>new o("string" == typeof t ? t : t + "", void 0, s), i = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new o(n, t, s);
}, S = (s, n)=>{
    e ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, c = e ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return r(e);
    })(t) : t;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"4A25t":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_$LH", ()=>Z);
parcelHelpers.export(exports, "html", ()=>x);
parcelHelpers.export(exports, "noChange", ()=>T);
parcelHelpers.export(exports, "nothing", ()=>A);
parcelHelpers.export(exports, "render", ()=>B);
parcelHelpers.export(exports, "svg", ()=>b);
var t;
const i = window, s = i.trustedTypes, e = s ? s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, o = "$lit$", n = `lit$${(Math.random() + "").slice(9)}$`, l = "?" + n, h = `<${l}>`, r = document, d = ()=>r.createComment(""), u = (t)=>null === t || "object" != typeof t && "function" != typeof t, c = Array.isArray, v = (t)=>c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), a = "[ 	\n\f\r]", f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, _ = /-->/g, m = />/g, p = RegExp(`>|${a}(?:([^\\s"'>=/]+)(${a}*=${a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), g = /'/g, $ = /"/g, y = /^(?:script|style|textarea|title)$/i, w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), x = w(1), b = w(2), T = Symbol.for("lit-noChange"), A = Symbol.for("lit-nothing"), E = new WeakMap, C = r.createTreeWalker(r, 129, null, !1), P = (t, i)=>{
    const s = t.length - 1, l = [];
    let r, d = 2 === i ? "<svg>" : "", u = f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let e, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === f ? "!--" === c[1] ? u = _ : void 0 !== c[1] ? u = m : void 0 !== c[2] ? (y.test(c[2]) && (r = RegExp("</" + c[2], "g")), u = p) : void 0 !== c[3] && (u = p) : u === p ? ">" === c[0] ? (u = null != r ? r : f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, e = c[1], u = void 0 === c[3] ? p : '"' === c[3] ? $ : g) : u === $ || u === g ? u = p : u === _ || u === m ? u = f : (u = p, r = void 0);
        const w = u === p && t[i + 1].startsWith("/>") ? " " : "";
        d += u === f ? s + h : v >= 0 ? (l.push(e), s.slice(0, v) + o + s.slice(v) + n + w) : s + n + (-2 === v ? (l.push(void 0), i) : w);
    }
    const c = d + (t[s] || "<?>") + (2 === i ? "</svg>" : "");
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== e ? e.createHTML(c) : c,
        l
    ];
};
class V {
    constructor({ strings: t , _$litType$: i  }, e){
        let h;
        this.parts = [];
        let r = 0, u = 0;
        const c = t.length - 1, v = this.parts, [a, f] = P(t, i);
        if (this.el = V.createElement(a, e), C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith(o) || i.startsWith(n)) {
                        const s = f[u++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + o).split(n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? k : "?" === i[1] ? I : "@" === i[1] ? L : R
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if (y.test(h.tagName)) {
                    const t = h.textContent.split(n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = s ? s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], d()), C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], d());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf(n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function N(t, i, s = t, e) {
    var o, n, l, h;
    if (i === T) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const d = u(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== d && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === d ? r = void 0 : (r = new d(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = N(t, r._$AS(t, i.values), r, e)), i;
}
class S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s  } , parts: e  } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : r).importNode(s, !0);
        C.currentNode = o;
        let n = C.nextNode(), l = 0, h = 0, d = e[0];
        for(; void 0 !== d;){
            if (l === d.index) {
                let i;
                2 === d.type ? i = new M(n, n.nextSibling, this, t) : 1 === d.type ? i = new d.ctor(n, d.name, d.strings, this, t) : 6 === d.type && (i = new z(n, this, t)), this._$AV.push(i), d = e[++h];
            }
            l !== (null == d ? void 0 : d.index) && (n = C.nextNode(), l++);
        }
        return C.currentNode = r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class M {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = A, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = N(this, t, i), u(t) ? t === A || null == t || "" === t ? (this._$AH !== A && this._$AR(), this._$AH = A) : t !== this._$AH && t !== T && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== A && u(this._$AH) ? this._$AA.nextSibling.data = t : this.$(r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s , _$litType$: e  } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = V.createElement(e.h, this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new S(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = E.get(t.strings);
        return void 0 === i && E.set(t.strings, i = new V(t)), i;
    }
    T(t) {
        c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new M(this.k(d()), this.k(d()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class R {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = A, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = A;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = N(this, t, i, 0), n = !u(t) || t !== this._$AH && t !== T, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = N(this, e[s + l], i, l), h === T && (h = this._$AH[l]), n || (n = !u(h) || h !== this._$AH[l]), h === A ? t = A : t !== A && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === A ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class k extends R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === A ? void 0 : t;
    }
}
const H = s ? s.emptyScript : "";
class I extends R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== A ? this.element.setAttribute(this.name, H) : this.element.removeAttribute(this.name);
    }
}
class L extends R {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = N(this, t, i, 0)) && void 0 !== s ? s : A) === T) return;
        const e = this._$AH, o = t === A && e !== A || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== A && (e === A || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        N(this, t);
    }
}
const Z = {
    O: o,
    P: n,
    A: l,
    C: 1,
    M: P,
    L: S,
    D: v,
    R: N,
    I: M,
    V: R,
    H: I,
    N: L,
    U: k,
    F: z
}, j = i.litHtmlPolyfillSupport;
null == j || j(V, M), (null !== (t = i.litHtmlVersions) && void 0 !== t ? t : i.litHtmlVersions = []).push("2.7.4");
const B = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new M(i.insertBefore(d(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8BOF1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LitElement", ()=>s);
parcelHelpers.export(exports, "UpdatingElement", ()=>r);
parcelHelpers.export(exports, "_$LE", ()=>h);
var _reactiveElement = require("@lit/reactive-element");
parcelHelpers.exportAll(_reactiveElement, exports);
var _litHtml = require("lit-html");
parcelHelpers.exportAll(_litHtml, exports);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var l, o;
const r = (0, _reactiveElement.ReactiveElement);
class s extends (0, _reactiveElement.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, _litHtml.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, _litHtml.noChange;
    }
}
s.finalized = !0, s._$litElement$ = !0, null === (l = globalThis.litElementHydrateSupport) || void 0 === l || l.call(globalThis, {
    LitElement: s
});
const n = globalThis.litElementPolyfillSupport;
null == n || n({
    LitElement: s
});
const h = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== (o = globalThis.litElementVersions) && void 0 !== o ? o : globalThis.litElementVersions = []).push("3.3.2");

},{"@lit/reactive-element":"hUcCl","lit-html":"4A25t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Mmwb":[function(require,module,exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServer", ()=>o);
const o = !1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8tMey":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _repeatJs = require("lit/directives/repeat.js");
var _whenJs = require("lit/directives/when.js");
var _scrollContainer = require("../scroll-container");
var _scrollContainerDefault = parcelHelpers.interopDefault(_scrollContainer);
var _loadingAnimation = require("./loading-animation");
var _loadingAnimationDefault = parcelHelpers.interopDefault(_loadingAnimation);
var _videoPlayer = require("./video-player");
var _videoPlayerDefault = parcelHelpers.interopDefault(_videoPlayer);
var _iconsJs = require("../icons.js");
var _swipedEvents = require("swiped-events/src/swiped-events");
var _dataJs = require("../data.js");
class FeedView extends (0, _lit.LitElement) {
    static get is() {
        return "feed-view";
    }
    static isMobile() {
        const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return regex.test(navigator.userAgent);
    }
    static requestFullscreen(element) {
        if (element.requestFullscreen) element.requestFullscreen();
        else if (element.webkitRequestFullscreen) /* Safari */ element.webkitRequestFullscreen();
        else if (element.msRequestFullscreen) /* IE11 */ element.msRequestFullscreen();
        else console.warn("Couldn't request fullscreen");
    }
    static random(seed) {
        const x = Math.sin(seed) * 10000;
        return x - Math.floor(x);
    }
    static swap(array, i, j) {
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
    static shuffleInPlace(array, seed) {
        for(let i = array.length - 1; i > 0; i--){
            // Generate a random index between 0 and i (inclusive)
            const j = Math.floor(FeedView.random(seed++) * (i + 1));
            FeedView.swap(array, i, j);
        }
    }
    getNextEntry() {
        const nextValue = this.iterator.next();
        if (nextValue.done) {
            alert("YOU WATCHED EVERYTHING!");
            return;
        }
        return nextValue.value;
    }
    saveUserInfo() {
        localStorage.setItem("bladingdata", JSON.stringify(this.info));
    }
    constructor(){
        super();
        if (!localStorage.getItem("bladingdata")) {
            console.debug("localStorage init");
            this.info = {
                seed: performance.now()
            };
            localStorage.setItem("bladingdata", JSON.stringify(this.info));
            this.firstVisit = true;
        } else this.info = JSON.parse(localStorage.getItem("bladingdata"));
        if (!this.info.likes) this.info.likes = [];
        if (!this.info.saves) this.info.saves = [];
        FeedView.shuffleInPlace((0, _dataJs.DATA), this.info.seed); // TODO: move to service worker ?
        this.url = new URL(window.location.href);
        let param = this.url.pathname;
        if (param.startsWith("/")) param = param.substring(1);
        if (param.length === 11) {
            const targetIndex = (0, _dataJs.DATA).indexOf(param);
            if (targetIndex === -1) (0, _dataJs.DATA).unshift(param);
            else if (targetIndex > 0) // target index could be already 0
            FeedView.swap((0, _dataJs.DATA), 0, targetIndex);
            this.param = param;
        }
        this.playlist = (0, _dataJs.DATA);
        this.iterator = this.playlist[Symbol.iterator](); // TODO: loop
        this.isMobile = FeedView.isMobile();
        this.firstInteraction = false;
        this.sectionCount = 4;
        this.sections = [];
        console.debug(this.info);
        if (this.info.lastWatched === undefined) return;
        function moveToIndex(iterator, targetIndex) {
            let currentIndex = 0;
            let nextValue = iterator.next();
            while(!nextValue.done && currentIndex < targetIndex){
                nextValue = iterator.next();
                currentIndex++;
            }
            return nextValue.value;
        }
        const lastIndex = this.playlist.indexOf(this.info.lastWatched); // TODO: get from shuffle to avoid iterating twice
        moveToIndex(this.iterator, lastIndex - 1); // step one back so when first section is created and increments iterator
    }
    createRenderRoot() {
        return this;
    }
    render() {
        console.debug("feed-view: render");
        return (0, _lit.html)`
            <loading-animation>
                ${(0, _whenJs.when)(this.firstVisit, ()=>(0, _lit.html)`<span slot="text">Initializing...</span>`, ()=>(0, _lit.html)`<span slot="text">Welcome back 💾</span>`)}
            </loading-animation>
            <scroll-container
                @sectionleave=${this.onSectionLeave} @sectionenter=${this.onSectionEnter}
                data-swipe-unit="px" data-swipe-timeout="250" data-swipe-threshold="10">
                    ${(0, _repeatJs.repeat)(this.sections, (section)=>section.id, (section)=>section)}
            </scroll-container>
            <heart-icon class="ephemeral"></heart-icon>
            <bookmark-icon class="ephemeral"></bookmark-icon>
        `;
    }
    renderVideoPlayer(playerId, videoId) {
        // TODO: make static for consistency
        return (0, _lit.html)`
            <video-player
                playerid="${playerId}"
                videoid="${videoId}"
                origin=${this.url.origin}
                liked=${this.info.likes.includes(videoId) || (0, _lit.nothing)}
                saved=${this.info.saves.includes(videoId) || (0, _lit.nothing)}>
            </video-player>
        `;
    }
    async firstUpdated() {
        super.firstUpdated();
        this.scrollContainer = this.renderRoot.querySelector((0, _scrollContainerDefault.default).is);
        this.likeLogo = this.renderRoot.querySelector((0, _iconsJs.HeartIcon).is);
        this.saveLogo = this.renderRoot.querySelector((0, _iconsJs.BookmarkIcon).is);
        let promises = [];
        for(var i = 0; i < this.sectionCount; i++){
            const playerId = `p${i}`;
            const videoId = this.getNextEntry();
            const playerTemplate = this.renderVideoPlayer(playerId, videoId);
            const section = this.scrollContainer.createSection(playerTemplate);
            section.id = `s${i}`;
            section.addEventListener("swiped-up", ()=>this.scrollContainer.scrollToSection(section, 1));
            section.addEventListener("swiped-down", ()=>this.scrollContainer.scrollToSection(section, -1));
            const player = section.querySelector((0, _videoPlayerDefault.default).is);
            player.addEventListener("ended", ()=>this.scrollContainer.scrollToSection(section, 1));
            promises.push(new Promise((resolve)=>{
                player.addEventListener("playerready", ()=>resolve());
            }));
            this.sections.push(section);
        }
        this.addEventListener("videoready", this.onVideoReady);
        this.requestUpdate();
        await Promise.all(promises);
        const loading = this.renderRoot.querySelector((0, _loadingAnimationDefault.default).is);
        loading.hide();
        window.addEventListener("keydown", (e)=>{
            if (e.code !== "ArrowUp" && e.code !== "ArrowDown") return;
            if (e.repeat) return;
            const direction = e.code === "ArrowDown" ? 1 : -1;
            this.scrollContainer.scrollToNextSection(direction);
        }, true);
        window.addEventListener("keydown", (e)=>{
            if (e.code !== "ArrowLeft" && e.code !== "ArrowRight") return;
            if (e.repeat) return;
            const section = this.scrollContainer.activeSection;
            const player = section.querySelector((0, _videoPlayerDefault.default).is);
            if (player === undefined || player === null) return;
            if (e.code === "ArrowLeft") player.rewind();
            else player.forward();
        }, true);
        window.addEventListener("keydown", (e)=>{
            if (e.code !== "Space") return;
            if (e.repeat) return;
            const section = this.scrollContainer.activeSection;
            const player = section.querySelector((0, _videoPlayerDefault.default).is);
            if (player === undefined || player === null) return;
            if (player.isPlaying()) player.pause();
            else player.play();
        }, true);
        this.addEventListener("click", this.onFirstUserInteraction, {
            once: true,
            capture: true
        });
        this.addEventListener("like", (e)=>this.onUserInteraction("like", e.detail.id, e.detail.state, this.info.likes, this.likeLogo));
        this.addEventListener("save", (e)=>this.onUserInteraction("save", e.detail.id, e.detail.state, this.info.saves, this.saveLogo));
    }
    onFirstUserInteraction(e) {
        if (this.firstInteraction) return;
        e.preventDefault();
        e.stopPropagation(); // avoid triggering player clickToPlay
        this.firstInteraction = true;
        this.sections.forEach((section)=>{
            const allowAutoplay = section.id === this.scrollContainer.activeSection.id;
            const player = section.querySelector((0, _videoPlayerDefault.default).is);
            player.enable(allowAutoplay);
        });
    }
    onUserInteraction(action, id, state, collection, element) {
        console.debug(`${action}: `, id);
        if (!state) {
            const index = collection.indexOf(id);
            if (index > -1) collection.splice(index, 1);
        } else if (!collection.includes(id)) // TODO: avoid includes
        collection.push(id);
        this.saveUserInfo();
        if (!state) return;
        if (navigator.vibrate) navigator.vibrate(50);
        element.addEventListener("animationend", ()=>element.classList.remove("rise"), {
            once: true
        });
        element.classList.add("rise");
    }
    onVideoReady(e) {
        e.detail.promise.catch((player)=>{
            if (player.videoid !== this.param || player.videoid !== this.playlist[0]) {
                player.load(this.getNextEntry());
                return;
            }
        // this.scrollContainer.timeout = setTimeout(() => {
        //     this.scrollContainer.timeout = undefined;
        //     this.scrollContainer.scrollToNextSection(1);
        // }, 10000);
        });
    }
    onSectionLeave(e) {
        const direction = e.detail.direction;
        if (direction > 0) {
            const prevSection = e.detail.current;
            const prevPlayer = prevSection.querySelector((0, _videoPlayerDefault.default).is);
            if (prevPlayer !== undefined && prevPlayer !== null) {
                this.info.lastWatched = prevPlayer.videoid;
                localStorage.setItem("bladingdata", JSON.stringify(this.info));
            }
        }
        if (!this.firstInteraction) return;
        const nextSection = e.detail.target;
        const nextPlayer = nextSection.querySelector((0, _videoPlayerDefault.default).is);
        if (nextPlayer !== undefined && nextPlayer !== null) nextPlayer.play();
        const prevSection = e.detail.current;
        const prevPlayer = prevSection.querySelector((0, _videoPlayerDefault.default).is);
        if (prevPlayer !== undefined && prevPlayer !== null) prevPlayer.pause();
    }
    onSectionEnter(e) {
        const section = e.detail.target;
        const direction = e.detail.direction;
        const player = section.querySelector((0, _videoPlayerDefault.default).is);
        if (player !== undefined && player !== null) window.history.replaceState(null, null, player.videoid);
        if (direction > 0 && Number(section.style.zIndex) % this.sectionCount - 1 === 0) {
            const firstSection = this.scrollContainer.getFirstSection();
            const firstPlayer = firstSection.querySelector((0, _videoPlayerDefault.default).is);
            const videoId = this.getNextEntry();
            const liked = this.info.likes.includes(videoId);
            const saved = this.info.saves.includes(videoId);
            firstPlayer.load(videoId, liked, saved);
            this.scrollContainer.shift();
        }
    }
}
exports.default = FeedView;
customElements.define(FeedView.is, FeedView); /*
let touchstartX = 0;
let touchstartY = 0;
let touchendX = 0;
let touchendY = 0;

const handleGesture = (touchstartX, touchstartY, touchendX, touchendY) => {
    const delx = touchendX - touchstartX;
    const dely = touchendY - touchstartY;
    if (Math.abs(delx) > Math.abs(dely)) {
        if (delx > 0) return "right"
        else return "left"
    }
    else if (Math.abs(delx) < Math.abs(dely)) {
        if (dely > 0) return "down"
        else return "up"
    }
    else return "tap"
}

this.scrollContainer.addEventListener('touchstart', (event) => {
    touchstartX = event.changedTouches[0].screenX;
    touchstartY = event.changedTouches[0].screenY;
}, false);

this.scrollContainer.addEventListener('touchend', (event) => {
    touchendX = event.changedTouches[0].screenX;
    touchendY = event.changedTouches[0].screenY;
    const gesture = handleGesture(touchstartX, touchstartY, touchendX, touchendY);

    if (gesture !== "up" && gesture !== "down")
        return;

    let direction;
    if (gesture === "up")
        direction = 1;
    else if (gesture === "down")
        direction = -1;

    const currSection = this.scrollContainer.activeSection;
    const nextSection = ScrollContainer.getNextSection(currSection, direction);

    const currPlayer = currSection.querySelector(VideoPlayer.is);
    const nextPlayer = nextSection.querySelector(VideoPlayer.is);

    currPlayer.pause();
    nextPlayer.play();

    this.scrollContainer.scrollToSection(currSection, direction);
}, false);
*/ 

},{"lit":"aCmte","lit/directives/repeat.js":"k7vT6","lit/directives/when.js":"4uFa6","../scroll-container":"lfgFh","./loading-animation":"jVgEq","./video-player":"5fFp0","../icons.js":"7gnwH","swiped-events/src/swiped-events":"2Ckcb","../data.js":"4SOBb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k7vT6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _repeatJs = require("lit-html/directives/repeat.js");
parcelHelpers.exportAll(_repeatJs, exports);

},{"lit-html/directives/repeat.js":"1muUi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1muUi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeat", ()=>c);
var _litHtmlJs = require("../lit-html.js");
var _directiveJs = require("../directive.js");
var _directiveHelpersJs = require("../directive-helpers.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, c = (0, _directiveJs.directive)(class extends (0, _directiveJs.Directive) {
    constructor(e){
        if (super(e), e.type !== (0, _directiveJs.PartType).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    dt(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.dt(e, s, t).values;
    }
    update(s, [t, r, c]) {
        var d;
        const a = (0, _directiveHelpersJs.getCommittedValue)(s), { values: p , keys: v  } = this.dt(t, r, c);
        if (!Array.isArray(a)) return this.ht = v, p;
        const h = null !== (d = this.ht) && void 0 !== d ? d : this.ht = [], m = [];
        let y, x, j = 0, k = a.length - 1, w = 0, A = p.length - 1;
        for(; j <= k && w <= A;)if (null === a[j]) j++;
        else if (null === a[k]) k--;
        else if (h[j] === v[w]) m[w] = (0, _directiveHelpersJs.setChildPartValue)(a[j], p[w]), j++, w++;
        else if (h[k] === v[A]) m[A] = (0, _directiveHelpersJs.setChildPartValue)(a[k], p[A]), k--, A--;
        else if (h[j] === v[A]) m[A] = (0, _directiveHelpersJs.setChildPartValue)(a[j], p[A]), (0, _directiveHelpersJs.insertPart)(s, m[A + 1], a[j]), j++, A--;
        else if (h[k] === v[w]) m[w] = (0, _directiveHelpersJs.setChildPartValue)(a[k], p[w]), (0, _directiveHelpersJs.insertPart)(s, a[j], a[k]), k--, w++;
        else if (void 0 === y && (y = u(v, w, A), x = u(h, j, k)), y.has(h[j])) {
            if (y.has(h[k])) {
                const e = x.get(v[w]), t = void 0 !== e ? a[e] : null;
                if (null === t) {
                    const e = (0, _directiveHelpersJs.insertPart)(s, a[j]);
                    (0, _directiveHelpersJs.setChildPartValue)(e, p[w]), m[w] = e;
                } else m[w] = (0, _directiveHelpersJs.setChildPartValue)(t, p[w]), (0, _directiveHelpersJs.insertPart)(s, a[j], t), a[e] = null;
                w++;
            } else (0, _directiveHelpersJs.removePart)(a[k]), k--;
        } else (0, _directiveHelpersJs.removePart)(a[j]), j++;
        for(; w <= A;){
            const e = (0, _directiveHelpersJs.insertPart)(s, m[A + 1]);
            (0, _directiveHelpersJs.setChildPartValue)(e, p[w]), m[w++] = e;
        }
        for(; j <= k;){
            const e = a[j++];
            null !== e && (0, _directiveHelpersJs.removePart)(e);
        }
        return this.ht = v, (0, _directiveHelpersJs.setCommittedValue)(s, m), _litHtmlJs.noChange;
    }
});

},{"../lit-html.js":"4A25t","../directive.js":"k6ssg","../directive-helpers.js":"40nzJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6ssg":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Directive", ()=>i);
parcelHelpers.export(exports, "PartType", ()=>t);
parcelHelpers.export(exports, "directive", ()=>e);
const t = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, e = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class i {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"40nzJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TemplateResultType", ()=>i);
parcelHelpers.export(exports, "clearPart", ()=>a);
parcelHelpers.export(exports, "getCommittedValue", ()=>m);
parcelHelpers.export(exports, "getDirectiveClass", ()=>v);
parcelHelpers.export(exports, "insertPart", ()=>r);
parcelHelpers.export(exports, "isDirectiveResult", ()=>d);
parcelHelpers.export(exports, "isPrimitive", ()=>t);
parcelHelpers.export(exports, "isSingleExpression", ()=>e);
parcelHelpers.export(exports, "isTemplateResult", ()=>n);
parcelHelpers.export(exports, "removePart", ()=>p);
parcelHelpers.export(exports, "setChildPartValue", ()=>u);
parcelHelpers.export(exports, "setCommittedValue", ()=>s);
var _litHtmlJs = require("./lit-html.js");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: l  } = (0, _litHtmlJs._$LH), t = (o)=>null === o || "object" != typeof o && "function" != typeof o, i = {
    HTML: 1,
    SVG: 2
}, n = (o, l)=>void 0 === l ? void 0 !== (null == o ? void 0 : o._$litType$) : (null == o ? void 0 : o._$litType$) === l, d = (o)=>void 0 !== (null == o ? void 0 : o._$litDirective$), v = (o)=>null == o ? void 0 : o._$litDirective$, e = (o)=>void 0 === o.strings, c = ()=>document.createComment(""), r = (o, t, i)=>{
    var n;
    const d = o._$AA.parentNode, v = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = d.insertBefore(c(), v), n = d.insertBefore(c(), v);
        i = new l(t, n, o, o.options);
    } else {
        const l = i._$AB.nextSibling, t = i._$AM, e = t !== o;
        if (e) {
            let l;
            null === (n = i._$AQ) || void 0 === n || n.call(i, o), i._$AM = o, void 0 !== i._$AP && (l = o._$AU) !== t._$AU && i._$AP(l);
        }
        if (l !== v || e) {
            let o = i._$AA;
            for(; o !== l;){
                const l = o.nextSibling;
                d.insertBefore(o, v), o = l;
            }
        }
    }
    return i;
}, u = (o, l, t = o)=>(o._$AI(l, t), o), f = {}, s = (o, l = f)=>o._$AH = l, m = (o)=>o._$AH, p = (o)=>{
    var l;
    null === (l = o._$AP) || void 0 === l || l.call(o, !1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, a = (o)=>{
    o._$AR();
};

},{"./lit-html.js":"4A25t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4uFa6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _whenJs = require("lit-html/directives/when.js");
parcelHelpers.exportAll(_whenJs, exports);

},{"lit-html/directives/when.js":"aH0jz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aH0jz":[function(require,module,exports) {
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "when", ()=>n);
function n(n, o, r) {
    return n ? o() : null == r ? void 0 : r();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lfgFh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
class ScrollContainer extends (0, _lit.LitElement) {
    static get is() {
        return "scroll-container";
    }
    static styles = (0, _lit.css)`
        :host {
            display: block;
            height: 100svh; height: 100%;
            overflow-y: hidden;
            background: black;
        }
        
        ::slotted(.section) {
            position: absolute;
            width: 100%;
            height: 100svh; height: 100%;
            transform: translateY(-100%);
            transition: transform 250ms ease-in-out;
            overflow: hidden;
        }

        ::slotted(.section.active) {
            transform: translateY(0%);
        }

        ::slotted(.section.hidden) {
            transform: translateY(100%);
        }
    `;
    connectedCallback() {
        super.connectedCallback();
        this.lastValues = [];
        this.timeoutId;
        this.lastTimestamp;
        this.lastTriggerTimestamp;
        const wheelHandler = (e)=>{
            if (this.lastTimestamp !== undefined && this.lastTriggerTimestamp !== undefined) {
                const deltaTriggerTimestamp = e.timeStamp - this.lastTriggerTimestamp;
                const deltaTimestamp = e.timeStamp - this.lastTimestamp;
                const absDeltaY = Math.abs(e.deltaY);
                const isTrendChanging = this.lastValues.every((val)=>absDeltaY - val > 10) && deltaTriggerTimestamp > 250;
                if (deltaTimestamp < 250 && !isTrendChanging) {
                    e.stopImmediatePropagation();
                    clearTimeout(this.timeoutId);
                    this.timeoutId = setTimeout(()=>{
                        this.lastValues = [];
                    }, 250);
                    this.lastTimestamp = e.timeStamp;
                    this.lastValues.push(absDeltaY);
                    if (this.lastValues.length > 10) this.lastValues.shift();
                    // console.log("ignore: ", e.deltaY);
                    return;
                }
            }
            this.lastTriggerTimestamp = e.timeStamp;
            this.lastTimestamp = e.timeStamp;
        };
        this.addEventListener("wheel", wheelHandler, {
            capture: true,
            passive: true
        });
    }
    render() {
        console.debug("scroll-container: render");
        return (0, _lit.html)`<slot @slotchange=${this.handleSlotchange}></slot>`;
    }
    handleSlotchange(e) {
        console.debug("handleSlotChange");
        const sections = e.target.assignedElements();
        sections.forEach((section, i)=>{
            section.style.zIndex = sections.length - 1 - i;
            if (i > 0) section.classList.add("hidden");
        });
    }
    getFirstSection() {
        const slot = this.shadowRoot.querySelector("slot");
        const sections = slot.assignedElements();
        return sections.reduce(function(a, b) {
            return a.style.zIndex > b.style.zIndex ? a : b;
        });
    }
    getNextSection(section, direction) {
        const slot = this.shadowRoot.querySelector("slot");
        const targetZIndex = Number(section.style.zIndex) - direction;
        const sections = slot.assignedElements();
        return sections.find((s)=>{
            return Number(s.style.zIndex) === targetZIndex;
        });
    }
    shift() {
        const firstSection = this.getFirstSection();
        firstSection.style.zIndex = -1;
        const slot = this.shadowRoot.querySelector("slot");
        const sections = slot.assignedElements();
        const activeZIndex = Number(this.activeSection.style.zIndex);
        sections.forEach((section)=>{
            section.style.zIndex++;
            if (Number(section.style.zIndex) <= activeZIndex) section.classList.add("hidden");
        });
    }
    createSection(innerHtml) {
        var section = document.createElement("div");
        section.className = "section";
        (0, _lit.render)(innerHtml, section);
        section.addEventListener("wheel", async (e)=>{
            const direction = Math.sign(e.deltaY);
            this.scrollToSection(section, direction);
        }, {
            passive: true
        });
        if (this.firstSectionReady === undefined) {
            this.firstSectionReady = true;
            section.classList.add("active");
            this.activeSection = section;
        }
        return section;
    }
    scrollToNextSection(direction) {
        this.scrollToSection(this.activeSection, direction);
    }
    scrollToSection(section, direction) {
        const nextSection = this.getNextSection(section, direction);
        if (nextSection === undefined || nextSection === null) {
            if (direction < 0) section.animate([
                {
                    transform: "translateY(0)"
                },
                {
                    transform: "translateY(10%)"
                },
                {
                    transform: "translateY(0)"
                }
            ], {
                duration: 250,
                easing: "ease-out"
            });
            return;
        }
        if (this.timeout !== undefined) {
            clearTimeout(this.timeout);
            this.timeout = undefined;
        }
        const createSectionEvent = (name)=>new CustomEvent(name, {
                detail: {
                    current: section,
                    target: nextSection,
                    direction: direction
                },
                bubbles: true,
                composed: true
            });
        section.addEventListener("transitionstart", ()=>this.dispatchEvent(createSectionEvent("sectionleave")), {
            once: true
        });
        section.addEventListener("transitionend", ()=>this.dispatchEvent(createSectionEvent("sectionenter")), {
            once: true
        });
        section.classList.remove("active");
        nextSection.classList.add("active");
        if (direction > 0) nextSection.classList.remove("hidden");
        else section.classList.add("hidden");
        this.activeSection = nextSection;
    }
}
exports.default = ScrollContainer;
customElements.define(ScrollContainer.is, ScrollContainer);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVgEq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _logo = require("../logo");
class LoadingAnimation extends (0, _lit.LitElement) {
    static get is() {
        return "loading-animation";
    }
    static styles = (0, _lit.css)`
        :host {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            z-index: 999999;
            height: 100%;
            width: 100%;
            background: rgba(0, 0, 0, .96);
            opacity: 1;
            transition: opacity 500ms ease-out;
        }

        :host(.hidden) {
            opacity: 0;
            pointer-events: none;
        }

        bd-logo {
            display: flex;
            fill: white;
            position: absolute;
            width: 40px;
            height: 40px;
            animation: logo-pulse .75s cubic-bezier(0, 0.2, 0.8, 1) infinite;
        }

        @keyframes logo-pulse {
            0% { transform: scale(1); }
            10% { transform: scale(.85); }
            100% { transform: scale(1); }
        }

        .ripple {
            position: absolute;
            width: 60px;
            height: 60px;
            box-sizing: border-box;
            border-radius: 50%;
            border: 3px solid white;
            filter: drop-shadow(0 0px 5px white);
            animation: ripple-pulse .75s ease-out infinite;
        }

        @keyframes ripple-pulse {
            0% {
                transform: scale(0.5);
                opacity: 0;
            }
            50% {
                opacity: 1;
            }
            100% {
                transform: scale(1.1);
                opacity: 0;
            }
        }

        ::slotted(*) {
            color: white;
            font-size: 12.5px;
            font-family: Montserrat;
            margin-top: 150px;
            opacity: 0.9;
        }
    `;
    render() {
        return (0, _lit.html)`
            <bd-logo></bd-logo>
            <div class="ripple"></div>
            <slot name="text"></slot>
        `;
    }
    hide() {
        this.classList.add("hidden");
    }
    show() {
        this.classList.remove("hidden");
    }
}
exports.default = LoadingAnimation;
customElements.define(LoadingAnimation.is, LoadingAnimation);

},{"lit":"aCmte","../logo":"eX4gb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eX4gb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
class Logo extends (0, _lit.LitElement) {
    static get is() {
        return "bd-logo";
    }
    static styles = (0, _lit.css)`
        :host {
        }

        svg {
            transform: scale(.75);
        }
    `;
    static logo = (0, _lit.svg)`
            <path d="M59.79,122.16c-1.85-3.99-4.11-7.35-6.78-10.06c-2.67-2.71-5.77-4.77-9.3-6.18c-3.53-1.41-7.46-2.11-11.79-2.11
                c-6.56,0-12.2,1.59-16.94,4.76c-4.73,3.18-8.34,7.79-10.82,13.84c-1.43,3.66-2.48,8.03-3.15,13.12C0.34,140.62,0,146.34,0,152.68
                c0,4.92,0.3,9.49,0.91,13.72c0.61,4.23,1.57,8.08,2.87,11.57c2.56,6.39,6.38,11.4,11.45,15.01c5.07,3.62,10.8,5.42,17.19,5.42
                c5.55,0,10.6-1.35,15.14-4.04c4.54-2.69,8.24-6.52,11.1-11.48c2.27-4.04,3.83-8.54,4.67-13.5c0.84-4.96,1.26-10.89,1.26-17.79
                C64.59,138.91,62.99,129.1,59.79,122.16L59.79,122.16z M45.98,170.03c-0.88,5-2.42,8.85-4.6,11.54c-2.19,2.69-5.21,4.04-9.08,4.04
                c-3.74,0-6.71-1.29-8.89-3.88c-2.19-2.59-3.74-6.4-4.67-11.45c-0.93-5.05-1.39-11.52-1.39-19.43c0-11.65,1.08-20.27,3.25-25.86
                c2.17-5.59,6.02-8.39,11.57-8.39c3.87,0,6.9,1.25,9.08,3.75c2.19,2.5,3.74,6.2,4.67,11.1c0.92,4.9,1.39,11.2,1.39,18.89
                C47.3,158.47,46.86,165.03,45.98,170.03z"/>
            <path d="M136.55,122.16c-1.85-3.99-4.11-7.35-6.78-10.06c-2.67-2.71-5.77-4.77-9.3-6.18c-3.53-1.41-7.46-2.11-11.79-2.11
                c-6.56,0-12.2,1.59-16.94,4.76c-4.73,3.18-8.34,7.79-10.82,13.84c-1.43,3.66-2.48,8.03-3.15,13.12c-0.67,5.09-1.01,10.81-1.01,17.16
                c0,4.92,0.3,9.49,0.91,13.72c0.61,4.23,1.57,8.08,2.87,11.57c2.56,6.39,6.38,11.4,11.45,15.01c5.07,3.62,10.8,5.42,17.19,5.42
                c5.55,0,10.6-1.35,15.14-4.04c4.54-2.69,8.24-6.52,11.1-11.48c2.27-4.04,3.83-8.54,4.67-13.5c0.84-4.96,1.26-10.89,1.26-17.79
                C141.35,138.91,139.75,129.1,136.55,122.16L136.55,122.16z M122.74,170.03c-0.88,5-2.42,8.85-4.6,11.54
                c-2.19,2.69-5.21,4.04-9.08,4.04c-3.74,0-6.71-1.29-8.89-3.88c-2.19-2.59-3.74-6.4-4.67-11.45c-0.93-5.05-1.39-11.52-1.39-19.43
                c0-11.65,1.08-20.27,3.25-25.86c2.17-5.59,6.02-8.39,11.57-8.39c3.87,0,6.9,1.25,9.08,3.75c2.19,2.5,3.74,6.2,4.67,11.1
                c0.92,4.9,1.39,11.2,1.39,18.89C124.06,158.47,123.62,165.03,122.74,170.03z"/>
            <path d="M213.31,122.16c-1.85-3.99-4.11-7.35-6.78-10.06c-2.67-2.71-5.77-4.77-9.3-6.18c-3.53-1.41-7.46-2.11-11.79-2.11
                c-6.56,0-12.2,1.59-16.94,4.76c-4.73,3.18-8.34,7.79-10.82,13.84c-1.43,3.66-2.48,8.03-3.15,13.12c-0.67,5.09-1.01,10.81-1.01,17.16
                c0,4.92,0.3,9.49,0.91,13.72c0.61,4.23,1.57,8.08,2.87,11.57c2.56,6.39,6.38,11.4,11.45,15.01c5.07,3.62,10.8,5.42,17.19,5.42
                c5.55,0,10.6-1.35,15.14-4.04c4.54-2.69,8.24-6.52,11.1-11.48c2.27-4.04,3.83-8.54,4.67-13.5c0.84-4.96,1.26-10.89,1.26-17.79
                C218.11,138.91,216.51,129.1,213.31,122.16L213.31,122.16z M199.5,170.03c-0.88,5-2.42,8.85-4.6,11.54
                c-2.19,2.69-5.21,4.04-9.08,4.04c-3.74,0-6.71-1.29-8.89-3.88c-2.19-2.59-3.74-6.4-4.67-11.45c-0.93-5.05-1.39-11.52-1.39-19.43
                c0-11.65,1.08-20.27,3.25-25.86c2.17-5.59,6.02-8.39,11.57-8.39c3.87,0,6.9,1.25,9.08,3.75c2.19,2.5,3.74,6.2,4.67,11.1
                c0.92,4.9,1.39,11.2,1.39,18.89C200.82,158.47,200.38,165.03,199.5,170.03z"/>
            <path d="M290.07,122.16c-1.85-3.99-4.11-7.35-6.78-10.06c-2.67-2.71-5.77-4.77-9.3-6.18c-3.53-1.41-7.46-2.11-11.79-2.11
                c-6.56,0-12.2,1.59-16.94,4.76c-4.73,3.18-8.34,7.79-10.82,13.84c-1.43,3.66-2.48,8.03-3.15,13.12c-0.67,5.09-1.01,10.81-1.01,17.16
                c0,4.92,0.3,9.49,0.91,13.72c0.61,4.23,1.57,8.08,2.87,11.57c2.56,6.39,6.38,11.4,11.45,15.01c5.07,3.62,10.8,5.42,17.19,5.42
                c5.55,0,10.6-1.35,15.14-4.04c4.54-2.69,8.24-6.52,11.1-11.48c2.27-4.04,3.83-8.54,4.67-13.5c0.84-4.96,1.26-10.89,1.26-17.79
                C294.87,138.91,293.27,129.1,290.07,122.16L290.07,122.16z M276.26,170.03c-0.88,5-2.42,8.85-4.6,11.54
                c-2.19,2.69-5.21,4.04-9.08,4.04c-3.74,0-6.71-1.29-8.89-3.88c-2.19-2.59-3.74-6.4-4.67-11.45c-0.93-5.05-1.39-11.52-1.39-19.43
                c0-11.65,1.08-20.27,3.25-25.86c2.17-5.59,6.02-8.39,11.57-8.39c3.87,0,6.9,1.25,9.08,3.75c2.19,2.5,3.74,6.2,4.67,11.1
                c0.92,4.9,1.39,11.2,1.39,18.89C277.58,158.47,277.14,165.03,276.26,170.03z"/>
            <path d="M60.67,61.49c-3.46,3.12-5.19,7.25-5.19,12.4c0,11.56,8.48,17.33,25.43,17.33h144.87c6.07,0,10.84-1.35,14.3-4.05
                c3.46-2.7,5.19-6.28,5.19-10.75c0-3.97-0.76-6.66-2.28-8.1c-1.52-1.44-5.57-4.51-12.15-9.24c-6.58-4.72-12.53-10.14-17.84-16.26
                c-5.31-6.12-10.38-14.28-15.18-24.48c-3.21-6.83-5.82-11.6-7.84-14.3c-2.02-2.7-5.19-4.05-9.49-4.05c-3.71,0-6.98,1.37-9.81,4.11
                c-2.83,2.74-4.24,5.88-4.24,9.43c0,7.42,8.22,21.85,24.67,43.27H75.98C69.23,56.81,64.13,58.37,60.67,61.49z"/>
        `;
    render() {
        return (0, _lit.html)`
            <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"
	              x="0px" y="0px" viewBox="0 0 294.87 198.41">
                ${Logo.logo}
            </svg>
        `;
    }
}
exports.default = Logo;
customElements.define(Logo.is, Logo);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5fFp0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _task = require("@lit/task");
var _plyr = require("plyr");
var _plyrDefault = parcelHelpers.interopDefault(_plyr);
var _plyrCss = require("plyr/dist/plyr.css");
var _plyrCssDefault = parcelHelpers.interopDefault(_plyrCss);
var _plyrCustomCss = require("../../css/plyr_custom.css");
var _plyrCustomCssDefault = parcelHelpers.interopDefault(_plyrCustomCss);
var _loadingAnimation = require("./loading-animation");
var _loadingAnimationDefault = parcelHelpers.interopDefault(_loadingAnimation);
var _logo = require("../logo");
var _icons = require("../icons");
class VideoPlayer extends (0, _lit.LitElement) {
    static get is() {
        return "video-player";
    }
    static styles = [
        (0, _plyrCssDefault.default),
        (0, _plyrCustomCssDefault.default)
    ];
    static properties = {
        playerId: {
            type: String
        },
        videoid: {
            type: String,
            reflect: true
        },
        origin: {
            type: String
        },
        liked: {
            type: Boolean,
            reflect: true
        },
        saved: {
            type: Boolean,
            reflect: true
        }
    };
    _fetchVideoInfoTask = new (0, _task.Task)(this, {
        args: ()=>[
                this.videoid
            ],
        task: async ([videoid], { signal  })=>{
            const response = await fetch(`https://www.youtube.com/oembed?url=http://www.youtube.com/watch?v=${videoid}&format=json`, {
                signal
            });
            if (!response.ok) throw new Error(response.status);
            return await response.json();
        }
    });
    createRenderRoot() {
        return this;
    }
    renderDebugInfo() {
        return (0, _lit.html)`
            <span style="z-index: 999;display: flex;position: absolute;color: white;margin: 10px;font-size: 3em;top: 50%;background-color: black;">
                ${this.playerId}: ${this.state}
            </span>`;
    }
    renderTitle() {
        return this._fetchVideoInfoTask.render({
            complete: (videoInfo)=>(0, _lit.html)`
                <span>${videoInfo.title}</span>
                <span style="font-variant: all-small-caps;">${videoInfo.author_name}</span>
            `
        });
    }
    render() {
        console.debug(`video-player: '${this.playerId}' render`);
        return (0, _lit.html)`
            <loading-animation></loading-animation>
            <div class="title-bar">
                <div class="card">
                    <bd-logo></bd-logo>
                    <div class="title-text">
                        ${this.renderTitle()}
                    </div>
                </div>
            </div>
            <div class="user-interactions">
                <heart-icon @click=${this.toggleLike}></heart-icon>
                <!-- <speech-bubble-icon></speech-bubble-icon> -->
                <paper-plane-icon @click=${this.share}></paper-plane-icon>
                <bookmark-icon @click=${this.save}></bookmark-icon>
            </div>
            <div class="plyr__video-embed" id="plyr__${this.playerId}">
                <iframe
                    src="https://www.youtube.com/embed/${this.videoid}?origin=${this.origin}&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1"
                    allowfullscreen
                    allowtransparency
                    allow="autoplay">
                </iframe>
            </div>
        `;
    }
    async firstUpdated() {
        super.firstUpdated();
        this.loadingAnimation = this.renderRoot.querySelector((0, _loadingAnimationDefault.default).is);
        this._plyr = new (0, _plyrDefault.default)(`#plyr__${this.playerId} `, {
            autoplay: true,
            autopause: false,
            playsinline: true,
            clickToPlay: false,
            resetOnEnd: true,
            invertTime: false,
            hideControls: false,
            keyboard: {
                focused: false,
                global: false
            },
            controls: [
                "play-large",
                "progress",
                "current-time",
                "settings"
            ],
            fullscreen: {
                enabled: true,
                fallback: true,
                iosNative: false,
                container: "scroll-container"
            } // TODO: use lit context for container
        });
        this._plyr.once("ready", (e)=>{
            const embed = e.detail.plyr.embed;
            embed.addEventListener("onError", this.handleVideoError);
            embed.addEventListener("onStateChange", (e)=>{
                this.state = e.data;
                this.dispatchEvent(new CustomEvent(e.data, {
                    e,
                    bubbles: false,
                    composed: false
                }));
            });
            this.hideControls();
            this._plyr.toggleCaptions(false);
            this.state = embed.getPlayerState();
            this.handleVideoLoad(this.state);
            this.dispatchEvent(new CustomEvent("playerready", {
                detail: {
                    promise: Promise.resolve(this)
                },
                bubbles: true,
                composed: true
            }));
        });
    }
    handleVideoError = ()=>{
        console.log(`video-player: '${this.playerId}' error`);
        this.classList.add("unavailable");
        this.dispatchEvent(new CustomEvent("videoready", {
            detail: {
                promise: Promise.reject(this)
            },
            bubbles: true,
            composed: true
        }));
    };
    handleVideoEnable = ()=>{
        console.log(`video-player: '${this.playerId}' handleVideoEnable`);
        this.addEventListener("2", ()=>this._plyr.embed.unMute(), {
            once: true
        });
        this._plyr.embed.pauseVideo();
    };
    handleVideoLoad = (state)=>{
        this.loadingAnimation.hide();
        console.log(`video-player: '${this.playerId}' handleVideoLoad: ${state}`);
        if (state === -1) {
            // loading error
            this.handleVideoError();
            return;
        }
        this.addEventListener("1", this.handleVideoAutoplay, {
            once: true
        });
        this._plyr.embed.mute();
        this.classList.add("unstarted");
        this.dispatchEvent(new CustomEvent("videoready", {
            detail: {
                promise: Promise.resolve(this)
            },
            bubbles: true,
            composed: true
        }));
    };
    handleVideoAutoplay = ()=>{
        console.log(`video-player: '${this.playerId}' handleVideoAutoplay`);
        if (!this.playRequest) {
            this.addEventListener("2", ()=>{
                this._plyr.embed.unMute();
                this.addEventListener("1", ()=>{
                    if (this.playRequest) this.handleVideoFirstPlay();
                }, {
                    once: true
                });
                this.requestUpdate();
            }, {
                once: true
            });
            this._plyr.embed.pauseVideo();
            return;
        }
        this.playRequest = false;
        this._plyr.embed.unMute();
        this.handleVideoFirstPlay();
    };
    handleVideoFirstPlay = ()=>{
        this.classList.remove("unstarted");
    };
    load(videoId, liked, saved) {
        console.debug(`video-player: '${this.playerId}' load: ` + videoId);
        this._plyr.once("statechange", (e)=>this.handleVideoLoad(e.detail.code));
        this._plyr.embed.loadVideoById({
            videoId: videoId,
            startSeconds: 0
        });
        // const url = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
        // const fallBackUrl = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
        // this._plyr.poster = fallBackUrl;
        this.classList.remove(...this.classList);
        this.loadingAnimation.show();
        this.hideControls();
        // triggers render
        this.videoid = videoId;
        this.liked = liked;
        this.saved = saved;
    }
    enable(allowAutoplay) {
        if (!allowAutoplay && this.state === 2) {
            // 2 -> handleVideoAutoplay has already been triggered once
            this._plyr.embed.mute();
            this.addEventListener("1", this.handleVideoEnable, {
                once: true
            });
        }
        this.lastTouch = 0;
        this._plyr.on("touchstart", ()=>{
            this.touchPressed = false;
            this.touchTimer = setTimeout(()=>{
                this.pause();
                this.showControls();
                this.touchPressed = true;
                if (this.controlsTimer !== undefined) clearTimeout(this.controlsTimer);
            }, 150);
        });
        this._plyr.on("touchend", ()=>{
            const ticks = new Date().getTime();
            const touchDelta = ticks - this.lastTouch;
            this.lastTouch = ticks;
            if (this.touchPressed) {
                this.play();
                this.controlsTimer = setTimeout(()=>this.hideControls(), 2000);
            } else if (touchDelta > 0 && touchDelta < 250) {
                this.like();
                this.showControls();
                this.controlsTimer = setTimeout(()=>this.hideControls(), 2000);
            } else {
                this.toggleControls();
                if (this.controlsTimer !== undefined) clearTimeout(this.controlsTimer);
            }
            this.touchPressed = false;
            clearTimeout(this.touchTimer);
            this.touchTimer = undefined;
        });
        this.playRequest = allowAutoplay;
        this._plyr.play();
    }
    play() {
        this.playRequest = true;
        this._plyr.play();
    }
    pause() {
        this.playRequest = false;
        this._plyr.pause();
    }
    stop() {
        this._plyr.stop();
    }
    isPlaying() {
        return this._plyr.playing;
    }
    isPaused() {
        return this._plyr.paused;
    }
    isStopped() {
        return this._plyr.stopped;
    }
    forward() {
        this._plyr.forward();
    }
    rewind() {
        this._plyr.rewind();
    }
    toggleControls() {
        if (this.classList.contains("hide-controls")) this.showControls();
        else this.hideControls();
    }
    hideControls() {
        this.classList.add("hide-controls");
        this._plyr.toggleControls(false);
    }
    showControls() {
        this.classList.remove("hide-controls");
        this._plyr.toggleControls(true);
    }
    toggleLike = ()=>{
        this.liked = !this.liked;
        this.dispatchEvent(new CustomEvent("like", {
            detail: {
                id: this.videoid,
                state: this.liked
            },
            bubbles: true,
            composed: true
        }));
    };
    like = ()=>{
        this.liked = true;
        this.dispatchEvent(new CustomEvent("like", {
            detail: {
                id: this.videoid,
                state: this.liked
            },
            bubbles: true,
            composed: true
        }));
    };
    save() {
        this.saved = !this.saved;
        this.dispatchEvent(new CustomEvent("save", {
            detail: {
                id: this.videoid,
                state: this.saved
            },
            bubbles: true,
            composed: true
        }));
    }
    share = async ()=>{
        const targetUrl = `${this.origin}/${this.videoid}`;
        if (navigator.vibrate) navigator.vibrate(50);
        if (!navigator.canShare) {
            prompt("\uD83D\uDCBE Copy following URL and share it with a friend!", targetUrl);
            return;
        }
        const shareData = {
            title: "\uD83D\uDCBE BLADING DATA",
            text: "Share the love!",
            url: targetUrl
        };
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error(err);
        }
    };
}
exports.default = VideoPlayer;
customElements.define(VideoPlayer.is, VideoPlayer);

},{"lit":"aCmte","@lit/task":"7kxr3","plyr":"5TiTQ","plyr/dist/plyr.css":"h07GF","../../css/plyr_custom.css":"2dM5c","./loading-animation":"jVgEq","../logo":"eX4gb","../icons":"7gnwH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7kxr3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Task", ()=>(0, _taskJs.Task));
parcelHelpers.export(exports, "TaskStatus", ()=>(0, _taskJs.TaskStatus));
parcelHelpers.export(exports, "initialState", ()=>(0, _taskJs.initialState));
parcelHelpers.export(exports, "shallowArrayEquals", ()=>(0, _taskJs.shallowArrayEquals));
var _taskJs = require("./task.js");

},{"./task.js":"8vPd2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8vPd2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Task", ()=>h);
parcelHelpers.export(exports, "TaskStatus", ()=>s);
parcelHelpers.export(exports, "initialState", ()=>i);
parcelHelpers.export(exports, "shallowArrayEquals", ()=>r);
var _reactiveElement = require("@lit/reactive-element");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const s = {
    INITIAL: 0,
    PENDING: 1,
    COMPLETE: 2,
    ERROR: 3
}, i = Symbol();
class h {
    get taskComplete() {
        return this.t || (1 === this.status ? this.t = new Promise((t, s)=>{
            this.i = t, this.o = s;
        }) : 3 === this.status ? this.t = Promise.reject(this.h) : this.t = Promise.resolve(this.l)), this.t;
    }
    constructor(t, s, i){
        this.u = 0, this.status = 0, (this.p = t).addController(this);
        const h = "object" == typeof s ? s : {
            task: s,
            args: i
        };
        this._ = h.task, this.v = h.args, this.j = h.argsEqual ?? r, this.m = h.onComplete, this.g = h.onError, this.autoRun = h.autoRun ?? !0, "initialValue" in h && (this.l = h.initialValue, this.status = 2, this.k = this.A?.());
    }
    hostUpdate() {
        !0 === this.autoRun && this.O();
    }
    hostUpdated() {
        "afterUpdate" === this.autoRun && this.O();
    }
    A() {
        if (void 0 === this.v) return;
        const t = this.v();
        if (!Array.isArray(t)) throw Error("The args function must return an array");
        return t;
    }
    async O() {
        const t = this.A(), s = this.k;
        this.k = t, t === s || void 0 === t || void 0 !== s && this.j(s, t) || await this.run(t);
    }
    async run(t) {
        let s, h;
        t ??= this.A(), this.k = t, 1 === this.status ? this.T?.abort() : (this.t = void 0, this.i = void 0, this.o = void 0), this.status = 1, "afterUpdate" === this.autoRun ? queueMicrotask(()=>this.p.requestUpdate()) : this.p.requestUpdate();
        const r = ++this.u;
        this.T = new AbortController;
        let e = !1;
        try {
            s = await this._(t, {
                signal: this.T.signal
            });
        } catch (t) {
            e = !0, h = t;
        }
        if (this.u === r) {
            if (s === i) this.status = 0;
            else {
                if (!1 === e) {
                    try {
                        this.m?.(s);
                    } catch  {}
                    this.status = 2, this.i?.(s);
                } else {
                    try {
                        this.g?.(h);
                    } catch  {}
                    this.status = 3, this.o?.(h);
                }
                this.l = s, this.h = h;
            }
            this.p.requestUpdate();
        }
    }
    abort(t) {
        1 === this.status && this.T?.abort(t);
    }
    get value() {
        return this.l;
    }
    get error() {
        return this.h;
    }
    render(t) {
        switch(this.status){
            case 0:
                return t.initial?.();
            case 1:
                return t.pending?.();
            case 2:
                return t.complete?.(this.value);
            case 3:
                return t.error?.(this.error);
            default:
                throw Error("Unexpected status: " + this.status);
        }
    }
}
const r = (s, i)=>s === i || s.length === i.length && s.every((s, h)=>!(0, _reactiveElement.notEqual)(s, i[h]));

},{"@lit/reactive-element":"hUcCl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5TiTQ":[function(require,module,exports) {
var global = arguments[3];
"object" == typeof navigator && function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    function e(e, t, i) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var s = i.call(e, t || "default");
                    if ("object" != typeof s) return s;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === t ? String : Number)(e);
            }(e, "string");
            return "symbol" == typeof t ? t : String(t);
        }(t)) in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function t(e, t) {
        for(var i = 0; i < t.length; i++){
            var s = t[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
        }
    }
    function i(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function s(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t && (s = s.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), i.push.apply(i, s);
        }
        return i;
    }
    function n(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function(t) {
                i(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var a = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    var l = function(e) {
        return null != e ? e.constructor : null;
    }, r = function(e, t) {
        return !!(e && t && e instanceof t);
    }, o = function(e) {
        return null == e;
    }, c = function(e) {
        return l(e) === Object;
    }, u = function(e) {
        return l(e) === String;
    }, h = function(e) {
        return Array.isArray(e);
    }, d = function(e) {
        return r(e, NodeList);
    }, m = {
        nullOrUndefined: o,
        object: c,
        number: function(e) {
            return l(e) === Number && !Number.isNaN(e);
        },
        string: u,
        boolean: function(e) {
            return l(e) === Boolean;
        },
        function: function(e) {
            return l(e) === Function;
        },
        array: h,
        nodeList: d,
        element: function(e) {
            return r(e, Element);
        },
        event: function(e) {
            return r(e, Event);
        },
        empty: function(e) {
            return o(e) || (u(e) || h(e) || d(e)) && !e.length || c(e) && !Object.keys(e).length;
        }
    };
    function p(e, t) {
        if (1 > t) {
            var i = function(e) {
                var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
            }(t);
            return parseFloat(e.toFixed(i));
        }
        return Math.round(e / t) * t;
    }
    var g = function() {
        function e(t, i) {
            (function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e), m.element(t) ? this.element = t : m.string(t) && (this.element = document.querySelector(t)), m.element(this.element) && m.empty(this.element.rangeTouch) && (this.config = n({}, a, {}, i), this.init());
        }
        return function(e, i, s) {
            i && t(e.prototype, i), s && t(e, s);
        }(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, i = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[i](e, function(e) {
                            return t.set(e);
                        }, !1);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !m.event(t)) return null;
                    var i, s = t.target, n = t.changedTouches[0], a = parseFloat(s.getAttribute("min")) || 0, l = parseFloat(s.getAttribute("max")) || 100, r = parseFloat(s.getAttribute("step")) || 1, o = s.getBoundingClientRect(), c = 100 / o.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (i = 100 / o.width * (n.clientX - o.left)) ? i = 0 : 100 < i && (i = 100), 50 > i ? i -= (100 - 2 * i) * c : 50 < i && (i += 2 * (i - 50) * c), a + p(i / 100 * (l - a), r);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && m.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), function(e, t) {
                        if (e && t) {
                            var i = new Event(t, {
                                bubbles: !0
                            });
                            e.dispatchEvent(i);
                        }
                    }(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, s = null;
                    if (m.empty(t) || m.string(t) ? s = Array.from(document.querySelectorAll(m.string(t) ? t : 'input[type="range"]')) : m.element(t) ? s = [
                        t
                    ] : m.nodeList(t) ? s = Array.from(t) : m.array(t) && (s = t.filter(m.element)), m.empty(s)) return null;
                    var l = n({}, a, {}, i);
                    if (m.string(t) && l.watch) {
                        var r = new MutationObserver(function(i) {
                            Array.from(i).forEach(function(i) {
                                Array.from(i.addedNodes).forEach(function(i) {
                                    m.element(i) && function(e, t) {
                                        return (function() {
                                            return Array.from(document.querySelectorAll(t)).includes(this);
                                        }).call(e, t);
                                    }(i, t) && new e(i, l);
                                });
                            });
                        });
                        r.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    }
                    return s.map(function(t) {
                        return new e(t, i);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    const f = (e)=>null != e ? e.constructor : null, y = (e, t)=>Boolean(e && t && e instanceof t), b = (e)=>null == e, v = (e)=>f(e) === Object, w = (e)=>f(e) === String, T = (e)=>"function" == typeof e, k = (e)=>Array.isArray(e), C = (e)=>y(e, NodeList), A = (e)=>b(e) || (w(e) || k(e) || C(e)) && !e.length || v(e) && !Object.keys(e).length;
    var S = {
        nullOrUndefined: b,
        object: v,
        number: (e)=>f(e) === Number && !Number.isNaN(e),
        string: w,
        boolean: (e)=>f(e) === Boolean,
        function: T,
        array: k,
        weakMap: (e)=>y(e, WeakMap),
        nodeList: C,
        element: (e)=>null !== e && "object" == typeof e && 1 === e.nodeType && "object" == typeof e.style && "object" == typeof e.ownerDocument,
        textNode: (e)=>f(e) === Text,
        event: (e)=>y(e, Event),
        keyboardEvent: (e)=>y(e, KeyboardEvent),
        cue: (e)=>y(e, window.TextTrackCue) || y(e, window.VTTCue),
        track: (e)=>y(e, TextTrack) || !b(e) && w(e.kind),
        promise: (e)=>y(e, Promise) && T(e.then),
        url: (e)=>{
            if (y(e, window.URL)) return !0;
            if (!w(e)) return !1;
            let t = e;
            e.startsWith("http://") && e.startsWith("https://") || (t = `http://${e}`);
            try {
                return !A(new URL(t).hostname);
            } catch (e) {
                return !1;
            }
        },
        empty: A
    };
    const E = (()=>{
        const e = document.createElement("span"), t = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        }, i = Object.keys(t).find((t)=>void 0 !== e.style[t]);
        return !!S.string(i) && t[i];
    })();
    function P(e, t) {
        setTimeout(()=>{
            try {
                e.hidden = !0, e.offsetHeight, e.hidden = !1;
            } catch (e) {}
        }, t);
    }
    var M = {
        isIE: Boolean(window.document.documentMode),
        isEdge: /Edge/g.test(navigator.userAgent),
        isWebKit: "WebkitAppearance" in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
        isIPhone: /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
        isIPadOS: "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1,
        isIos: /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1
    };
    function N(e, t) {
        return t.split(".").reduce((e, t)=>e && e[t], e);
    }
    function x(e = {}, ...t) {
        if (!t.length) return e;
        const i = t.shift();
        return S.object(i) ? (Object.keys(i).forEach((t)=>{
            S.object(i[t]) ? (Object.keys(e).includes(t) || Object.assign(e, {
                [t]: {}
            }), x(e[t], i[t])) : Object.assign(e, {
                [t]: i[t]
            });
        }), x(e, ...t)) : e;
    }
    function L(e, t) {
        const i = e.length ? e : [
            e
        ];
        Array.from(i).reverse().forEach((e, i)=>{
            const s = i > 0 ? t.cloneNode(!0) : t, n = e.parentNode, a = e.nextSibling;
            s.appendChild(e), a ? n.insertBefore(s, a) : n.appendChild(s);
        });
    }
    function I(e, t) {
        S.element(e) && !S.empty(t) && Object.entries(t).filter(([, e])=>!S.nullOrUndefined(e)).forEach(([t, i])=>e.setAttribute(t, i));
    }
    function $(e, t, i) {
        const s = document.createElement(e);
        return S.object(t) && I(s, t), S.string(i) && (s.innerText = i), s;
    }
    function _(e, t, i, s) {
        S.element(t) && t.appendChild($(e, i, s));
    }
    function O(e) {
        S.nodeList(e) || S.array(e) ? Array.from(e).forEach(O) : S.element(e) && S.element(e.parentNode) && e.parentNode.removeChild(e);
    }
    function j(e) {
        if (!S.element(e)) return;
        let { length: t  } = e.childNodes;
        for(; t > 0;)e.removeChild(e.lastChild), t -= 1;
    }
    function q(e, t) {
        return S.element(t) && S.element(t.parentNode) && S.element(e) ? (t.parentNode.replaceChild(e, t), e) : null;
    }
    function D(e, t) {
        if (!S.string(e) || S.empty(e)) return {};
        const i = {}, s = x({}, t);
        return e.split(",").forEach((e)=>{
            const t = e.trim(), n = t.replace(".", ""), a = t.replace(/[[\]]/g, "").split("="), [l] = a, r = a.length > 1 ? a[1].replace(/["']/g, "") : "";
            switch(t.charAt(0)){
                case ".":
                    S.string(s.class) ? i.class = `${s.class} ${n}` : i.class = n;
                    break;
                case "#":
                    i.id = t.replace("#", "");
                    break;
                case "[":
                    i[l] = r;
            }
        }), x(s, i);
    }
    function H(e, t) {
        if (!S.element(e)) return;
        let i = t;
        S.boolean(i) || (i = !e.hidden), e.hidden = i;
    }
    function R(e, t, i) {
        if (S.nodeList(e)) return Array.from(e).map((e)=>R(e, t, i));
        if (S.element(e)) {
            let s = "toggle";
            return void 0 !== i && (s = i ? "add" : "remove"), e.classList[s](t), e.classList.contains(t);
        }
        return !1;
    }
    function F(e, t) {
        return S.element(e) && e.classList.contains(t);
    }
    function V(e, t) {
        const { prototype: i  } = Element;
        return (i.matches || i.webkitMatchesSelector || i.mozMatchesSelector || i.msMatchesSelector || function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function U(e) {
        return this.elements.container.querySelectorAll(e);
    }
    function B(e) {
        return this.elements.container.querySelector(e);
    }
    function W(e = null, t = !1) {
        S.element(e) && e.focus({
            preventScroll: !0,
            focusVisible: t
        });
    }
    const z = {
        "audio/ogg": "vorbis",
        "audio/wav": "1",
        "video/webm": "vp8, vorbis",
        "video/mp4": "avc1.42E01E, mp4a.40.2",
        "video/ogg": "theora"
    }, K = {
        audio: "canPlayType" in document.createElement("audio"),
        video: "canPlayType" in document.createElement("video"),
        check (e, t) {
            const i = K[e] || "html5" !== t;
            return {
                api: i,
                ui: i && K.rangeInput
            };
        },
        pip: !(M.isIPhone || !S.function($("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || $("video").disablePictureInPicture)),
        airplay: S.function(window.WebKitPlaybackTargetAvailabilityEvent),
        playsinline: "playsInline" in document.createElement("video"),
        mime (e) {
            if (S.empty(e)) return !1;
            const [t] = e.split("/");
            let i = e;
            if (!this.isHTML5 || t !== this.type) return !1;
            Object.keys(z).includes(i) && (i += `; codecs="${z[e]}"`);
            try {
                return Boolean(i && this.media.canPlayType(i).replace(/no/, ""));
            } catch (e) {
                return !1;
            }
        },
        textTracks: "textTracks" in document.createElement("video"),
        rangeInput: (()=>{
            const e = document.createElement("input");
            return e.type = "range", "range" === e.type;
        })(),
        touch: "ontouchstart" in document.documentElement,
        transitions: !1 !== E,
        reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
    }, Y = (()=>{
        let e = !1;
        try {
            const t = Object.defineProperty({}, "passive", {
                get: ()=>(e = !0, null)
            });
            window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
        } catch (e) {}
        return e;
    })();
    function Q(e, t, i, s = !1, n = !0, a = !1) {
        if (!e || !("addEventListener" in e) || S.empty(t) || !S.function(i)) return;
        const l = t.split(" ");
        let r = a;
        Y && (r = {
            passive: n,
            capture: a
        }), l.forEach((t)=>{
            this && this.eventListeners && s && this.eventListeners.push({
                element: e,
                type: t,
                callback: i,
                options: r
            }), e[s ? "addEventListener" : "removeEventListener"](t, i, r);
        });
    }
    function X(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !0, s, n);
    }
    function J(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !1, s, n);
    }
    function G(e, t = "", i, s = !0, n = !1) {
        const a = (...l)=>{
            J(e, t, a, s, n), i.apply(this, l);
        };
        Q.call(this, e, t, a, !0, s, n);
    }
    function Z(e, t = "", i = !1, s = {}) {
        if (!S.element(e) || S.empty(t)) return;
        const n = new CustomEvent(t, {
            bubbles: i,
            detail: {
                ...s,
                plyr: this
            }
        });
        e.dispatchEvent(n);
    }
    function ee() {
        this && this.eventListeners && (this.eventListeners.forEach((e)=>{
            const { element: t , type: i , callback: s , options: n  } = e;
            t.removeEventListener(i, s, n);
        }), this.eventListeners = []);
    }
    function te() {
        return new Promise((e)=>this.ready ? setTimeout(e, 0) : X.call(this, this.elements.container, "ready", e)).then(()=>{});
    }
    function ie(e) {
        S.promise(e) && e.then(null, ()=>{});
    }
    function se(e) {
        return S.array(e) ? e.filter((t, i)=>e.indexOf(t) === i) : e;
    }
    function ne(e, t) {
        return S.array(e) && e.length ? e.reduce((e, i)=>Math.abs(i - t) < Math.abs(e - t) ? i : e) : null;
    }
    function ae(e) {
        return !(!window || !window.CSS) && window.CSS.supports(e);
    }
    const le = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((e, [t, i])=>({
            ...e,
            [t / i]: [
                t,
                i
            ]
        }), {});
    function re(e) {
        if (!(S.array(e) || S.string(e) && e.includes(":"))) return !1;
        return (S.array(e) ? e : e.split(":")).map(Number).every(S.number);
    }
    function oe(e) {
        if (!S.array(e) || !e.every(S.number)) return null;
        const [t, i] = e, s = (e, t)=>0 === t ? e : s(t, e % t), n = s(t, i);
        return [
            t / n,
            i / n
        ];
    }
    function ce(e) {
        const t = (e)=>re(e) ? e.split(":").map(Number) : null;
        let i = t(e);
        if (null === i && (i = t(this.config.ratio)), null === i && !S.empty(this.embed) && S.array(this.embed.ratio) && ({ ratio: i  } = this.embed), null === i && this.isHTML5) {
            const { videoWidth: e , videoHeight: t  } = this.media;
            i = [
                e,
                t
            ];
        }
        return oe(i);
    }
    function ue(e) {
        if (!this.isVideo) return {};
        const { wrapper: t  } = this.elements, i = ce.call(this, e);
        if (!S.array(i)) return {};
        const [s, n] = oe(i), a = 100 / s * n;
        if (ae(`aspect-ratio: ${s}/${n}`) ? t.style.aspectRatio = `${s}/${n}` : t.style.paddingBottom = `${a}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const e = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10), i = (e - a) / (e / 50);
            this.fullscreen.active ? t.style.paddingBottom = null : this.media.style.transform = `translateY(-${i}%)`;
        } else this.isHTML5 && t.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: a,
            ratio: i
        };
    }
    function he(e, t, i = .05) {
        const s = e / t, n = ne(Object.keys(le), s);
        return Math.abs(n - s) <= i ? le[n] : [
            e,
            t
        ];
    }
    const de = {
        getSources () {
            if (!this.isHTML5) return [];
            return Array.from(this.media.querySelectorAll("source")).filter((e)=>{
                const t = e.getAttribute("type");
                return !!S.empty(t) || K.mime.call(this, t);
            });
        },
        getQualityOptions () {
            return this.config.quality.forced ? this.config.quality.options : de.getSources.call(this).map((e)=>Number(e.getAttribute("size"))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const e = this;
            e.options.speed = e.config.speed.options, S.empty(this.config.ratio) || ue.call(e), Object.defineProperty(e.media, "quality", {
                get () {
                    const t = de.getSources.call(e).find((t)=>t.getAttribute("src") === e.source);
                    return t && Number(t.getAttribute("size"));
                },
                set (t) {
                    if (e.quality !== t) {
                        if (e.config.quality.forced && S.function(e.config.quality.onChange)) e.config.quality.onChange(t);
                        else {
                            const i = de.getSources.call(e).find((e)=>Number(e.getAttribute("size")) === t);
                            if (!i) return;
                            const { currentTime: s , paused: n , preload: a , readyState: l , playbackRate: r  } = e.media;
                            e.media.src = i.getAttribute("src"), ("none" !== a || l) && (e.once("loadedmetadata", ()=>{
                                e.speed = r, e.currentTime = s, n || ie(e.play());
                            }), e.media.load());
                        }
                        Z.call(e, e.media, "qualitychange", !1, {
                            quality: t
                        });
                    }
                }
            });
        },
        cancelRequests () {
            this.isHTML5 && (O(de.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
        }
    };
    function me(e, ...t) {
        return S.empty(e) ? e : e.toString().replace(/{(\d+)}/g, (e, i)=>t[i].toString());
    }
    const pe = (e = "", t = "", i = "")=>e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i.toString()), ge = (e = "")=>e.toString().replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.slice(1).toLowerCase());
    function fe(e = "") {
        let t = e.toString();
        return t = function(e = "") {
            let t = e.toString();
            return t = pe(t, "-", " "), t = pe(t, "_", " "), t = ge(t), pe(t, " ", "");
        }(t), t.charAt(0).toLowerCase() + t.slice(1);
    }
    function ye(e) {
        const t = document.createElement("div");
        return t.appendChild(e), t.innerHTML;
    }
    const be = {
        pip: "PIP",
        airplay: "AirPlay",
        html5: "HTML5",
        vimeo: "Vimeo",
        youtube: "YouTube"
    }, ve = {
        get (e = "", t = {}) {
            if (S.empty(e) || S.empty(t)) return "";
            let i = N(t.i18n, e);
            if (S.empty(i)) return Object.keys(be).includes(e) ? be[e] : "";
            const s = {
                "{seektime}": t.seekTime,
                "{title}": t.title
            };
            return Object.entries(s).forEach(([e, t])=>{
                i = pe(i, e, t);
            }), i;
        }
    };
    class we {
        constructor(t){
            e(this, "get", (e)=>{
                if (!we.supported || !this.enabled) return null;
                const t = window.localStorage.getItem(this.key);
                if (S.empty(t)) return null;
                const i = JSON.parse(t);
                return S.string(e) && e.length ? i[e] : i;
            }), e(this, "set", (e)=>{
                if (!we.supported || !this.enabled) return;
                if (!S.object(e)) return;
                let t = this.get();
                S.empty(t) && (t = {}), x(t, e);
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(t));
                } catch (e) {}
            }), this.enabled = t.config.storage.enabled, this.key = t.config.storage.key;
        }
        static get supported() {
            try {
                if (!("localStorage" in window)) return !1;
                const e = "___test";
                return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
            } catch (e) {
                return !1;
            }
        }
    }
    function Te(e, t = "text") {
        return new Promise((i, s)=>{
            try {
                const s = new XMLHttpRequest;
                if (!("withCredentials" in s)) return;
                s.addEventListener("load", ()=>{
                    if ("text" === t) try {
                        i(JSON.parse(s.responseText));
                    } catch (e) {
                        i(s.responseText);
                    }
                    else i(s.response);
                }), s.addEventListener("error", ()=>{
                    throw new Error(s.status);
                }), s.open("GET", e, !0), s.responseType = t, s.send();
            } catch (e) {
                s(e);
            }
        });
    }
    function ke(e, t) {
        if (!S.string(e)) return;
        const i = "cache", s = S.string(t);
        let n = !1;
        const a = ()=>null !== document.getElementById(t), l = (e, t)=>{
            e.innerHTML = t, s && a() || document.body.insertAdjacentElement("afterbegin", e);
        };
        if (!s || !a()) {
            const a = we.supported, r = document.createElement("div");
            if (r.setAttribute("hidden", ""), s && r.setAttribute("id", t), a) {
                const e = window.localStorage.getItem(`${i}-${t}`);
                if (n = null !== e, n) {
                    const t = JSON.parse(e);
                    l(r, t.content);
                }
            }
            Te(e).then((e)=>{
                if (!S.empty(e)) {
                    if (a) try {
                        window.localStorage.setItem(`${i}-${t}`, JSON.stringify({
                            content: e
                        }));
                    } catch (e) {}
                    l(r, e);
                }
            }).catch(()=>{});
        }
    }
    const Ce = (e)=>Math.trunc(e / 60 / 60 % 60, 10), Ae = (e)=>Math.trunc(e / 60 % 60, 10), Se = (e)=>Math.trunc(e % 60, 10);
    function Ee(e = 0, t = !1, i = !1) {
        if (!S.number(e)) return Ee(void 0, t, i);
        const s = (e)=>`0${e}`.slice(-2);
        let n = Ce(e);
        const a = Ae(e), l = Se(e);
        return n = t || n > 0 ? `${n}:` : "", `${i && e > 0 ? "-" : ""}${n}${s(a)}:${s(l)}`;
    }
    const Pe = {
        getIconUrl () {
            const e = new URL(this.config.iconUrl, window.location), t = window.location.host ? window.location.host : window.top.location.host, i = e.host !== t || M.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: i
            };
        },
        findElements () {
            try {
                return this.elements.controls = B.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = {
                    play: U.call(this, this.config.selectors.buttons.play),
                    pause: B.call(this, this.config.selectors.buttons.pause),
                    restart: B.call(this, this.config.selectors.buttons.restart),
                    rewind: B.call(this, this.config.selectors.buttons.rewind),
                    fastForward: B.call(this, this.config.selectors.buttons.fastForward),
                    mute: B.call(this, this.config.selectors.buttons.mute),
                    pip: B.call(this, this.config.selectors.buttons.pip),
                    airplay: B.call(this, this.config.selectors.buttons.airplay),
                    settings: B.call(this, this.config.selectors.buttons.settings),
                    captions: B.call(this, this.config.selectors.buttons.captions),
                    fullscreen: B.call(this, this.config.selectors.buttons.fullscreen)
                }, this.elements.progress = B.call(this, this.config.selectors.progress), this.elements.inputs = {
                    seek: B.call(this, this.config.selectors.inputs.seek),
                    volume: B.call(this, this.config.selectors.inputs.volume)
                }, this.elements.display = {
                    buffer: B.call(this, this.config.selectors.display.buffer),
                    currentTime: B.call(this, this.config.selectors.display.currentTime),
                    duration: B.call(this, this.config.selectors.display.duration)
                }, S.element(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), !0;
            } catch (e) {
                return this.debug.warn("It looks like there is a problem with your custom controls HTML", e), this.toggleNativeControls(!0), !1;
            }
        },
        createIcon (e, t) {
            const i = "http://www.w3.org/2000/svg", s = Pe.getIconUrl.call(this), n = `${s.cors ? "" : s.url}#${this.config.iconPrefix}`, a = document.createElementNS(i, "svg");
            I(a, x(t, {
                "aria-hidden": "true",
                focusable: "false"
            }));
            const l = document.createElementNS(i, "use"), r = `${n}-${e}`;
            return "href" in l && l.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), l.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", r), a.appendChild(l), a;
        },
        createLabel (e, t = {}) {
            const i = ve.get(e, this.config);
            return $("span", {
                ...t,
                class: [
                    t.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(" ")
            }, i);
        },
        createBadge (e) {
            if (S.empty(e)) return null;
            const t = $("span", {
                class: this.config.classNames.menu.value
            });
            return t.appendChild($("span", {
                class: this.config.classNames.menu.badge
            }, e)), t;
        },
        createButton (e, t) {
            const i = x({}, t);
            let s = fe(e);
            const n = {
                element: "button",
                toggle: !1,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            switch([
                "element",
                "icon",
                "label"
            ].forEach((e)=>{
                Object.keys(i).includes(e) && (n[e] = i[e], delete i[e]);
            }), "button" !== n.element || Object.keys(i).includes("type") || (i.type = "button"), Object.keys(i).includes("class") ? i.class.split(" ").some((e)=>e === this.config.classNames.control) || x(i, {
                class: `${i.class} ${this.config.classNames.control}`
            }) : i.class = this.config.classNames.control, e){
                case "play":
                    n.toggle = !0, n.label = "play", n.labelPressed = "pause", n.icon = "play", n.iconPressed = "pause";
                    break;
                case "mute":
                    n.toggle = !0, n.label = "mute", n.labelPressed = "unmute", n.icon = "volume", n.iconPressed = "muted";
                    break;
                case "captions":
                    n.toggle = !0, n.label = "enableCaptions", n.labelPressed = "disableCaptions", n.icon = "captions-off", n.iconPressed = "captions-on";
                    break;
                case "fullscreen":
                    n.toggle = !0, n.label = "enterFullscreen", n.labelPressed = "exitFullscreen", n.icon = "enter-fullscreen", n.iconPressed = "exit-fullscreen";
                    break;
                case "play-large":
                    i.class += ` ${this.config.classNames.control}--overlaid`, s = "play", n.label = "play", n.icon = "play";
                    break;
                default:
                    S.empty(n.label) && (n.label = s), S.empty(n.icon) && (n.icon = e);
            }
            const a = $(n.element);
            return n.toggle ? (a.appendChild(Pe.createIcon.call(this, n.iconPressed, {
                class: "icon--pressed"
            })), a.appendChild(Pe.createIcon.call(this, n.icon, {
                class: "icon--not-pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.labelPressed, {
                class: "label--pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.label, {
                class: "label--not-pressed"
            }))) : (a.appendChild(Pe.createIcon.call(this, n.icon)), a.appendChild(Pe.createLabel.call(this, n.label))), x(i, D(this.config.selectors.buttons[s], i)), I(a, i), "play" === s ? (S.array(this.elements.buttons[s]) || (this.elements.buttons[s] = []), this.elements.buttons[s].push(a)) : this.elements.buttons[s] = a, a;
        },
        createRange (e, t) {
            const i = $("input", x(D(this.config.selectors.inputs[e]), {
                type: "range",
                min: 0,
                max: 100,
                step: .01,
                value: 0,
                autocomplete: "off",
                role: "slider",
                "aria-label": ve.get(e, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0
            }, t));
            return this.elements.inputs[e] = i, Pe.updateRangeFill.call(this, i), g.setup(i), i;
        },
        createProgress (e, t) {
            const i = $("progress", x(D(this.config.selectors.display[e]), {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": !0
            }, t));
            if ("volume" !== e) {
                i.appendChild($("span", null, "0"));
                const t = {
                    played: "played",
                    buffer: "buffered"
                }[e], s = t ? ve.get(t, this.config) : "";
                i.innerText = `% ${s.toLowerCase()}`;
            }
            return this.elements.display[e] = i, i;
        },
        createTime (e, t) {
            const i = D(this.config.selectors.display[e], t), s = $("div", x(i, {
                class: `${i.class ? i.class : ""} ${this.config.classNames.display.time} `.trim(),
                "aria-label": ve.get(e, this.config),
                role: "timer"
            }), "00:00");
            return this.elements.display[e] = s, s;
        },
        bindMenuItemShortcuts (e, t) {
            X.call(this, e, "keydown keyup", (i)=>{
                if (![
                    " ",
                    "ArrowUp",
                    "ArrowDown",
                    "ArrowRight"
                ].includes(i.key)) return;
                if (i.preventDefault(), i.stopPropagation(), "keydown" === i.type) return;
                const s = V(e, '[role="menuitemradio"]');
                if (!s && [
                    " ",
                    "ArrowRight"
                ].includes(i.key)) Pe.showMenuPanel.call(this, t, !0);
                else {
                    let t;
                    " " !== i.key && ("ArrowDown" === i.key || s && "ArrowRight" === i.key ? (t = e.nextElementSibling, S.element(t) || (t = e.parentNode.firstElementChild)) : (t = e.previousElementSibling, S.element(t) || (t = e.parentNode.lastElementChild)), W.call(this, t, !0));
                }
            }, !1), X.call(this, e, "keyup", (e)=>{
                "Return" === e.key && Pe.focusFirstMenuItem.call(this, null, !0);
            });
        },
        createMenuItem ({ value: e , list: t , type: i , title: s , badge: n = null , checked: a = !1  }) {
            const l = D(this.config.selectors.inputs[i]), r = $("button", x(l, {
                type: "button",
                role: "menuitemradio",
                class: `${this.config.classNames.control} ${l.class ? l.class : ""}`.trim(),
                "aria-checked": a,
                value: e
            })), o = $("span");
            o.innerHTML = s, S.element(n) && o.appendChild(n), r.appendChild(o), Object.defineProperty(r, "checked", {
                enumerable: !0,
                get: ()=>"true" === r.getAttribute("aria-checked"),
                set (e) {
                    e && Array.from(r.parentNode.children).filter((e)=>V(e, '[role="menuitemradio"]')).forEach((e)=>e.setAttribute("aria-checked", "false")), r.setAttribute("aria-checked", e ? "true" : "false");
                }
            }), this.listeners.bind(r, "click keyup", (t)=>{
                if (!S.keyboardEvent(t) || " " === t.key) {
                    switch(t.preventDefault(), t.stopPropagation(), r.checked = !0, i){
                        case "language":
                            this.currentTrack = Number(e);
                            break;
                        case "quality":
                            this.quality = e;
                            break;
                        case "speed":
                            this.speed = parseFloat(e);
                    }
                    Pe.showMenuPanel.call(this, "home", S.keyboardEvent(t));
                }
            }, i, !1), Pe.bindMenuItemShortcuts.call(this, r, i), t.appendChild(r);
        },
        formatTime (e = 0, t = !1) {
            if (!S.number(e)) return e;
            return Ee(e, Ce(this.duration) > 0, t);
        },
        updateTimeDisplay (e = null, t = 0, i = !1) {
            S.element(e) && S.number(t) && (e.innerText = Pe.formatTime(t, i));
        },
        updateVolume () {
            this.supported.ui && (S.element(this.elements.inputs.volume) && Pe.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), S.element(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume));
        },
        setRange (e, t = 0) {
            S.element(e) && (e.value = t, Pe.updateRangeFill.call(this, e));
        },
        updateProgress (e) {
            if (!this.supported.ui || !S.event(e)) return;
            let t = 0;
            const i = (e, t)=>{
                const i = S.number(t) ? t : 0, s = S.element(e) ? e : this.elements.display.buffer;
                if (S.element(s)) {
                    s.value = i;
                    const e = s.getElementsByTagName("span")[0];
                    S.element(e) && (e.childNodes[0].nodeValue = i);
                }
            };
            if (e) switch(e.type){
                case "timeupdate":
                case "seeking":
                case "seeked":
                    s = this.currentTime, n = this.duration, t = 0 === s || 0 === n || Number.isNaN(s) || Number.isNaN(n) ? 0 : (s / n * 100).toFixed(2), "timeupdate" === e.type && Pe.setRange.call(this, this.elements.inputs.seek, t);
                    break;
                case "playing":
                case "progress":
                    i(this.elements.display.buffer, 100 * this.buffered);
            }
            var s, n;
        },
        updateRangeFill (e) {
            const t = S.event(e) ? e.target : e;
            if (S.element(t) && "range" === t.getAttribute("type")) {
                if (V(t, this.config.selectors.inputs.seek)) {
                    t.setAttribute("aria-valuenow", this.currentTime);
                    const e = Pe.formatTime(this.currentTime), i = Pe.formatTime(this.duration), s = ve.get("seekLabel", this.config);
                    t.setAttribute("aria-valuetext", s.replace("{currentTime}", e).replace("{duration}", i));
                } else if (V(t, this.config.selectors.inputs.volume)) {
                    const e = 100 * t.value;
                    t.setAttribute("aria-valuenow", e), t.setAttribute("aria-valuetext", `${e.toFixed(1)}%`);
                } else t.setAttribute("aria-valuenow", t.value);
                (M.isWebKit || M.isIPadOS) && t.style.setProperty("--value", t.value / t.max * 100 + "%");
            }
        },
        updateSeekTooltip (e) {
            var t, i;
            if (!this.config.tooltips.seek || !S.element(this.elements.inputs.seek) || !S.element(this.elements.display.seekTooltip) || 0 === this.duration) return;
            const s = this.elements.display.seekTooltip, n = `${this.config.classNames.tooltip}--visible`, a = (e)=>R(s, n, e);
            if (this.touch) return void a(!1);
            let l = 0;
            const r = this.elements.progress.getBoundingClientRect();
            if (S.event(e)) l = 100 / r.width * (e.pageX - r.left);
            else {
                if (!F(s, n)) return;
                l = parseFloat(s.style.left, 10);
            }
            l < 0 ? l = 0 : l > 100 && (l = 100);
            const o = this.duration / 100 * l;
            s.innerText = Pe.formatTime(o);
            const c = null === (t = this.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e  })=>e === Math.round(o));
            c && s.insertAdjacentHTML("afterbegin", `${c.label}<br>`), s.style.left = `${l}%`, S.event(e) && [
                "mouseenter",
                "mouseleave"
            ].includes(e.type) && a("mouseenter" === e.type);
        },
        timeUpdate (e) {
            const t = !S.element(this.elements.display.duration) && this.config.invertTime;
            Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, t ? this.duration - this.currentTime : this.currentTime, t), e && "timeupdate" === e.type && this.media.seeking || Pe.updateProgress.call(this, e);
        },
        durationUpdate () {
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            if (this.duration >= 2 ** 32) return H(this.elements.display.currentTime, !0), void H(this.elements.progress, !0);
            S.element(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
            const e = S.element(this.elements.display.duration);
            !e && this.config.displayDuration && this.paused && Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), e && Pe.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), this.config.markers.enabled && Pe.setMarkers.call(this), Pe.updateSeekTooltip.call(this);
        },
        toggleMenuButton (e, t) {
            H(this.elements.settings.buttons[e], !t);
        },
        updateSetting (e, t, i) {
            const s = this.elements.settings.panels[e];
            let n = null, a = t;
            if ("captions" === e) n = this.currentTrack;
            else {
                if (n = S.empty(i) ? this[e] : i, S.empty(n) && (n = this.config[e].default), !S.empty(this.options[e]) && !this.options[e].includes(n)) return void this.debug.warn(`Unsupported value of '${n}' for ${e}`);
                if (!this.config[e].options.includes(n)) return void this.debug.warn(`Disabled value of '${n}' for ${e}`);
            }
            if (S.element(a) || (a = s && s.querySelector('[role="menu"]')), !S.element(a)) return;
            this.elements.settings.buttons[e].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = Pe.getLabel.call(this, e, n);
            const l = a && a.querySelector(`[value="${n}"]`);
            S.element(l) && (l.checked = !0);
        },
        getLabel (e, t) {
            switch(e){
                case "speed":
                    return 1 === t ? ve.get("normal", this.config) : `${t}&times;`;
                case "quality":
                    if (S.number(t)) {
                        const e = ve.get(`qualityLabel.${t}`, this.config);
                        return e.length ? e : `${t}p`;
                    }
                    return ge(t);
                case "captions":
                    return xe.getLabel.call(this);
                default:
                    return null;
            }
        },
        setQualityMenu (e) {
            if (!S.element(this.elements.settings.panels.quality)) return;
            const t = "quality", i = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            S.array(e) && (this.options.quality = se(e).filter((e)=>this.config.quality.options.includes(e)));
            const s = !S.empty(this.options.quality) && this.options.quality.length > 1;
            if (Pe.toggleMenuButton.call(this, t, s), j(i), Pe.checkMenu.call(this), !s) return;
            const n = (e)=>{
                const t = ve.get(`qualityBadge.${e}`, this.config);
                return t.length ? Pe.createBadge.call(this, t) : null;
            };
            this.options.quality.sort((e, t)=>{
                const i = this.config.quality.options;
                return i.indexOf(e) > i.indexOf(t) ? 1 : -1;
            }).forEach((e)=>{
                Pe.createMenuItem.call(this, {
                    value: e,
                    list: i,
                    type: t,
                    title: Pe.getLabel.call(this, "quality", e),
                    badge: n(e)
                });
            }), Pe.updateSetting.call(this, t, i);
        },
        setCaptionsMenu () {
            if (!S.element(this.elements.settings.panels.captions)) return;
            const e = "captions", t = this.elements.settings.panels.captions.querySelector('[role="menu"]'), i = xe.getTracks.call(this), s = Boolean(i.length);
            if (Pe.toggleMenuButton.call(this, e, s), j(t), Pe.checkMenu.call(this), !s) return;
            const n = i.map((e, i)=>({
                    value: i,
                    checked: this.captions.toggled && this.currentTrack === i,
                    title: xe.getLabel.call(this, e),
                    badge: e.language && Pe.createBadge.call(this, e.language.toUpperCase()),
                    list: t,
                    type: "language"
                }));
            n.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: ve.get("disabled", this.config),
                list: t,
                type: "language"
            }), n.forEach(Pe.createMenuItem.bind(this)), Pe.updateSetting.call(this, e, t);
        },
        setSpeedMenu () {
            if (!S.element(this.elements.settings.panels.speed)) return;
            const e = "speed", t = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            this.options.speed = this.options.speed.filter((e)=>e >= this.minimumSpeed && e <= this.maximumSpeed);
            const i = !S.empty(this.options.speed) && this.options.speed.length > 1;
            Pe.toggleMenuButton.call(this, e, i), j(t), Pe.checkMenu.call(this), i && (this.options.speed.forEach((i)=>{
                Pe.createMenuItem.call(this, {
                    value: i,
                    list: t,
                    type: e,
                    title: Pe.getLabel.call(this, "speed", i)
                });
            }), Pe.updateSetting.call(this, e, t));
        },
        checkMenu () {
            const { buttons: e  } = this.elements.settings, t = !S.empty(e) && Object.values(e).some((e)=>!e.hidden);
            H(this.elements.settings.menu, !t);
        },
        focusFirstMenuItem (e, t = !1) {
            if (this.elements.settings.popup.hidden) return;
            let i = e;
            S.element(i) || (i = Object.values(this.elements.settings.panels).find((e)=>!e.hidden));
            const s = i.querySelector('[role^="menuitem"]');
            W.call(this, s, t);
        },
        toggleMenu (e) {
            const { popup: t  } = this.elements.settings, i = this.elements.buttons.settings;
            if (!S.element(t) || !S.element(i)) return;
            const { hidden: s  } = t;
            let n = s;
            if (S.boolean(e)) n = e;
            else if (S.keyboardEvent(e) && "Escape" === e.key) n = !1;
            else if (S.event(e)) {
                const s = S.function(e.composedPath) ? e.composedPath()[0] : e.target, a = t.contains(s);
                if (a || !a && e.target !== i && n) return;
            }
            i.setAttribute("aria-expanded", n), H(t, !n), R(this.elements.container, this.config.classNames.menu.open, n), n && S.keyboardEvent(e) ? Pe.focusFirstMenuItem.call(this, null, !0) : n || s || W.call(this, i, S.keyboardEvent(e));
        },
        getMenuSize (e) {
            const t = e.cloneNode(!0);
            t.style.position = "absolute", t.style.opacity = 0, t.removeAttribute("hidden"), e.parentNode.appendChild(t);
            const i = t.scrollWidth, s = t.scrollHeight;
            return O(t), {
                width: i,
                height: s
            };
        },
        showMenuPanel (e = "", t = !1) {
            const i = this.elements.container.querySelector(`#plyr-settings-${this.id}-${e}`);
            if (!S.element(i)) return;
            const s = i.parentNode, n = Array.from(s.children).find((e)=>!e.hidden);
            if (K.transitions && !K.reducedMotion) {
                s.style.width = `${n.scrollWidth}px`, s.style.height = `${n.scrollHeight}px`;
                const e = Pe.getMenuSize.call(this, i), t = (e)=>{
                    e.target === s && [
                        "width",
                        "height"
                    ].includes(e.propertyName) && (s.style.width = "", s.style.height = "", J.call(this, s, E, t));
                };
                X.call(this, s, E, t), s.style.width = `${e.width}px`, s.style.height = `${e.height}px`;
            }
            H(n, !0), H(i, !1), Pe.focusFirstMenuItem.call(this, i, t);
        },
        setDownloadUrl () {
            const e = this.elements.buttons.download;
            S.element(e) && e.setAttribute("href", this.download);
        },
        create (e) {
            const { bindMenuItemShortcuts: t , createButton: i , createProgress: s , createRange: n , createTime: a , setQualityMenu: l , setSpeedMenu: r , showMenuPanel: o  } = Pe;
            this.elements.controls = null, S.array(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i.call(this, "play-large"));
            const c = $("div", D(this.config.selectors.controls.wrapper));
            this.elements.controls = c;
            const u = {
                class: "plyr__controls__item"
            };
            return se(S.array(this.config.controls) ? this.config.controls : []).forEach((l)=>{
                if ("restart" === l && c.appendChild(i.call(this, "restart", u)), "rewind" === l && c.appendChild(i.call(this, "rewind", u)), "play" === l && c.appendChild(i.call(this, "play", u)), "fast-forward" === l && c.appendChild(i.call(this, "fast-forward", u)), "progress" === l) {
                    const t = $("div", {
                        class: `${u.class} plyr__progress__container`
                    }), i = $("div", D(this.config.selectors.progress));
                    if (i.appendChild(n.call(this, "seek", {
                        id: `plyr-seek-${e.id}`
                    })), i.appendChild(s.call(this, "buffer")), this.config.tooltips.seek) {
                        const e = $("span", {
                            class: this.config.classNames.tooltip
                        }, "00:00");
                        i.appendChild(e), this.elements.display.seekTooltip = e;
                    }
                    this.elements.progress = i, t.appendChild(this.elements.progress), c.appendChild(t);
                }
                if ("current-time" === l && c.appendChild(a.call(this, "currentTime", u)), "duration" === l && c.appendChild(a.call(this, "duration", u)), "mute" === l || "volume" === l) {
                    let { volume: t  } = this.elements;
                    if (S.element(t) && c.contains(t) || (t = $("div", x({}, u, {
                        class: `${u.class} plyr__volume`.trim()
                    })), this.elements.volume = t, c.appendChild(t)), "mute" === l && t.appendChild(i.call(this, "mute")), "volume" === l && !M.isIos && !M.isIPadOS) {
                        const i = {
                            max: 1,
                            step: .05,
                            value: this.config.volume
                        };
                        t.appendChild(n.call(this, "volume", x(i, {
                            id: `plyr-volume-${e.id}`
                        })));
                    }
                }
                if ("captions" === l && c.appendChild(i.call(this, "captions", u)), "settings" === l && !S.empty(this.config.settings)) {
                    const s = $("div", x({}, u, {
                        class: `${u.class} plyr__menu`.trim(),
                        hidden: ""
                    }));
                    s.appendChild(i.call(this, "settings", {
                        "aria-haspopup": !0,
                        "aria-controls": `plyr-settings-${e.id}`,
                        "aria-expanded": !1
                    }));
                    const n = $("div", {
                        class: "plyr__menu__container",
                        id: `plyr-settings-${e.id}`,
                        hidden: ""
                    }), a = $("div"), l = $("div", {
                        id: `plyr-settings-${e.id}-home`
                    }), r = $("div", {
                        role: "menu"
                    });
                    l.appendChild(r), a.appendChild(l), this.elements.settings.panels.home = l, this.config.settings.forEach((i)=>{
                        const s = $("button", x(D(this.config.selectors.buttons.settings), {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            role: "menuitem",
                            "aria-haspopup": !0,
                            hidden: ""
                        }));
                        t.call(this, s, i), X.call(this, s, "click", ()=>{
                            o.call(this, i, !1);
                        });
                        const n = $("span", null, ve.get(i, this.config)), l = $("span", {
                            class: this.config.classNames.menu.value
                        });
                        l.innerHTML = e[i], n.appendChild(l), s.appendChild(n), r.appendChild(s);
                        const c = $("div", {
                            id: `plyr-settings-${e.id}-${i}`,
                            hidden: ""
                        }), u = $("button", {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        u.appendChild($("span", {
                            "aria-hidden": !0
                        }, ve.get(i, this.config))), u.appendChild($("span", {
                            class: this.config.classNames.hidden
                        }, ve.get("menuBack", this.config))), X.call(this, c, "keydown", (e)=>{
                            "ArrowLeft" === e.key && (e.preventDefault(), e.stopPropagation(), o.call(this, "home", !0));
                        }, !1), X.call(this, u, "click", ()=>{
                            o.call(this, "home", !1);
                        }), c.appendChild(u), c.appendChild($("div", {
                            role: "menu"
                        })), a.appendChild(c), this.elements.settings.buttons[i] = s, this.elements.settings.panels[i] = c;
                    }), n.appendChild(a), s.appendChild(n), c.appendChild(s), this.elements.settings.popup = n, this.elements.settings.menu = s;
                }
                if ("pip" === l && K.pip && c.appendChild(i.call(this, "pip", u)), "airplay" === l && K.airplay && c.appendChild(i.call(this, "airplay", u)), "download" === l) {
                    const e = x({}, u, {
                        element: "a",
                        href: this.download,
                        target: "_blank"
                    });
                    this.isHTML5 && (e.download = "");
                    const { download: t  } = this.config.urls;
                    !S.url(t) && this.isEmbed && x(e, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    }), c.appendChild(i.call(this, "download", e));
                }
                "fullscreen" === l && c.appendChild(i.call(this, "fullscreen", u));
            }), this.isHTML5 && l.call(this, de.getQualityOptions.call(this)), r.call(this), c;
        },
        inject () {
            if (this.config.loadSprite) {
                const e = Pe.getIconUrl.call(this);
                e.cors && ke(e.url, "sprite-plyr");
            }
            this.id = Math.floor(1e4 * Math.random());
            let e = null;
            this.elements.controls = null;
            const t = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let i = !0;
            S.function(this.config.controls) && (this.config.controls = this.config.controls.call(this, t)), this.config.controls || (this.config.controls = []), S.element(this.config.controls) || S.string(this.config.controls) ? e = this.config.controls : (e = Pe.create.call(this, {
                id: this.id,
                seektime: this.config.seekTime,
                speed: this.speed,
                quality: this.quality,
                captions: xe.getLabel.call(this)
            }), i = !1);
            let s;
            i && S.string(this.config.controls) && (e = ((e)=>{
                let i = e;
                return Object.entries(t).forEach(([e, t])=>{
                    i = pe(i, `{${e}}`, t);
                }), i;
            })(e)), S.string(this.config.selectors.controls.container) && (s = document.querySelector(this.config.selectors.controls.container)), S.element(s) || (s = this.elements.container);
            if (s[S.element(e) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", e), S.element(this.elements.controls) || Pe.findElements.call(this), !S.empty(this.elements.buttons)) {
                const e = (e)=>{
                    const t = this.config.classNames.controlPressed;
                    e.setAttribute("aria-pressed", "false"), Object.defineProperty(e, "pressed", {
                        configurable: !0,
                        enumerable: !0,
                        get: ()=>F(e, t),
                        set (i = !1) {
                            R(e, t, i), e.setAttribute("aria-pressed", i ? "true" : "false");
                        }
                    });
                };
                Object.values(this.elements.buttons).filter(Boolean).forEach((t)=>{
                    S.array(t) || S.nodeList(t) ? Array.from(t).filter(Boolean).forEach(e) : e(t);
                });
            }
            if (M.isEdge && P(s), this.config.tooltips.controls) {
                const { classNames: e , selectors: t  } = this.config, i = `${t.controls.wrapper} ${t.labels} .${e.hidden}`, s = U.call(this, i);
                Array.from(s).forEach((e)=>{
                    R(e, this.config.classNames.hidden, !1), R(e, this.config.classNames.tooltip, !0);
                });
            }
        },
        setMediaMetadata () {
            try {
                "mediaSession" in navigator && (navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                }));
            } catch (e) {}
        },
        setMarkers () {
            var e, t;
            if (!this.duration || this.elements.markers) return;
            const i = null === (e = this.config.markers) || void 0 === e || null === (t = e.points) || void 0 === t ? void 0 : t.filter(({ time: e  })=>e > 0 && e < this.duration);
            if (null == i || !i.length) return;
            const s = document.createDocumentFragment(), n = document.createDocumentFragment();
            let a = null;
            const l = `${this.config.classNames.tooltip}--visible`, r = (e)=>R(a, l, e);
            i.forEach((e)=>{
                const t = $("span", {
                    class: this.config.classNames.marker
                }, ""), i = e.time / this.duration * 100 + "%";
                a && (t.addEventListener("mouseenter", ()=>{
                    e.label || (a.style.left = i, a.innerHTML = e.label, r(!0));
                }), t.addEventListener("mouseleave", ()=>{
                    r(!1);
                })), t.addEventListener("click", ()=>{
                    this.currentTime = e.time;
                }), t.style.left = i, n.appendChild(t);
            }), s.appendChild(n), this.config.tooltips.seek || (a = $("span", {
                class: this.config.classNames.tooltip
            }, ""), s.appendChild(a)), this.elements.markers = {
                points: n,
                tip: a
            }, this.elements.progress.appendChild(s);
        }
    };
    function Me(e, t = !0) {
        let i = e;
        if (t) {
            const e = document.createElement("a");
            e.href = i, i = e.href;
        }
        try {
            return new URL(i);
        } catch (e) {
            return null;
        }
    }
    function Ne(e) {
        const t = new URLSearchParams;
        return S.object(e) && Object.entries(e).forEach(([e, i])=>{
            t.set(e, i);
        }), t;
    }
    const xe = {
        setup () {
            if (!this.supported.ui) return;
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !K.textTracks) return void (S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this));
            var e, t;
            if (S.element(this.elements.captions) || (this.elements.captions = $("div", D(this.config.selectors.captions)), this.elements.captions.setAttribute("dir", "auto"), e = this.elements.captions, t = this.elements.wrapper, S.element(e) && S.element(t) && t.parentNode.insertBefore(e, t.nextSibling)), M.isIE && window.URL) {
                const e = this.media.querySelectorAll("track");
                Array.from(e).forEach((e)=>{
                    const t = e.getAttribute("src"), i = Me(t);
                    null !== i && i.hostname !== window.location.href.hostname && [
                        "http:",
                        "https:"
                    ].includes(i.protocol) && Te(t, "blob").then((t)=>{
                        e.setAttribute("src", window.URL.createObjectURL(t));
                    }).catch(()=>{
                        O(e);
                    });
                });
            }
            const i = se((navigator.languages || [
                navigator.language || navigator.userLanguage || "en"
            ]).map((e)=>e.split("-")[0]));
            let s = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
            "auto" === s && ([s] = i);
            let n = this.storage.get("captions");
            if (S.boolean(n) || ({ active: n  } = this.config.captions), Object.assign(this.captions, {
                toggled: !1,
                active: n,
                language: s,
                languages: i
            }), this.isHTML5) {
                const e = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                X.call(this, this.media.textTracks, e, xe.update.bind(this));
            }
            setTimeout(xe.update.bind(this), 0);
        },
        update () {
            const e = xe.getTracks.call(this, !0), { active: t , language: i , meta: s , currentTrackNode: n  } = this.captions, a = Boolean(e.find((e)=>e.language === i));
            this.isHTML5 && this.isVideo && e.filter((e)=>!s.get(e)).forEach((e)=>{
                this.debug.log("Track added", e), s.set(e, {
                    default: "showing" === e.mode
                }), "showing" === e.mode && (e.mode = "hidden"), X.call(this, e, "cuechange", ()=>xe.updateCues.call(this));
            }), (a && this.language !== i || !e.includes(n)) && (xe.setLanguage.call(this, i), xe.toggle.call(this, t && a)), this.elements && R(this.elements.container, this.config.classNames.captions.enabled, !S.empty(e)), S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this);
        },
        toggle (e, t = !0) {
            if (!this.supported.ui) return;
            const { toggled: i  } = this.captions, s = this.config.classNames.captions.active, n = S.nullOrUndefined(e) ? !i : e;
            if (n !== i) {
                if (t || (this.captions.active = n, this.storage.set({
                    captions: n
                })), !this.language && n && !t) {
                    const e = xe.getTracks.call(this), t = xe.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], !0);
                    return this.captions.language = t.language, void xe.set.call(this, e.indexOf(t));
                }
                this.elements.buttons.captions && (this.elements.buttons.captions.pressed = n), R(this.elements.container, s, n), this.captions.toggled = n, Pe.updateSetting.call(this, "captions"), Z.call(this, this.media, n ? "captionsenabled" : "captionsdisabled");
            }
            setTimeout(()=>{
                n && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
            });
        },
        set (e, t = !0) {
            const i = xe.getTracks.call(this);
            if (-1 !== e) {
                if (S.number(e)) {
                    if (e in i) {
                        if (this.captions.currentTrack !== e) {
                            this.captions.currentTrack = e;
                            const s = i[e], { language: n  } = s || {};
                            this.captions.currentTrackNode = s, Pe.updateSetting.call(this, "captions"), t || (this.captions.language = n, this.storage.set({
                                language: n
                            })), this.isVimeo && this.embed.enableTextTrack(n), Z.call(this, this.media, "languagechange");
                        }
                        xe.toggle.call(this, !0, t), this.isHTML5 && this.isVideo && xe.updateCues.call(this);
                    } else this.debug.warn("Track not found", e);
                } else this.debug.warn("Invalid caption argument", e);
            } else xe.toggle.call(this, !1, t);
        },
        setLanguage (e, t = !0) {
            if (!S.string(e)) return void this.debug.warn("Invalid language argument", e);
            const i = e.toLowerCase();
            this.captions.language = i;
            const s = xe.getTracks.call(this), n = xe.findTrack.call(this, [
                i
            ]);
            xe.set.call(this, s.indexOf(n), t);
        },
        getTracks (e = !1) {
            return Array.from((this.media || {}).textTracks || []).filter((t)=>!this.isHTML5 || e || this.captions.meta.has(t)).filter((e)=>[
                    "captions",
                    "subtitles"
                ].includes(e.kind));
        },
        findTrack (e, t = !1) {
            const i = xe.getTracks.call(this), s = (e)=>Number((this.captions.meta.get(e) || {}).default), n = Array.from(i).sort((e, t)=>s(t) - s(e));
            let a;
            return e.every((e)=>(a = n.find((t)=>t.language === e), !a)), a || (t ? n[0] : void 0);
        },
        getCurrentTrack () {
            return xe.getTracks.call(this)[this.currentTrack];
        },
        getLabel (e) {
            let t = e;
            return !S.track(t) && K.textTracks && this.captions.toggled && (t = xe.getCurrentTrack.call(this)), S.track(t) ? S.empty(t.label) ? S.empty(t.language) ? ve.get("enabled", this.config) : e.language.toUpperCase() : t.label : ve.get("disabled", this.config);
        },
        updateCues (e) {
            if (!this.supported.ui) return;
            if (!S.element(this.elements.captions)) return void this.debug.warn("No captions element to render to");
            if (!S.nullOrUndefined(e) && !Array.isArray(e)) return void this.debug.warn("updateCues: Invalid input", e);
            let t = e;
            if (!t) {
                const e = xe.getCurrentTrack.call(this);
                t = Array.from((e || {}).activeCues || []).map((e)=>e.getCueAsHTML()).map(ye);
            }
            const i = t.map((e)=>e.trim()).join("\n");
            if (i !== this.elements.captions.innerHTML) {
                j(this.elements.captions);
                const e = $("span", D(this.config.selectors.caption));
                e.innerHTML = i, this.elements.captions.appendChild(e), Z.call(this, this.media, "cuechange");
            }
        }
    }, Le = {
        enabled: !0,
        title: "",
        debug: !1,
        autoplay: !1,
        autopause: !0,
        playsinline: !0,
        seekTime: 10,
        volume: 1,
        muted: !1,
        duration: null,
        displayDuration: !0,
        invertTime: !0,
        toggleInvert: !0,
        ratio: null,
        clickToPlay: !0,
        hideControls: !0,
        resetOnEnd: !1,
        disableContextMenu: !0,
        loadSprite: !0,
        iconPrefix: "plyr",
        iconUrl: "https://cdn.plyr.io/3.7.8/plyr.svg",
        blankVideo: "https://cdn.plyr.io/static/blank.mp4",
        quality: {
            default: 576,
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: !1,
            onChange: null
        },
        loop: {
            active: !1
        },
        speed: {
            selected: 1,
            options: [
                .5,
                .75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        keyboard: {
            focused: !0,
            global: !1
        },
        tooltips: {
            controls: !1,
            seek: !0
        },
        captions: {
            active: !1,
            language: "auto",
            update: !1
        },
        fullscreen: {
            enabled: !0,
            fallback: !0,
            iosNative: !1
        },
        storage: {
            enabled: !0,
            key: "plyr"
        },
        controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "mute",
            "volume",
            "captions",
            "settings",
            "pip",
            "airplay",
            "fullscreen"
        ],
        settings: [
            "captions",
            "quality",
            "speed"
        ],
        i18n: {
            restart: "Restart",
            rewind: "Rewind {seektime}s",
            play: "Play",
            pause: "Pause",
            fastForward: "Forward {seektime}s",
            seek: "Seek",
            seekLabel: "{currentTime} of {duration}",
            played: "Played",
            buffered: "Buffered",
            currentTime: "Current time",
            duration: "Duration",
            volume: "Volume",
            mute: "Mute",
            unmute: "Unmute",
            enableCaptions: "Enable captions",
            disableCaptions: "Disable captions",
            download: "Download",
            enterFullscreen: "Enter fullscreen",
            exitFullscreen: "Exit fullscreen",
            frameTitle: "Player for {title}",
            captions: "Captions",
            settings: "Settings",
            pip: "PIP",
            menuBack: "Go back to previous menu",
            speed: "Speed",
            normal: "Normal",
            quality: "Quality",
            loop: "Loop",
            start: "Start",
            end: "End",
            all: "All",
            reset: "Reset",
            disabled: "Disabled",
            enabled: "Enabled",
            advertisement: "Ad",
            qualityBadge: {
                2160: "4K",
                1440: "HD",
                1080: "HD",
                720: "HD",
                576: "SD",
                480: "SD"
            }
        },
        urls: {
            download: null,
            vimeo: {
                sdk: "https://player.vimeo.com/api/player.js",
                iframe: "https://player.vimeo.com/video/{0}?{1}",
                api: "https://vimeo.com/api/oembed.json?url={0}"
            },
            youtube: {
                sdk: "https://www.youtube.com/iframe_api",
                api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
            },
            googleIMA: {
                sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
            }
        },
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        events: [
            "ended",
            "progress",
            "stalled",
            "playing",
            "waiting",
            "canplay",
            "canplaythrough",
            "loadstart",
            "loadeddata",
            "loadedmetadata",
            "timeupdate",
            "volumechange",
            "play",
            "pause",
            "error",
            "seeking",
            "seeked",
            "emptied",
            "ratechange",
            "cuechange",
            "download",
            "enterfullscreen",
            "exitfullscreen",
            "captionsenabled",
            "captionsdisabled",
            "languagechange",
            "controlshidden",
            "controlsshown",
            "ready",
            "statechange",
            "qualitychange",
            "adsloaded",
            "adscontentpause",
            "adscontentresume",
            "adstarted",
            "adsmidpoint",
            "adscomplete",
            "adsallcomplete",
            "adsimpression",
            "adsclick"
        ],
        selectors: {
            editable: "input, textarea, select, [contenteditable]",
            container: ".plyr",
            controls: {
                container: null,
                wrapper: ".plyr__controls"
            },
            labels: "[data-plyr]",
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: ".plyr__time--current",
                duration: ".plyr__time--duration",
                buffer: ".plyr__progress__buffer",
                loop: ".plyr__progress__loop",
                volume: ".plyr__volume--display"
            },
            progress: ".plyr__progress",
            captions: ".plyr__captions",
            caption: ".plyr__caption"
        },
        classNames: {
            type: "plyr--{0}",
            provider: "plyr--{0}",
            video: "plyr__video-wrapper",
            embed: "plyr__video-embed",
            videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
            embedContainer: "plyr__video-embed__container",
            poster: "plyr__poster",
            posterEnabled: "plyr__poster-enabled",
            ads: "plyr__ads",
            control: "plyr__control",
            controlPressed: "plyr__control--pressed",
            playing: "plyr--playing",
            paused: "plyr--paused",
            stopped: "plyr--stopped",
            loading: "plyr--loading",
            hover: "plyr--hover",
            tooltip: "plyr__tooltip",
            cues: "plyr__cues",
            marker: "plyr__progress__marker",
            hidden: "plyr__sr-only",
            hideControls: "plyr--hide-controls",
            isTouch: "plyr--is-touch",
            uiSupported: "plyr--full-ui",
            noTransition: "plyr--no-transition",
            display: {
                time: "plyr__time"
            },
            menu: {
                value: "plyr__menu__value",
                badge: "plyr__badge",
                open: "plyr--menu-open"
            },
            captions: {
                enabled: "plyr--captions-enabled",
                active: "plyr--captions-active"
            },
            fullscreen: {
                enabled: "plyr--fullscreen-enabled",
                fallback: "plyr--fullscreen-fallback"
            },
            pip: {
                supported: "plyr--pip-supported",
                active: "plyr--pip-active"
            },
            airplay: {
                supported: "plyr--airplay-supported",
                active: "plyr--airplay-active"
            },
            previewThumbnails: {
                thumbContainer: "plyr__preview-thumb",
                thumbContainerShown: "plyr__preview-thumb--is-shown",
                imageContainer: "plyr__preview-thumb__image-container",
                timeContainer: "plyr__preview-thumb__time-container",
                scrubbingContainer: "plyr__preview-scrubbing",
                scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
            }
        },
        attributes: {
            embed: {
                provider: "data-plyr-provider",
                id: "data-plyr-embed-id",
                hash: "data-plyr-embed-hash"
            }
        },
        ads: {
            enabled: !1,
            publisherId: "",
            tagUrl: ""
        },
        previewThumbnails: {
            enabled: !1,
            src: ""
        },
        vimeo: {
            byline: !1,
            portrait: !1,
            title: !1,
            speed: !0,
            transparent: !1,
            customControls: !0,
            referrerPolicy: null,
            premium: !1
        },
        youtube: {
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            customControls: !0,
            noCookie: !1
        },
        mediaMetadata: {
            title: "",
            artist: "",
            album: "",
            artwork: []
        },
        markers: {
            enabled: !1,
            points: []
        }
    }, Ie = "picture-in-picture", $e = "inline", _e = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo"
    }, Oe = "audio", je = "video";
    const qe = ()=>{};
    class De {
        constructor(e = !1){
            this.enabled = window.console && e, this.enabled && this.log("Debugging enabled");
        }
        get log() {
            return this.enabled ? Function.prototype.bind.call(console.log, console) : qe;
        }
        get warn() {
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : qe;
        }
        get error() {
            return this.enabled ? Function.prototype.bind.call(console.error, console) : qe;
        }
    }
    class He {
        constructor(t){
            e(this, "onChange", ()=>{
                if (!this.supported) return;
                const e = this.player.elements.buttons.fullscreen;
                S.element(e) && (e.pressed = this.active);
                const t = this.target === this.player.media ? this.target : this.player.elements.container;
                Z.call(this.player, t, this.active ? "enterfullscreen" : "exitfullscreen", !0);
            }), e(this, "toggleFallback", (e = !1)=>{
                if (e ? this.scrollPosition = {
                    x: window.scrollX ?? 0,
                    y: window.scrollY ?? 0
                } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = e ? "hidden" : "", R(this.target, this.player.config.classNames.fullscreen.fallback, e), M.isIos) {
                    let t = document.head.querySelector('meta[name="viewport"]');
                    const i = "viewport-fit=cover";
                    t || (t = document.createElement("meta"), t.setAttribute("name", "viewport"));
                    const s = S.string(t.content) && t.content.includes(i);
                    e ? (this.cleanupViewport = !s, s || (t.content += `,${i}`)) : this.cleanupViewport && (t.content = t.content.split(",").filter((e)=>e.trim() !== i).join(","));
                }
                this.onChange();
            }), e(this, "trapFocus", (e)=>{
                if (M.isIos || M.isIPadOS || !this.active || "Tab" !== e.key) return;
                const t = document.activeElement, i = U.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"), [s] = i, n = i[i.length - 1];
                t !== n || e.shiftKey ? t === s && e.shiftKey && (n.focus(), e.preventDefault()) : (s.focus(), e.preventDefault());
            }), e(this, "update", ()=>{
                if (this.supported) {
                    let e;
                    e = this.forceFallback ? "Fallback (forced)" : He.nativeSupported ? "Native" : "Fallback", this.player.debug.log(`${e} fullscreen enabled`);
                } else this.player.debug.log("Fullscreen not supported and fallback disabled");
                R(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.supported);
            }), e(this, "enter", ()=>{
                this.supported && (M.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !He.nativeSupported || this.forceFallback ? this.toggleFallback(!0) : this.prefix ? S.empty(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({
                    navigationUI: "hide"
                }));
            }), e(this, "exit", ()=>{
                if (this.supported) {
                    if (M.isIos && this.player.config.fullscreen.iosNative) this.player.isVimeo ? this.player.embed.exitFullscreen() : this.target.webkitEnterFullscreen(), ie(this.player.play());
                    else if (!He.nativeSupported || this.forceFallback) this.toggleFallback(!1);
                    else if (this.prefix) {
                        if (!S.empty(this.prefix)) {
                            const e = "moz" === this.prefix ? "Cancel" : "Exit";
                            document[`${this.prefix}${e}${this.property}`]();
                        }
                    } else (document.cancelFullScreen || document.exitFullscreen).call(document);
                }
            }), e(this, "toggle", ()=>{
                this.active ? this.exit() : this.enter();
            }), this.player = t, this.prefix = He.prefix, this.property = He.property, this.scrollPosition = {
                x: 0,
                y: 0
            }, this.forceFallback = "force" === t.config.fullscreen.fallback, this.player.elements.fullscreen = t.config.fullscreen.container && function(e, t) {
                const { prototype: i  } = Element;
                return (i.closest || function() {
                    let e = this;
                    do {
                        if (V.matches(e, t)) return e;
                        e = e.parentElement || e.parentNode;
                    }while (null !== e && 1 === e.nodeType);
                    return null;
                }).call(e, t);
            }(this.player.elements.container, t.config.fullscreen.container), X.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, ()=>{
                this.onChange();
            }), X.call(this.player, this.player.elements.container, "dblclick", (e)=>{
                S.element(this.player.elements.controls) && this.player.elements.controls.contains(e.target) || this.player.listeners.proxy(e, this.toggle, "fullscreen");
            }), X.call(this, this.player.elements.container, "keydown", (e)=>this.trapFocus(e)), this.update();
        }
        static get nativeSupported() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        get useNative() {
            return He.nativeSupported && !this.forceFallback;
        }
        static get prefix() {
            if (S.function(document.exitFullscreen)) return "";
            let e = "";
            return [
                "webkit",
                "moz",
                "ms"
            ].some((t)=>!(!S.function(document[`${t}ExitFullscreen`]) && !S.function(document[`${t}CancelFullScreen`])) && (e = t, !0)), e;
        }
        static get property() {
            return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
        }
        get supported() {
            return [
                this.player.config.fullscreen.enabled,
                this.player.isVideo,
                He.nativeSupported || this.player.config.fullscreen.fallback,
                !this.player.isYouTube || He.nativeSupported || !M.isIos || this.player.config.playsinline && !this.player.config.fullscreen.iosNative
            ].every(Boolean);
        }
        get active() {
            if (!this.supported) return !1;
            if (!He.nativeSupported || this.forceFallback) return F(this.target, this.player.config.classNames.fullscreen.fallback);
            const e = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
            return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
        }
        get target() {
            return M.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen ?? this.player.elements.container;
        }
    }
    function Re(e, t = 1) {
        return new Promise((i, s)=>{
            const n = new Image, a = ()=>{
                delete n.onload, delete n.onerror, (n.naturalWidth >= t ? i : s)(n);
            };
            Object.assign(n, {
                onload: a,
                onerror: a,
                src: e
            });
        });
    }
    const Fe = {
        addStyleHook () {
            R(this.elements.container, this.config.selectors.container.replace(".", ""), !0), R(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        toggleNativeControls (e = !1) {
            e && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
        },
        build () {
            if (this.listeners.media(), !this.supported.ui) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void Fe.toggleNativeControls.call(this, !0);
            S.element(this.elements.controls) || (Pe.inject.call(this), this.listeners.controls()), Fe.toggleNativeControls.call(this), this.isHTML5 && xe.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, Pe.updateVolume.call(this), Pe.timeUpdate.call(this), Pe.durationUpdate.call(this), Fe.checkPlaying.call(this), R(this.elements.container, this.config.classNames.pip.supported, K.pip && this.isHTML5 && this.isVideo), R(this.elements.container, this.config.classNames.airplay.supported, K.airplay && this.isHTML5), R(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(()=>{
                Z.call(this, this.media, "ready");
            }, 0), Fe.setTitle.call(this), this.poster && Fe.setPoster.call(this, this.poster, !1).catch(()=>{}), this.config.duration && Pe.durationUpdate.call(this), this.config.mediaMetadata && Pe.setMediaMetadata.call(this);
        },
        setTitle () {
            let e = ve.get("play", this.config);
            if (S.string(this.config.title) && !S.empty(this.config.title) && (e += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach((t)=>{
                t.setAttribute("aria-label", e);
            }), this.isEmbed) {
                const e = B.call(this, "iframe");
                if (!S.element(e)) return;
                const t = S.empty(this.config.title) ? "video" : this.config.title, i = ve.get("frameTitle", this.config);
                e.setAttribute("title", i.replace("{title}", t));
            }
        },
        togglePoster (e) {
            R(this.elements.container, this.config.classNames.posterEnabled, e);
        },
        setPoster (e, t = !0) {
            return t && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e), this.elements.poster.removeAttribute("hidden"), te.call(this).then(()=>Re(e)).catch((t)=>{
                throw e === this.poster && Fe.togglePoster.call(this, !1), t;
            }).then(()=>{
                if (e !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
            }).then(()=>(Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${e}')`,
                    backgroundSize: ""
                }), Fe.togglePoster.call(this, !0), e)));
        },
        checkPlaying (e) {
            R(this.elements.container, this.config.classNames.playing, this.playing), R(this.elements.container, this.config.classNames.paused, this.paused), R(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach((e)=>{
                Object.assign(e, {
                    pressed: this.playing
                }), e.setAttribute("aria-label", ve.get(this.playing ? "pause" : "play", this.config));
            }), S.event(e) && "timeupdate" === e.type || Fe.toggleControls.call(this);
        },
        checkLoading (e) {
            this.loading = [
                "stalled",
                "waiting"
            ].includes(e.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(()=>{
                R(this.elements.container, this.config.classNames.loading, this.loading), Fe.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        toggleControls (e) {
            const { controls: t  } = this.elements;
            if (t && this.config.hideControls) {
                const i = this.touch && this.lastSeekTime + 2e3 > Date.now();
                this.toggleControls(Boolean(e || this.loading || this.paused || t.pressed || t.hover || i));
            }
        },
        migrateStyles () {
            Object.values({
                ...this.media.style
            }).filter((e)=>!S.empty(e) && S.string(e) && e.startsWith("--plyr")).forEach((e)=>{
                this.elements.container.style.setProperty(e, this.media.style.getPropertyValue(e)), this.media.style.removeProperty(e);
            }), S.empty(this.media.style) && this.media.removeAttribute("style");
        }
    };
    class Ve {
        constructor(t){
            e(this, "firstTouch", ()=>{
                const { player: e  } = this, { elements: t  } = e;
                e.touch = !0, R(t.container, e.config.classNames.isTouch, !0);
            }), e(this, "global", (e = !0)=>{
                const { player: t  } = this;
                t.config.keyboard.global && Q.call(t, window, "keydown keyup", this.handleKey, e, !1), Q.call(t, document.body, "click", this.toggleMenu, e), G.call(t, document.body, "touchstart", this.firstTouch);
            }), e(this, "container", ()=>{
                const { player: e  } = this, { config: t , elements: i , timers: s  } = e;
                !t.keyboard.global && t.keyboard.focused && X.call(e, i.container, "keydown keyup", this.handleKey, !1), X.call(e, i.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (t)=>{
                    const { controls: n  } = i;
                    n && "enterfullscreen" === t.type && (n.pressed = !1, n.hover = !1);
                    let a = 0;
                    [
                        "touchstart",
                        "touchmove",
                        "mousemove"
                    ].includes(t.type) && (Fe.toggleControls.call(e, !0), a = e.touch ? 3e3 : 2e3), clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), a);
                });
                const n = ()=>{
                    if (!e.isVimeo || e.config.vimeo.premium) return;
                    const t = i.wrapper, { active: s  } = e.fullscreen, [n, a] = ce.call(e), l = ae(`aspect-ratio: ${n} / ${a}`);
                    if (!s) return void (l ? (t.style.width = null, t.style.height = null) : (t.style.maxWidth = null, t.style.margin = null));
                    const [r, o] = [
                        Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
                        Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
                    ], c = r / o > n / a;
                    l ? (t.style.width = c ? "auto" : "100%", t.style.height = c ? "100%" : "auto") : (t.style.maxWidth = c ? o / a * n + "px" : null, t.style.margin = c ? "0 auto" : null);
                }, a = ()=>{
                    clearTimeout(s.resized), s.resized = setTimeout(n, 50);
                };
                X.call(e, i.container, "enterfullscreen exitfullscreen", (t)=>{
                    const { target: s  } = e.fullscreen;
                    if (s !== i.container) return;
                    if (!e.isEmbed && S.empty(e.config.ratio)) return;
                    n();
                    ("enterfullscreen" === t.type ? X : J).call(e, window, "resize", a);
                });
            }), e(this, "media", ()=>{
                const { player: e  } = this, { elements: t  } = e;
                if (X.call(e, e.media, "timeupdate seeking seeked", (t)=>Pe.timeUpdate.call(e, t)), X.call(e, e.media, "durationchange loadeddata loadedmetadata", (t)=>Pe.durationUpdate.call(e, t)), X.call(e, e.media, "ended", ()=>{
                    e.isHTML5 && e.isVideo && e.config.resetOnEnd && (e.restart(), e.pause());
                }), X.call(e, e.media, "progress playing seeking seeked", (t)=>Pe.updateProgress.call(e, t)), X.call(e, e.media, "volumechange", (t)=>Pe.updateVolume.call(e, t)), X.call(e, e.media, "playing play pause ended emptied timeupdate", (t)=>Fe.checkPlaying.call(e, t)), X.call(e, e.media, "waiting canplay seeked playing", (t)=>Fe.checkLoading.call(e, t)), e.supported.ui && e.config.clickToPlay && !e.isAudio) {
                    const i = B.call(e, `.${e.config.classNames.video}`);
                    if (!S.element(i)) return;
                    X.call(e, t.container, "click", (s)=>{
                        ([
                            t.container,
                            i
                        ].includes(s.target) || i.contains(s.target)) && (e.touch && e.config.hideControls || (e.ended ? (this.proxy(s, e.restart, "restart"), this.proxy(s, ()=>{
                            ie(e.play());
                        }, "play")) : this.proxy(s, ()=>{
                            ie(e.togglePlay());
                        }, "play")));
                    });
                }
                e.supported.ui && e.config.disableContextMenu && X.call(e, t.wrapper, "contextmenu", (e)=>{
                    e.preventDefault();
                }, !1), X.call(e, e.media, "volumechange", ()=>{
                    e.storage.set({
                        volume: e.volume,
                        muted: e.muted
                    });
                }), X.call(e, e.media, "ratechange", ()=>{
                    Pe.updateSetting.call(e, "speed"), e.storage.set({
                        speed: e.speed
                    });
                }), X.call(e, e.media, "qualitychange", (t)=>{
                    Pe.updateSetting.call(e, "quality", null, t.detail.quality);
                }), X.call(e, e.media, "ready qualitychange", ()=>{
                    Pe.setDownloadUrl.call(e);
                });
                const i = e.config.events.concat([
                    "keyup",
                    "keydown"
                ]).join(" ");
                X.call(e, e.media, i, (i)=>{
                    let { detail: s = {}  } = i;
                    "error" === i.type && (s = e.media.error), Z.call(e, t.container, i.type, !0, s);
                });
            }), e(this, "proxy", (e, t, i)=>{
                const { player: s  } = this, n = s.config.listeners[i];
                let a = !0;
                S.function(n) && (a = n.call(s, e)), !1 !== a && S.function(t) && t.call(s, e);
            }), e(this, "bind", (e, t, i, s, n = !0)=>{
                const { player: a  } = this, l = a.config.listeners[s], r = S.function(l);
                X.call(a, e, t, (e)=>this.proxy(e, i, s), n && !r);
            }), e(this, "controls", ()=>{
                const { player: e  } = this, { elements: t  } = e, i = M.isIE ? "change" : "input";
                if (t.buttons.play && Array.from(t.buttons.play).forEach((t)=>{
                    this.bind(t, "click", ()=>{
                        ie(e.togglePlay());
                    }, "play");
                }), this.bind(t.buttons.restart, "click", e.restart, "restart"), this.bind(t.buttons.rewind, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.rewind();
                }, "rewind"), this.bind(t.buttons.fastForward, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.forward();
                }, "fastForward"), this.bind(t.buttons.mute, "click", ()=>{
                    e.muted = !e.muted;
                }, "mute"), this.bind(t.buttons.captions, "click", ()=>e.toggleCaptions()), this.bind(t.buttons.download, "click", ()=>{
                    Z.call(e, e.media, "download");
                }, "download"), this.bind(t.buttons.fullscreen, "click", ()=>{
                    e.fullscreen.toggle();
                }, "fullscreen"), this.bind(t.buttons.pip, "click", ()=>{
                    e.pip = "toggle";
                }, "pip"), this.bind(t.buttons.airplay, "click", e.airplay, "airplay"), this.bind(t.buttons.settings, "click", (t)=>{
                    t.stopPropagation(), t.preventDefault(), Pe.toggleMenu.call(e, t);
                }, null, !1), this.bind(t.buttons.settings, "keyup", (t)=>{
                    [
                        " ",
                        "Enter"
                    ].includes(t.key) && ("Enter" !== t.key ? (t.preventDefault(), t.stopPropagation(), Pe.toggleMenu.call(e, t)) : Pe.focusFirstMenuItem.call(e, null, !0));
                }, null, !1), this.bind(t.settings.menu, "keydown", (t)=>{
                    "Escape" === t.key && Pe.toggleMenu.call(e, t);
                }), this.bind(t.inputs.seek, "mousedown mousemove", (e)=>{
                    const i = t.progress.getBoundingClientRect(), s = 100 / i.width * (e.pageX - i.left);
                    e.currentTarget.setAttribute("seek-value", s);
                }), this.bind(t.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (t)=>{
                    const i = t.currentTarget, s = "play-on-seeked";
                    if (S.keyboardEvent(t) && ![
                        "ArrowLeft",
                        "ArrowRight"
                    ].includes(t.key)) return;
                    e.lastSeekTime = Date.now();
                    const n = i.hasAttribute(s), a = [
                        "mouseup",
                        "touchend",
                        "keyup"
                    ].includes(t.type);
                    n && a ? (i.removeAttribute(s), ie(e.play())) : !a && e.playing && (i.setAttribute(s, ""), e.pause());
                }), M.isIos) {
                    const t = U.call(e, 'input[type="range"]');
                    Array.from(t).forEach((e)=>this.bind(e, i, (e)=>P(e.target)));
                }
                this.bind(t.inputs.seek, i, (t)=>{
                    const i = t.currentTarget;
                    let s = i.getAttribute("seek-value");
                    S.empty(s) && (s = i.value), i.removeAttribute("seek-value"), e.currentTime = s / i.max * e.duration;
                }, "seek"), this.bind(t.progress, "mouseenter mouseleave mousemove", (t)=>Pe.updateSeekTooltip.call(e, t)), this.bind(t.progress, "mousemove touchmove", (t)=>{
                    const { previewThumbnails: i  } = e;
                    i && i.loaded && i.startMove(t);
                }), this.bind(t.progress, "mouseleave touchend click", ()=>{
                    const { previewThumbnails: t  } = e;
                    t && t.loaded && t.endMove(!1, !0);
                }), this.bind(t.progress, "mousedown touchstart", (t)=>{
                    const { previewThumbnails: i  } = e;
                    i && i.loaded && i.startScrubbing(t);
                }), this.bind(t.progress, "mouseup touchend", (t)=>{
                    const { previewThumbnails: i  } = e;
                    i && i.loaded && i.endScrubbing(t);
                }), M.isWebKit && Array.from(U.call(e, 'input[type="range"]')).forEach((t)=>{
                    this.bind(t, "input", (t)=>Pe.updateRangeFill.call(e, t.target));
                }), e.config.toggleInvert && !S.element(t.display.duration) && this.bind(t.display.currentTime, "click", ()=>{
                    0 !== e.currentTime && (e.config.invertTime = !e.config.invertTime, Pe.timeUpdate.call(e));
                }), this.bind(t.inputs.volume, i, (t)=>{
                    e.volume = t.target.value;
                }, "volume"), this.bind(t.controls, "mouseenter mouseleave", (i)=>{
                    t.controls.hover = !e.touch && "mouseenter" === i.type;
                }), t.fullscreen && Array.from(t.fullscreen.children).filter((e)=>!e.contains(t.container)).forEach((i)=>{
                    this.bind(i, "mouseenter mouseleave", (i)=>{
                        t.controls && (t.controls.hover = !e.touch && "mouseenter" === i.type);
                    });
                }), this.bind(t.controls, "mousedown mouseup touchstart touchend touchcancel", (e)=>{
                    t.controls.pressed = [
                        "mousedown",
                        "touchstart"
                    ].includes(e.type);
                }), this.bind(t.controls, "focusin", ()=>{
                    const { config: i , timers: s  } = e;
                    R(t.controls, i.classNames.noTransition, !0), Fe.toggleControls.call(e, !0), setTimeout(()=>{
                        R(t.controls, i.classNames.noTransition, !1);
                    }, 0);
                    const n = this.touch ? 3e3 : 4e3;
                    clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), n);
                }), this.bind(t.inputs.volume, "wheel", (t)=>{
                    const i = t.webkitDirectionInvertedFromDevice, [s, n] = [
                        t.deltaX,
                        -t.deltaY
                    ].map((e)=>i ? -e : e), a = Math.sign(Math.abs(s) > Math.abs(n) ? s : n);
                    e.increaseVolume(a / 50);
                    const { volume: l  } = e.media;
                    (1 === a && l < 1 || -1 === a && l > 0) && t.preventDefault();
                }, "volume", !1);
            }), this.player = t, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.firstTouch = this.firstTouch.bind(this);
        }
        handleKey(e) {
            const { player: t  } = this, { elements: i  } = t, { key: s , type: n , altKey: a , ctrlKey: l , metaKey: r , shiftKey: o  } = e, c = "keydown" === n, u = c && s === this.lastKey;
            if (a || l || r || o) return;
            if (!s) return;
            if (c) {
                const n = document.activeElement;
                if (S.element(n)) {
                    const { editable: s  } = t.config.selectors, { seek: a  } = i.inputs;
                    if (n !== a && V(n, s)) return;
                    if (" " === e.key && V(n, 'button, [role^="menuitem"]')) return;
                }
                switch([
                    " ",
                    "ArrowLeft",
                    "ArrowUp",
                    "ArrowRight",
                    "ArrowDown",
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "c",
                    "f",
                    "k",
                    "l",
                    "m"
                ].includes(s) && (e.preventDefault(), e.stopPropagation()), s){
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        u || (h = parseInt(s, 10), t.currentTime = t.duration / 10 * h);
                        break;
                    case " ":
                    case "k":
                        u || ie(t.togglePlay());
                        break;
                    case "ArrowUp":
                        t.increaseVolume(.1);
                        break;
                    case "ArrowDown":
                        t.decreaseVolume(.1);
                        break;
                    case "m":
                        u || (t.muted = !t.muted);
                        break;
                    case "ArrowRight":
                        t.forward();
                        break;
                    case "ArrowLeft":
                        t.rewind();
                        break;
                    case "f":
                        t.fullscreen.toggle();
                        break;
                    case "c":
                        u || t.toggleCaptions();
                        break;
                    case "l":
                        t.loop = !t.loop;
                }
                "Escape" === s && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(), this.lastKey = s;
            } else this.lastKey = null;
            var h;
        }
        toggleMenu(e) {
            Pe.toggleMenu.call(this.player, e);
        }
    }
    "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
    var Ue = function(e, t) {
        return e(t = {
            exports: {}
        }, t.exports), t.exports;
    }(function(e, t) {
        e.exports = function() {
            var e = function() {}, t = {}, i = {}, s = {};
            function n(e, t) {
                e = e.push ? e : [
                    e
                ];
                var n, a, l, r = [], o = e.length, c = o;
                for(n = function(e, i) {
                    i.length && r.push(e), --c || t(r);
                }; o--;)a = e[o], (l = i[a]) ? n(a, l) : (s[a] = s[a] || []).push(n);
            }
            function a(e, t) {
                if (e) {
                    var n = s[e];
                    if (i[e] = t, n) for(; n.length;)n[0](e, t), n.splice(0, 1);
                }
            }
            function l(t, i) {
                t.call && (t = {
                    success: t
                }), i.length ? (t.error || e)(i) : (t.success || e)(t);
            }
            function r(t, i, s, n) {
                var a, l, o = document, c = s.async, u = (s.numRetries || 0) + 1, h = s.before || e, d = t.replace(/[\?|#].*$/, ""), m = t.replace(/^(css|img)!/, "");
                n = n || 0, /(^css!|\.css$)/.test(d) ? ((l = o.createElement("link")).rel = "stylesheet", l.href = m, (a = "hideFocus" in l) && l.relList && (a = 0, l.rel = "preload", l.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d) ? (l = o.createElement("img")).src = m : ((l = o.createElement("script")).src = t, l.async = void 0 === c || c), l.onload = l.onerror = l.onbeforeload = function(e) {
                    var o = e.type[0];
                    if (a) try {
                        l.sheet.cssText.length || (o = "e");
                    } catch (e) {
                        18 != e.code && (o = "e");
                    }
                    if ("e" == o) {
                        if ((n += 1) < u) return r(t, i, s, n);
                    } else if ("preload" == l.rel && "style" == l.as) return l.rel = "stylesheet";
                    i(t, o, e.defaultPrevented);
                }, !1 !== h(t, l) && o.head.appendChild(l);
            }
            function o(e, t, i) {
                var s, n, a = (e = e.push ? e : [
                    e
                ]).length, l = a, o = [];
                for(s = function(e, i, s) {
                    if ("e" == i && o.push(e), "b" == i) {
                        if (!s) return;
                        o.push(e);
                    }
                    --a || t(o);
                }, n = 0; n < l; n++)r(e[n], s, i);
            }
            function c(e, i, s) {
                var n, r;
                if (i && i.trim && (n = i), r = (n ? s : i) || {}, n) {
                    if (n in t) throw "LoadJS";
                    t[n] = !0;
                }
                function c(t, i) {
                    o(e, function(e) {
                        l(r, e), t && l({
                            success: t,
                            error: i
                        }, e), a(n, e);
                    }, r);
                }
                if (r.returnPromise) return new Promise(c);
                c();
            }
            return c.ready = function(e, t) {
                return n(e, function(e) {
                    l(t, e);
                }), c;
            }, c.done = function(e) {
                a(e, []);
            }, c.reset = function() {
                t = {}, i = {}, s = {};
            }, c.isDefined = function(e) {
                return e in t;
            }, c;
        }();
    });
    function Be(e) {
        return new Promise((t, i)=>{
            Ue(e, {
                success: t,
                error: i
            });
        });
    }
    function We(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    const ze = {
        setup () {
            const e = this;
            R(e.elements.wrapper, e.config.classNames.embed, !0), e.options.speed = e.config.speed.options, ue.call(e), S.object(window.Vimeo) ? ze.ready.call(e) : Be(e.config.urls.vimeo.sdk).then(()=>{
                ze.ready.call(e);
            }).catch((t)=>{
                e.debug.warn("Vimeo SDK (player.js) failed to load", t);
            });
        },
        ready () {
            const e = this, t = e.config.vimeo, { premium: i , referrerPolicy: s , ...n } = t;
            let a = e.media.getAttribute("src"), l = "";
            S.empty(a) ? (a = e.media.getAttribute(e.config.attributes.embed.id), l = e.media.getAttribute(e.config.attributes.embed.hash)) : l = function(e) {
                const t = e.match(/^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/);
                return t && 5 === t.length ? t[4] : null;
            }(a);
            const r = l ? {
                h: l
            } : {};
            i && Object.assign(n, {
                controls: !1,
                sidedock: !1
            });
            const o = Ne({
                loop: e.config.loop.active,
                autoplay: e.autoplay,
                muted: e.muted,
                gesture: "media",
                playsinline: e.config.playsinline,
                ...r,
                ...n
            }), c = (u = a, S.empty(u) ? null : S.number(Number(u)) ? u : u.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : u);
            var u;
            const h = $("iframe"), d = me(e.config.urls.vimeo.iframe, c, o);
            if (h.setAttribute("src", d), h.setAttribute("allowfullscreen", ""), h.setAttribute("allow", [
                "autoplay",
                "fullscreen",
                "picture-in-picture",
                "encrypted-media",
                "accelerometer",
                "gyroscope"
            ].join("; ")), S.empty(s) || h.setAttribute("referrerPolicy", s), i || !t.customControls) h.setAttribute("data-poster", e.poster), e.media = q(h, e.media);
            else {
                const t = $("div", {
                    class: e.config.classNames.embedContainer,
                    "data-poster": e.poster
                });
                t.appendChild(h), e.media = q(t, e.media);
            }
            t.customControls || Te(me(e.config.urls.vimeo.api, d)).then((t)=>{
                !S.empty(t) && t.thumbnail_url && Fe.setPoster.call(e, t.thumbnail_url).catch(()=>{});
            }), e.embed = new window.Vimeo.Player(h, {
                autopause: e.config.autopause,
                muted: e.muted
            }), e.media.paused = !0, e.media.currentTime = 0, e.supported.ui && e.embed.disableTextTrack(), e.media.play = ()=>(We.call(e, !0), e.embed.play()), e.media.pause = ()=>(We.call(e, !1), e.embed.pause()), e.media.stop = ()=>{
                e.pause(), e.currentTime = 0;
            };
            let { currentTime: m  } = e.media;
            Object.defineProperty(e.media, "currentTime", {
                get: ()=>m,
                set (t) {
                    const { embed: i , media: s , paused: n , volume: a  } = e, l = n && !i.hasPlayed;
                    s.seeking = !0, Z.call(e, s, "seeking"), Promise.resolve(l && i.setVolume(0)).then(()=>i.setCurrentTime(t)).then(()=>l && i.pause()).then(()=>l && i.setVolume(a)).catch(()=>{});
                }
            });
            let p = e.config.speed.selected;
            Object.defineProperty(e.media, "playbackRate", {
                get: ()=>p,
                set (t) {
                    e.embed.setPlaybackRate(t).then(()=>{
                        p = t, Z.call(e, e.media, "ratechange");
                    }).catch(()=>{
                        e.options.speed = [
                            1
                        ];
                    });
                }
            });
            let { volume: g  } = e.config;
            Object.defineProperty(e.media, "volume", {
                get: ()=>g,
                set (t) {
                    e.embed.setVolume(t).then(()=>{
                        g = t, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let { muted: f  } = e.config;
            Object.defineProperty(e.media, "muted", {
                get: ()=>f,
                set (t) {
                    const i = !!S.boolean(t) && t;
                    e.embed.setMuted(!!i || e.config.muted).then(()=>{
                        f = i, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let y, { loop: b  } = e.config;
            Object.defineProperty(e.media, "loop", {
                get: ()=>b,
                set (t) {
                    const i = S.boolean(t) ? t : e.config.loop.active;
                    e.embed.setLoop(i).then(()=>{
                        b = i;
                    });
                }
            }), e.embed.getVideoUrl().then((t)=>{
                y = t, Pe.setDownloadUrl.call(e);
            }).catch((e)=>{
                this.debug.warn(e);
            }), Object.defineProperty(e.media, "currentSrc", {
                get: ()=>y
            }), Object.defineProperty(e.media, "ended", {
                get: ()=>e.currentTime === e.duration
            }), Promise.all([
                e.embed.getVideoWidth(),
                e.embed.getVideoHeight()
            ]).then((t)=>{
                const [i, s] = t;
                e.embed.ratio = he(i, s), ue.call(this);
            }), e.embed.setAutopause(e.config.autopause).then((t)=>{
                e.config.autopause = t;
            }), e.embed.getVideoTitle().then((t)=>{
                e.config.title = t, Fe.setTitle.call(this);
            }), e.embed.getCurrentTime().then((t)=>{
                m = t, Z.call(e, e.media, "timeupdate");
            }), e.embed.getDuration().then((t)=>{
                e.media.duration = t, Z.call(e, e.media, "durationchange");
            }), e.embed.getTextTracks().then((t)=>{
                e.media.textTracks = t, xe.setup.call(e);
            }), e.embed.on("cuechange", ({ cues: t = []  })=>{
                const i = t.map((e)=>(function(e) {
                        const t = document.createDocumentFragment(), i = document.createElement("div");
                        return t.appendChild(i), i.innerHTML = e, t.firstChild.innerText;
                    })(e.text));
                xe.updateCues.call(e, i);
            }), e.embed.on("loaded", ()=>{
                if (e.embed.getPaused().then((t)=>{
                    We.call(e, !t), t || Z.call(e, e.media, "playing");
                }), S.element(e.embed.element) && e.supported.ui) e.embed.element.setAttribute("tabindex", -1);
            }), e.embed.on("bufferstart", ()=>{
                Z.call(e, e.media, "waiting");
            }), e.embed.on("bufferend", ()=>{
                Z.call(e, e.media, "playing");
            }), e.embed.on("play", ()=>{
                We.call(e, !0), Z.call(e, e.media, "playing");
            }), e.embed.on("pause", ()=>{
                We.call(e, !1);
            }), e.embed.on("timeupdate", (t)=>{
                e.media.seeking = !1, m = t.seconds, Z.call(e, e.media, "timeupdate");
            }), e.embed.on("progress", (t)=>{
                e.media.buffered = t.percent, Z.call(e, e.media, "progress"), 1 === parseInt(t.percent, 10) && Z.call(e, e.media, "canplaythrough"), e.embed.getDuration().then((t)=>{
                    t !== e.media.duration && (e.media.duration = t, Z.call(e, e.media, "durationchange"));
                });
            }), e.embed.on("seeked", ()=>{
                e.media.seeking = !1, Z.call(e, e.media, "seeked");
            }), e.embed.on("ended", ()=>{
                e.media.paused = !0, Z.call(e, e.media, "ended");
            }), e.embed.on("error", (t)=>{
                e.media.error = t, Z.call(e, e.media, "error");
            }), t.customControls && setTimeout(()=>Fe.build.call(e), 0);
        }
    };
    function Ke(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    function Ye(e) {
        return e.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0;
    }
    const Qe = {
        setup () {
            if (R(this.elements.wrapper, this.config.classNames.embed, !0), S.object(window.YT) && S.function(window.YT.Player)) Qe.ready.call(this);
            else {
                const e = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = ()=>{
                    S.function(e) && e(), Qe.ready.call(this);
                }, Be(this.config.urls.youtube.sdk).catch((e)=>{
                    this.debug.warn("YouTube API failed to load", e);
                });
            }
        },
        getTitle (e) {
            Te(me(this.config.urls.youtube.api, e)).then((e)=>{
                if (S.object(e)) {
                    const { title: t , height: i , width: s  } = e;
                    this.config.title = t, Fe.setTitle.call(this), this.embed.ratio = he(s, i);
                }
                ue.call(this);
            }).catch(()=>{
                ue.call(this);
            });
        },
        ready () {
            const e = this, t = e.config.youtube, i = e.media && e.media.getAttribute("id");
            if (!S.empty(i) && i.startsWith("youtube-")) return;
            let s = e.media.getAttribute("src");
            S.empty(s) && (s = e.media.getAttribute(this.config.attributes.embed.id));
            const n = (a = s, S.empty(a) ? null : a.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : a);
            var a;
            const l = $("div", {
                id: `${e.provider}-${Math.floor(1e4 * Math.random())}`,
                "data-poster": t.customControls ? e.poster : void 0
            });
            if (e.media = q(l, e.media), t.customControls) {
                const t = (e)=>`https://i.ytimg.com/vi/${n}/${e}default.jpg`;
                Re(t("maxres"), 121).catch(()=>Re(t("sd"), 121)).catch(()=>Re(t("hq"))).then((t)=>Fe.setPoster.call(e, t.src)).then((t)=>{
                    t.includes("maxres") || (e.elements.poster.style.backgroundSize = "cover");
                }).catch(()=>{});
            }
            e.embed = new window.YT.Player(e.media, {
                videoId: n,
                host: Ye(t),
                playerVars: x({}, {
                    autoplay: e.config.autoplay ? 1 : 0,
                    hl: e.config.hl,
                    controls: e.supported.ui && t.customControls ? 0 : 1,
                    disablekb: 1,
                    playsinline: e.config.playsinline && !e.config.fullscreen.iosNative ? 1 : 0,
                    cc_load_policy: e.captions.active ? 1 : 0,
                    cc_lang_pref: e.config.captions.language,
                    widget_referrer: window ? window.location.href : null
                }, t),
                events: {
                    onError (t) {
                        if (!e.media.error) {
                            const i = t.data, s = {
                                2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                101: "The owner of the requested video does not allow it to be played in embedded players.",
                                150: "The owner of the requested video does not allow it to be played in embedded players."
                            }[i] || "An unknown error occurred";
                            e.media.error = {
                                code: i,
                                message: s
                            }, Z.call(e, e.media, "error");
                        }
                    },
                    onPlaybackRateChange (t) {
                        const i = t.target;
                        e.media.playbackRate = i.getPlaybackRate(), Z.call(e, e.media, "ratechange");
                    },
                    onReady (i) {
                        if (S.function(e.media.play)) return;
                        const s = i.target;
                        Qe.getTitle.call(e, n), e.media.play = ()=>{
                            Ke.call(e, !0), s.playVideo();
                        }, e.media.pause = ()=>{
                            Ke.call(e, !1), s.pauseVideo();
                        }, e.media.stop = ()=>{
                            s.stopVideo();
                        }, e.media.duration = s.getDuration(), e.media.paused = !0, e.media.currentTime = 0, Object.defineProperty(e.media, "currentTime", {
                            get: ()=>Number(s.getCurrentTime()),
                            set (t) {
                                e.paused && !e.embed.hasPlayed && e.embed.mute(), e.media.seeking = !0, Z.call(e, e.media, "seeking"), s.seekTo(t);
                            }
                        }), Object.defineProperty(e.media, "playbackRate", {
                            get: ()=>s.getPlaybackRate(),
                            set (e) {
                                s.setPlaybackRate(e);
                            }
                        });
                        let { volume: a  } = e.config;
                        Object.defineProperty(e.media, "volume", {
                            get: ()=>a,
                            set (t) {
                                a = t, s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        });
                        let { muted: l  } = e.config;
                        Object.defineProperty(e.media, "muted", {
                            get: ()=>l,
                            set (t) {
                                const i = S.boolean(t) ? t : l;
                                l = i, s[i ? "mute" : "unMute"](), s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        }), Object.defineProperty(e.media, "currentSrc", {
                            get: ()=>s.getVideoUrl()
                        }), Object.defineProperty(e.media, "ended", {
                            get: ()=>e.currentTime === e.duration
                        });
                        const r = s.getAvailablePlaybackRates();
                        e.options.speed = r.filter((t)=>e.config.speed.options.includes(t)), e.supported.ui && t.customControls && e.media.setAttribute("tabindex", -1), Z.call(e, e.media, "timeupdate"), Z.call(e, e.media, "durationchange"), clearInterval(e.timers.buffering), e.timers.buffering = setInterval(()=>{
                            e.media.buffered = s.getVideoLoadedFraction(), (null === e.media.lastBuffered || e.media.lastBuffered < e.media.buffered) && Z.call(e, e.media, "progress"), e.media.lastBuffered = e.media.buffered, 1 === e.media.buffered && (clearInterval(e.timers.buffering), Z.call(e, e.media, "canplaythrough"));
                        }, 200), t.customControls && setTimeout(()=>Fe.build.call(e), 50);
                    },
                    onStateChange (i) {
                        const s = i.target;
                        clearInterval(e.timers.playing);
                        switch(e.media.seeking && [
                            1,
                            2
                        ].includes(i.data) && (e.media.seeking = !1, Z.call(e, e.media, "seeked")), i.data){
                            case -1:
                                Z.call(e, e.media, "timeupdate"), e.media.buffered = s.getVideoLoadedFraction(), Z.call(e, e.media, "progress");
                                break;
                            case 0:
                                Ke.call(e, !1), e.media.loop ? (s.stopVideo(), s.playVideo()) : Z.call(e, e.media, "ended");
                                break;
                            case 1:
                                t.customControls && !e.config.autoplay && e.media.paused && !e.embed.hasPlayed ? e.media.pause() : (Ke.call(e, !0), Z.call(e, e.media, "playing"), e.timers.playing = setInterval(()=>{
                                    Z.call(e, e.media, "timeupdate");
                                }, 50), e.media.duration !== s.getDuration() && (e.media.duration = s.getDuration(), Z.call(e, e.media, "durationchange")));
                                break;
                            case 2:
                                e.muted || e.embed.unMute(), Ke.call(e, !1);
                                break;
                            case 3:
                                Z.call(e, e.media, "waiting");
                        }
                        Z.call(e, e.elements.container, "statechange", !1, {
                            code: i.data
                        });
                    }
                }
            });
        }
    }, Xe = {
        setup () {
            this.media ? (R(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), R(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && R(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = $("div", {
                class: this.config.classNames.video
            }), L(this.media, this.elements.wrapper), this.elements.poster = $("div", {
                class: this.config.classNames.poster
            }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? de.setup.call(this) : this.isYouTube ? Qe.setup.call(this) : this.isVimeo && ze.setup.call(this)) : this.debug.warn("No media element found!");
        }
    };
    class Je {
        constructor(t){
            e(this, "load", ()=>{
                this.enabled && (S.object(window.google) && S.object(window.google.ima) ? this.ready() : Be(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    this.trigger("error", new Error("Google IMA SDK failed to load"));
                }));
            }), e(this, "ready", ()=>{
                var e;
                this.enabled || ((e = this).manager && e.manager.destroy(), e.elements.displayContainer && e.elements.displayContainer.destroy(), e.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(()=>{
                    this.clearSafetyTimer("onAdsManagerLoaded()");
                }), this.listeners(), this.setupIMA();
            }), e(this, "setupIMA", ()=>{
                this.elements.container = $("div", {
                    class: this.player.config.classNames.ads
                }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (e)=>this.onAdsManagerLoaded(e), !1), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e), !1), this.requestAds();
            }), e(this, "requestAds", ()=>{
                const { container: e  } = this.player.elements;
                try {
                    const t = new google.ima.AdsRequest;
                    t.adTagUrl = this.tagUrl, t.linearAdSlotWidth = e.offsetWidth, t.linearAdSlotHeight = e.offsetHeight, t.nonLinearAdSlotWidth = e.offsetWidth, t.nonLinearAdSlotHeight = e.offsetHeight, t.forceNonLinearFullSlot = !1, t.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(t);
                } catch (e) {
                    this.onAdError(e);
                }
            }), e(this, "pollCountdown", (e = !1)=>{
                if (!e) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
                this.countdownTimer = setInterval(()=>{
                    const e = Ee(Math.max(this.manager.getRemainingTime(), 0)), t = `${ve.get("advertisement", this.player.config)} - ${e}`;
                    this.elements.container.setAttribute("data-badge-text", t);
                }, 100);
            }), e(this, "onAdsManagerLoaded", (e)=>{
                if (!this.enabled) return;
                const t = new google.ima.AdsRenderingSettings;
                t.restoreCustomPlaybackStateOnAdBreakComplete = !0, t.enablePreloading = !0, this.manager = e.getAdsManager(this.player, t), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e)), Object.keys(google.ima.AdEvent.Type).forEach((e)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[e], (e)=>this.onAdEvent(e));
                }), this.trigger("loaded");
            }), e(this, "addCuePoints", ()=>{
                S.empty(this.cuePoints) || this.cuePoints.forEach((e)=>{
                    if (0 !== e && -1 !== e && e < this.player.duration) {
                        const t = this.player.elements.progress;
                        if (S.element(t)) {
                            const i = 100 / this.player.duration * e, s = $("span", {
                                class: this.player.config.classNames.cues
                            });
                            s.style.left = `${i.toString()}%`, t.appendChild(s);
                        }
                    }
                });
            }), e(this, "onAdEvent", (e)=>{
                const { container: t  } = this.player.elements, i = e.getAd(), s = e.getAdData();
                switch(((e)=>{
                    Z.call(this.player, this.player.media, `ads${e.replace(/_/g, "").toLowerCase()}`);
                })(e.type), e.type){
                    case google.ima.AdEvent.Type.LOADED:
                        this.trigger("loaded"), this.pollCountdown(!0), i.isLinear() || (i.width = t.offsetWidth, i.height = t.offsetHeight);
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        this.player.ended ? this.loadAds() : this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        this.pollCountdown(), this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        s.adError && this.player.debug.warn(`Non-fatal ad error: ${s.adError.getMessage()}`);
                }
            }), e(this, "onAdError", (e)=>{
                this.cancel(), this.player.debug.warn("Ads error", e);
            }), e(this, "listeners", ()=>{
                const { container: e  } = this.player.elements;
                let t;
                this.player.on("canplay", ()=>{
                    this.addCuePoints();
                }), this.player.on("ended", ()=>{
                    this.loader.contentComplete();
                }), this.player.on("timeupdate", ()=>{
                    t = this.player.currentTime;
                }), this.player.on("seeked", ()=>{
                    const e = this.player.currentTime;
                    S.empty(this.cuePoints) || this.cuePoints.forEach((i, s)=>{
                        t < i && i < e && (this.manager.discardAdBreak(), this.cuePoints.splice(s, 1));
                    });
                }), window.addEventListener("resize", ()=>{
                    this.manager && this.manager.resize(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            }), e(this, "play", ()=>{
                const { container: e  } = this.player.elements;
                this.managerPromise || this.resumeContent(), this.managerPromise.then(()=>{
                    this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
                    try {
                        this.initialized || (this.manager.init(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = !0;
                    } catch (e) {
                        this.onAdError(e);
                    }
                }).catch(()=>{});
            }), e(this, "resumeContent", ()=>{
                this.elements.container.style.zIndex = "", this.playing = !1, ie(this.player.media.play());
            }), e(this, "pauseContent", ()=>{
                this.elements.container.style.zIndex = 3, this.playing = !0, this.player.media.pause();
            }), e(this, "cancel", ()=>{
                this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
            }), e(this, "loadAds", ()=>{
                this.managerPromise.then(()=>{
                    this.manager && this.manager.destroy(), this.managerPromise = new Promise((e)=>{
                        this.on("loaded", e), this.player.debug.log(this.manager);
                    }), this.initialized = !1, this.requestAds();
                }).catch(()=>{});
            }), e(this, "trigger", (e, ...t)=>{
                const i = this.events[e];
                S.array(i) && i.forEach((e)=>{
                    S.function(e) && e.apply(this, t);
                });
            }), e(this, "on", (e, t)=>(S.array(this.events[e]) || (this.events[e] = []), this.events[e].push(t), this)), e(this, "startSafetyTimer", (e, t)=>{
                this.player.debug.log(`Safety timer invoked from: ${t}`), this.safetyTimer = setTimeout(()=>{
                    this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
                }, e);
            }), e(this, "clearSafetyTimer", (e)=>{
                S.nullOrUndefined(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${e}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
            }), this.player = t, this.config = t.config.ads, this.playing = !1, this.initialized = !1, this.elements = {
                container: null,
                displayContainer: null
            }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise((e, t)=>{
                this.on("loaded", e), this.on("error", t);
            }), this.load();
        }
        get enabled() {
            const { config: e  } = this;
            return this.player.isHTML5 && this.player.isVideo && e.enabled && (!S.empty(e.publisherId) || S.url(e.tagUrl));
        }
        get tagUrl() {
            const { config: e  } = this;
            if (S.url(e.tagUrl)) return e.tagUrl;
            return `https://go.aniview.com/api/adserver6/vast/?${Ne({
                AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                AV_CHANNELID: "5a0458dc28a06145e4519d21",
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: e.publisherId
            })}`;
        }
    }
    function Ge(e = 0, t = 0, i = 255) {
        return Math.min(Math.max(e, t), i);
    }
    const Ze = (e)=>{
        const t = [];
        return e.split(/\r\n\r\n|\n\n|\r\r/).forEach((e)=>{
            const i = {};
            e.split(/\r\n|\n|\r/).forEach((e)=>{
                if (S.number(i.startTime)) {
                    if (!S.empty(e.trim()) && S.empty(i.text)) {
                        const t = e.trim().split("#xywh=");
                        [i.text] = t, t[1] && ([i.x, i.y, i.w, i.h] = t[1].split(","));
                    }
                } else {
                    const t = e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                    t && (i.startTime = 60 * Number(t[1] || 0) * 60 + 60 * Number(t[2]) + Number(t[3]) + Number(`0.${t[4]}`), i.endTime = 60 * Number(t[6] || 0) * 60 + 60 * Number(t[7]) + Number(t[8]) + Number(`0.${t[9]}`));
                }
            }), i.text && t.push(i);
        }), t;
    }, et = (e, t)=>{
        const i = {};
        return e > t.width / t.height ? (i.width = t.width, i.height = 1 / e * t.width) : (i.height = t.height, i.width = e * t.height), i;
    };
    class tt {
        constructor(t){
            e(this, "load", ()=>{
                this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then(()=>{
                    this.enabled && (this.render(), this.determineContainerAutoSizing(), this.listeners(), this.loaded = !0);
                });
            }), e(this, "getThumbnails", ()=>new Promise((e)=>{
                    const { src: t  } = this.player.config.previewThumbnails;
                    if (S.empty(t)) throw new Error("Missing previewThumbnails.src config attribute");
                    const i = ()=>{
                        this.thumbnails.sort((e, t)=>e.height - t.height), this.player.debug.log("Preview thumbnails", this.thumbnails), e();
                    };
                    if (S.function(t)) t((e)=>{
                        this.thumbnails = e, i();
                    });
                    else {
                        const e = (S.string(t) ? [
                            t
                        ] : t).map((e)=>this.getThumbnail(e));
                        Promise.all(e).then(i);
                    }
                })), e(this, "getThumbnail", (e)=>new Promise((t)=>{
                    Te(e).then((i)=>{
                        const s = {
                            frames: Ze(i),
                            height: null,
                            urlPrefix: ""
                        };
                        s.frames[0].text.startsWith("/") || s.frames[0].text.startsWith("http://") || s.frames[0].text.startsWith("https://") || (s.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                        const n = new Image;
                        n.onload = ()=>{
                            s.height = n.naturalHeight, s.width = n.naturalWidth, this.thumbnails.push(s), t();
                        }, n.src = s.urlPrefix + s.frames[0].text;
                    });
                })), e(this, "startMove", (e)=>{
                if (this.loaded && S.event(e) && [
                    "touchmove",
                    "mousemove"
                ].includes(e.type) && this.player.media.duration) {
                    if ("touchmove" === e.type) this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                    else {
                        var t, i;
                        const s = this.player.elements.progress.getBoundingClientRect(), n = 100 / s.width * (e.pageX - s.left);
                        this.seekTime = this.player.media.duration * (n / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = e.pageX, this.elements.thumb.time.innerText = Ee(this.seekTime);
                        const a = null === (t = this.player.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e  })=>e === Math.round(this.seekTime));
                        a && this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${a.label}<br>`);
                    }
                    this.showImageAtCurrentTime();
                }
            }), e(this, "endMove", ()=>{
                this.toggleThumbContainer(!1, !0);
            }), e(this, "startScrubbing", (e)=>{
                (S.nullOrUndefined(e.button) || !1 === e.button || 0 === e.button) && (this.mouseDown = !0, this.player.media.duration && (this.toggleScrubbingContainer(!0), this.toggleThumbContainer(!1, !0), this.showImageAtCurrentTime()));
            }), e(this, "endScrubbing", ()=>{
                this.mouseDown = !1, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(!1) : G.call(this.player, this.player.media, "timeupdate", ()=>{
                    this.mouseDown || this.toggleScrubbingContainer(!1);
                });
            }), e(this, "listeners", ()=>{
                this.player.on("play", ()=>{
                    this.toggleThumbContainer(!1, !0);
                }), this.player.on("seeked", ()=>{
                    this.toggleThumbContainer(!1);
                }), this.player.on("timeupdate", ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            }), e(this, "render", ()=>{
                this.elements.thumb.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                }), this.elements.thumb.imageContainer = $("div", {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                const e = $("div", {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = $("span", {}, "00:00"), e.appendChild(this.elements.thumb.time), this.elements.thumb.imageContainer.appendChild(e), S.element(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            }), e(this, "destroy", ()=>{
                this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
            }), e(this, "showImageAtCurrentTime", ()=>{
                this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
                const e = this.thumbnails[0].frames.findIndex((e)=>this.seekTime >= e.startTime && this.seekTime <= e.endTime), t = e >= 0;
                let i = 0;
                this.mouseDown || this.toggleThumbContainer(t), t && (this.thumbnails.forEach((t, s)=>{
                    this.loadedImages.includes(t.frames[e].text) && (i = s);
                }), e !== this.showingThumb && (this.showingThumb = e, this.loadImage(i)));
            }), e(this, "loadImage", (e = 0)=>{
                const t = this.showingThumb, i = this.thumbnails[e], { urlPrefix: s  } = i, n = i.frames[t], a = i.frames[t].text, l = s + a;
                if (this.currentImageElement && this.currentImageElement.dataset.filename === a) this.showImage(this.currentImageElement, n, e, t, a, !1), this.currentImageElement.dataset.index = t, this.removeOldImages(this.currentImageElement);
                else {
                    this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
                    const i = new Image;
                    i.src = l, i.dataset.index = t, i.dataset.filename = a, this.showingThumbFilename = a, this.player.debug.log(`Loading image: ${l}`), i.onload = ()=>this.showImage(i, n, e, t, a, !0), this.loadingImage = i, this.removeOldImages(i);
                }
            }), e(this, "showImage", (e, t, i, s, n, a = !0)=>{
                this.player.debug.log(`Showing thumb: ${n}. num: ${s}. qual: ${i}. newimg: ${a}`), this.setImageSizeAndOffset(e, t), a && (this.currentImageContainer.appendChild(e), this.currentImageElement = e, this.loadedImages.includes(n) || this.loadedImages.push(n)), this.preloadNearby(s, !0).then(this.preloadNearby(s, !1)).then(this.getHigherQuality(i, e, t, n));
            }), e(this, "removeOldImages", (e)=>{
                Array.from(this.currentImageContainer.children).forEach((t)=>{
                    if ("img" !== t.tagName.toLowerCase()) return;
                    const i = this.usingSprites ? 500 : 1e3;
                    if (t.dataset.index !== e.dataset.index && !t.dataset.deleting) {
                        t.dataset.deleting = !0;
                        const { currentImageContainer: e  } = this;
                        setTimeout(()=>{
                            e.removeChild(t), this.player.debug.log(`Removing thumb: ${t.dataset.filename}`);
                        }, i);
                    }
                });
            }), e(this, "preloadNearby", (e, t = !0)=>new Promise((i)=>{
                    setTimeout(()=>{
                        const s = this.thumbnails[0].frames[e].text;
                        if (this.showingThumbFilename === s) {
                            let n;
                            n = t ? this.thumbnails[0].frames.slice(e) : this.thumbnails[0].frames.slice(0, e).reverse();
                            let a = !1;
                            n.forEach((e)=>{
                                const t = e.text;
                                if (t !== s && !this.loadedImages.includes(t)) {
                                    a = !0, this.player.debug.log(`Preloading thumb filename: ${t}`);
                                    const { urlPrefix: e  } = this.thumbnails[0], s = e + t, n = new Image;
                                    n.src = s, n.onload = ()=>{
                                        this.player.debug.log(`Preloaded thumb filename: ${t}`), this.loadedImages.includes(t) || this.loadedImages.push(t), i();
                                    };
                                }
                            }), a || i();
                        }
                    }, 300);
                })), e(this, "getHigherQuality", (e, t, i, s)=>{
                if (e < this.thumbnails.length - 1) {
                    let n = t.naturalHeight;
                    this.usingSprites && (n = i.h), n < this.thumbContainerHeight && setTimeout(()=>{
                        this.showingThumbFilename === s && (this.player.debug.log(`Showing higher quality thumb for: ${s}`), this.loadImage(e + 1));
                    }, 300);
                }
            }), e(this, "toggleThumbContainer", (e = !1, t = !1)=>{
                const i = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(i, e), !e && t && (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "toggleScrubbingContainer", (e = !1)=>{
                const t = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(t, e), e || (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "determineContainerAutoSizing", ()=>{
                (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = !0);
            }), e(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: e  } = this.elements.thumb;
                if (this.sizeSpecifiedInCSS) {
                    if (e.clientHeight > 20 && e.clientWidth < 20) {
                        const t = Math.floor(e.clientHeight * this.thumbAspectRatio);
                        e.style.width = `${t}px`;
                    } else if (e.clientHeight < 20 && e.clientWidth > 20) {
                        const t = Math.floor(e.clientWidth / this.thumbAspectRatio);
                        e.style.height = `${t}px`;
                    }
                } else {
                    const t = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    e.style.height = `${this.thumbContainerHeight}px`, e.style.width = `${t}px`;
                }
                this.setThumbContainerPos();
            }), e(this, "setThumbContainerPos", ()=>{
                const e = this.player.elements.progress.getBoundingClientRect(), t = this.player.elements.container.getBoundingClientRect(), { container: i  } = this.elements.thumb, s = t.left - e.left + 10, n = t.right - e.left - i.clientWidth - 10, a = this.mousePosX - e.left - i.clientWidth / 2, l = Ge(a, s, n);
                i.style.left = `${l}px`, i.style.setProperty("--preview-arrow-offset", a - l + "px");
            }), e(this, "setScrubbingContainerSize", ()=>{
                const { width: e , height: t  } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${e}px`, this.elements.scrubbing.container.style.height = `${t}px`;
            }), e(this, "setImageSizeAndOffset", (e, t)=>{
                if (!this.usingSprites) return;
                const i = this.thumbContainerHeight / t.h;
                e.style.height = e.naturalHeight * i + "px", e.style.width = e.naturalWidth * i + "px", e.style.left = `-${t.x * i}px`, e.style.top = `-${t.y * i}px`;
            }), this.player = t, this.thumbnails = [], this.loaded = !1, this.lastMouseMoveTime = Date.now(), this.mouseDown = !1, this.loadedImages = [], this.elements = {
                thumb: {},
                scrubbing: {}
            }, this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes("w");
        }
        get thumbAspectRatio() {
            return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: e  } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return e;
            }
            return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(e) {
            this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e;
        }
    }
    const it = {
        insertElements (e, t) {
            S.string(t) ? _(e, this.media, {
                src: t
            }) : S.array(t) && t.forEach((t)=>{
                _(e, this.media, t);
            });
        },
        change (e) {
            N(e, "sources.length") ? (de.cancelRequests.call(this), this.destroy.call(this, ()=>{
                this.options.quality = [], O(this.media), this.media = null, S.element(this.elements.container) && this.elements.container.removeAttribute("class");
                const { sources: t , type: i  } = e, [{ provider: s = _e.html5 , src: n  }] = t, a = "html5" === s ? i : "div", l = "html5" === s ? {} : {
                    src: n
                };
                Object.assign(this, {
                    provider: s,
                    type: i,
                    supported: K.check(i, s, this.config.playsinline),
                    media: $(a, l)
                }), this.elements.container.appendChild(this.media), S.boolean(e.autoplay) && (this.config.autoplay = e.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), S.empty(e.poster) || (this.poster = e.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), Fe.addStyleHook.call(this), this.isHTML5 && it.insertElements.call(this, "source", t), this.config.title = e.title, Xe.setup.call(this), this.isHTML5 && Object.keys(e).includes("tracks") && it.insertElements.call(this, "track", e.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.isHTML5 && this.media.load(), S.empty(e.previewThumbnails) || (Object.assign(this.config.previewThumbnails, e.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))), this.fullscreen.update();
            }, !0)) : this.debug.warn("Invalid source format");
        }
    };
    class st {
        constructor(t, i){
            if (e(this, "play", ()=>S.function(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>ie(this.media.play())), this.media.play()) : null), e(this, "pause", ()=>this.playing && S.function(this.media.pause) ? this.media.pause() : null), e(this, "togglePlay", (e)=>(S.boolean(e) ? e : !this.playing) ? this.play() : this.pause()), e(this, "stop", ()=>{
                this.isHTML5 ? (this.pause(), this.restart()) : S.function(this.media.stop) && this.media.stop();
            }), e(this, "restart", ()=>{
                this.currentTime = 0;
            }), e(this, "rewind", (e)=>{
                this.currentTime -= S.number(e) ? e : this.config.seekTime;
            }), e(this, "forward", (e)=>{
                this.currentTime += S.number(e) ? e : this.config.seekTime;
            }), e(this, "increaseVolume", (e)=>{
                const t = this.media.muted ? 0 : this.volume;
                this.volume = t + (S.number(e) ? e : 0);
            }), e(this, "decreaseVolume", (e)=>{
                this.increaseVolume(-e);
            }), e(this, "airplay", ()=>{
                K.airplay && this.media.webkitShowPlaybackTargetPicker();
            }), e(this, "toggleControls", (e)=>{
                if (this.supported.ui && !this.isAudio) {
                    const t = F(this.elements.container, this.config.classNames.hideControls), i = void 0 === e ? void 0 : !e, s = R(this.elements.container, this.config.classNames.hideControls, i);
                    if (s && S.array(this.config.controls) && this.config.controls.includes("settings") && !S.empty(this.config.settings) && Pe.toggleMenu.call(this, !1), s !== t) {
                        const e = s ? "controlshidden" : "controlsshown";
                        Z.call(this, this.media, e);
                    }
                    return !s;
                }
                return !1;
            }), e(this, "on", (e, t)=>{
                X.call(this, this.elements.container, e, t);
            }), e(this, "once", (e, t)=>{
                G.call(this, this.elements.container, e, t);
            }), e(this, "off", (e, t)=>{
                J(this.elements.container, e, t);
            }), e(this, "destroy", (e, t = !1)=>{
                if (!this.ready) return;
                const i = ()=>{
                    document.body.style.overflow = "", this.embed = null, t ? (Object.keys(this.elements).length && (O(this.elements.buttons.play), O(this.elements.captions), O(this.elements.controls), O(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), S.function(e) && e()) : (ee.call(this), de.cancelRequests.call(this), q(this.elements.original, this.elements.container), Z.call(this, this.elements.original, "destroyed", !0), S.function(e) && e.call(this.elements.original), this.ready = !1, setTimeout(()=>{
                        this.elements = null, this.media = null;
                    }, 200));
                };
                this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (Fe.toggleNativeControls.call(this, !0), i()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), null !== this.embed && S.function(this.embed.destroy) && this.embed.destroy(), i()) : this.isVimeo && (null !== this.embed && this.embed.unload().then(i), setTimeout(i, 200));
            }), e(this, "supports", (e)=>K.mime.call(this, e)), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = K.touch, this.media = t, S.string(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || S.nodeList(this.media) || S.array(this.media)) && (this.media = this.media[0]), this.config = x({}, Le, st.defaults, i || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute("data-plyr-config"));
                } catch (e) {
                    return {};
                }
            })()), this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            }, this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap
            }, this.fullscreen = {
                active: !1
            }, this.options = {
                speed: [],
                quality: []
            }, this.debug = new De(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", K), S.nullOrUndefined(this.media) || !S.element(this.media)) return void this.debug.error("Setup failed: no suitable element passed");
            if (this.media.plyr) return void this.debug.warn("Target already setup");
            if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
            if (!K.check().api) return void this.debug.error("Setup failed: no support");
            const s = this.media.cloneNode(!0);
            s.autoplay = !1, this.elements.original = s;
            const n = this.media.tagName.toLowerCase();
            let a = null, l = null;
            switch(n){
                case "div":
                    if (a = this.media.querySelector("iframe"), S.element(a)) {
                        if (l = Me(a.getAttribute("src")), this.provider = function(e) {
                            return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e) ? _e.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e) ? _e.vimeo : null;
                        }(l.toString()), this.elements.container = this.media, this.media = a, this.elements.container.className = "", l.search.length) {
                            const e = [
                                "1",
                                "true"
                            ];
                            e.includes(l.searchParams.get("autoplay")) && (this.config.autoplay = !0), e.includes(l.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? (this.config.playsinline = e.includes(l.searchParams.get("playsinline")), this.config.youtube.hl = l.searchParams.get("hl")) : this.config.playsinline = !0;
                        }
                    } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
                    if (S.empty(this.provider) || !Object.values(_e).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
                    this.type = je;
                    break;
                case "video":
                case "audio":
                    this.type = n, this.provider = _e.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                    break;
                default:
                    return void this.debug.error("Setup failed: unsupported type");
            }
            this.supported = K.check(this.type, this.provider), this.supported.api ? (this.eventListeners = [], this.listeners = new Ve(this), this.storage = new we(this), this.media.plyr = this, S.element(this.elements.container) || (this.elements.container = $("div"), L(this.media, this.elements.container)), Fe.migrateStyles.call(this), Fe.addStyleHook.call(this), Xe.setup.call(this), this.config.debug && X.call(this, this.elements.container, this.config.events.join(" "), (e)=>{
                this.debug.log(`event: ${e.type}`);
            }), this.fullscreen = new He(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new Je(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", ()=>ie(this.play())), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))) : this.debug.error("Setup failed: no support");
        }
        get isHTML5() {
            return this.provider === _e.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === _e.youtube;
        }
        get isVimeo() {
            return this.provider === _e.vimeo;
        }
        get isVideo() {
            return this.type === je;
        }
        get isAudio() {
            return this.type === Oe;
        }
        get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        get paused() {
            return Boolean(this.media.paused);
        }
        get stopped() {
            return Boolean(this.paused && 0 === this.currentTime);
        }
        get ended() {
            return Boolean(this.media.ended);
        }
        set currentTime(e) {
            if (!this.duration) return;
            const t = S.number(e) && e > 0;
            this.media.currentTime = t ? Math.min(e, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        get currentTime() {
            return Number(this.media.currentTime);
        }
        get buffered() {
            const { buffered: e  } = this.media;
            return S.number(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
        }
        get seeking() {
            return Boolean(this.media.seeking);
        }
        get duration() {
            const e = parseFloat(this.config.duration), t = (this.media || {}).duration, i = S.number(t) && t !== 1 / 0 ? t : 0;
            return e || i;
        }
        set volume(e) {
            let t = e;
            S.string(t) && (t = Number(t)), S.number(t) || (t = this.storage.get("volume")), S.number(t) || ({ volume: t  } = this.config), t > 1 && (t = 1), t < 0 && (t = 0), this.config.volume = t, this.media.volume = t, !S.empty(e) && this.muted && t > 0 && (this.muted = !1);
        }
        get volume() {
            return Number(this.media.volume);
        }
        set muted(e) {
            let t = e;
            S.boolean(t) || (t = this.storage.get("muted")), S.boolean(t) || (t = this.config.muted), this.config.muted = t, this.media.muted = t;
        }
        get muted() {
            return Boolean(this.media.muted);
        }
        get hasAudio() {
            return !this.isHTML5 || !!this.isAudio || Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        set speed(e) {
            let t = null;
            S.number(e) && (t = e), S.number(t) || (t = this.storage.get("speed")), S.number(t) || (t = this.config.speed.selected);
            const { minimumSpeed: i , maximumSpeed: s  } = this;
            t = Ge(t, i, s), this.config.speed.selected = t, setTimeout(()=>{
                this.media && (this.media.playbackRate = t);
            }, 0);
        }
        get speed() {
            return Number(this.media.playbackRate);
        }
        get minimumSpeed() {
            return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? .5 : .0625;
        }
        get maximumSpeed() {
            return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
        }
        set quality(e) {
            const t = this.config.quality, i = this.options.quality;
            if (!i.length) return;
            let s = [
                !S.empty(e) && Number(e),
                this.storage.get("quality"),
                t.selected,
                t.default
            ].find(S.number), n = !0;
            if (!i.includes(s)) {
                const e = ne(i, s);
                this.debug.warn(`Unsupported quality option: ${s}, using ${e} instead`), s = e, n = !1;
            }
            t.selected = s, this.media.quality = s, n && this.storage.set({
                quality: s
            });
        }
        get quality() {
            return this.media.quality;
        }
        set loop(e) {
            const t = S.boolean(e) ? e : this.config.loop.active;
            this.config.loop.active = t, this.media.loop = t;
        }
        get loop() {
            return Boolean(this.media.loop);
        }
        set source(e) {
            it.change.call(this, e);
        }
        get source() {
            return this.media.currentSrc;
        }
        get download() {
            const { download: e  } = this.config.urls;
            return S.url(e) ? e : this.source;
        }
        set download(e) {
            S.url(e) && (this.config.urls.download = e, Pe.setDownloadUrl.call(this));
        }
        set poster(e) {
            this.isVideo ? Fe.setPoster.call(this, e, !1).catch(()=>{}) : this.debug.warn("Poster can only be set for video");
        }
        get poster() {
            return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
        }
        get ratio() {
            if (!this.isVideo) return null;
            const e = oe(ce.call(this));
            return S.array(e) ? e.join(":") : e;
        }
        set ratio(e) {
            this.isVideo ? S.string(e) && re(e) ? (this.config.ratio = oe(e), ue.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e})`) : this.debug.warn("Aspect ratio can only be set for video");
        }
        set autoplay(e) {
            this.config.autoplay = S.boolean(e) ? e : this.config.autoplay;
        }
        get autoplay() {
            return Boolean(this.config.autoplay);
        }
        toggleCaptions(e) {
            xe.toggle.call(this, e, !1);
        }
        set currentTrack(e) {
            xe.set.call(this, e, !1), xe.setup.call(this);
        }
        get currentTrack() {
            const { toggled: e , currentTrack: t  } = this.captions;
            return e ? t : -1;
        }
        set language(e) {
            xe.setLanguage.call(this, e, !1);
        }
        get language() {
            return (xe.getCurrentTrack.call(this) || {}).language;
        }
        set pip(e) {
            if (!K.pip) return;
            const t = S.boolean(e) ? e : !this.pip;
            S.function(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? Ie : $e), S.function(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture());
        }
        get pip() {
            return K.pip ? S.empty(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === Ie : null;
        }
        setPreviewThumbnails(e) {
            this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this));
        }
        static supported(e, t) {
            return K.check(e, t);
        }
        static loadSprite(e, t) {
            return ke(e, t);
        }
        static setup(e, t = {}) {
            let i = null;
            return S.string(e) ? i = Array.from(document.querySelectorAll(e)) : S.nodeList(e) ? i = Array.from(e) : S.array(e) && (i = e.filter(S.element)), S.empty(i) ? null : i.map((e)=>new st(e, t));
        }
    }
    var nt;
    return st.defaults = (nt = Le, JSON.parse(JSON.stringify(nt))), st;
});

},{}],"h07GF":[function() {},{}],"2dM5c":[function() {},{}],"7gnwH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeartIcon", ()=>HeartIcon);
/***********************************************************************************************************/ parcelHelpers.export(exports, "SpeechBubbleIcon", ()=>SpeechBubbleIcon);
/***********************************************************************************************************/ parcelHelpers.export(exports, "PaperPlaneIcon", ()=>PaperPlaneIcon);
/***********************************************************************************************************/ parcelHelpers.export(exports, "BookmarkIcon", ()=>BookmarkIcon);
var _lit = require("lit");
class HeartIcon extends (0, _lit.LitElement) {
    static get is() {
        return "heart-icon";
    }
    render() {
        return (0, _lit.html)`
            <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="inherit" fill="inherit">
                <path transform="translate(-1)" d="M11 4C5.5-1.5-1.5 5.5 4 11l7 7 7-7c5.458-5.458-1.542-12.458-7-7Z"/>
            </svg>
        `;
    }
}
customElements.define(HeartIcon.is, HeartIcon);
class SpeechBubbleIcon extends (0, _lit.LitElement) {
    static get is() {
        return "speech-bubble-icon";
    }
    render() {
        return (0, _lit.html)`
            <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" stroke="inherit" fill="inherit">
                <path transform="scale(1, 1.1)" d="M5 5h9M5 9h5m8-8H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4l3.5 4 3.5-4h5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Z"/>
            </svg>
        `;
    }
}
customElements.define(SpeechBubbleIcon.is, SpeechBubbleIcon);
class PaperPlaneIcon extends (0, _lit.LitElement) {
    static get is() {
        return "paper-plane-icon";
    }
    render() {
        return (0, _lit.html)`
            <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="inherit" fill="inherit">
                <path transform="rotate(45, 9, 10) translate(1.5, -2) scale(.9)" d="m9 17 8 2L9 1 1 19l8-2Zm0 0V9"/>
            </svg>
        `;
    }
}
customElements.define(PaperPlaneIcon.is, PaperPlaneIcon);
class BookmarkIcon extends (0, _lit.LitElement) {
    static get is() {
        return "bookmark-icon";
    }
    render() {
        return (0, _lit.html)`
            <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" stroke="inherit" fill="inherit">
                <path transform="translate(2.5)" d="m13 19-6-5-6 5V2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17Z"/>
            </svg>
        `;
    }
}
customElements.define(BookmarkIcon.is, BookmarkIcon);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Ckcb":[function(require,module,exports) {
/*!
 * swiped-events.js - v@version@
 * Pure JavaScript swipe events
 * https://github.com/john-doherty/swiped-events
 * @inspiration https://stackoverflow.com/questions/16348031/disable-scrolling-when-touch-moving-certain-element
 * @author John Doherty <www.johndoherty.info>
 * @license MIT
 */ (function(window1, document1) {
    "use strict";
    // patch CustomEvent to allow constructor creation (IE/Chrome)
    if (typeof window1.CustomEvent !== "function") {
        window1.CustomEvent = function(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            var evt = document1.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        };
        window1.CustomEvent.prototype = window1.Event.prototype;
    }
    document1.addEventListener("touchstart", handleTouchStart, false);
    document1.addEventListener("touchmove", handleTouchMove, false);
    document1.addEventListener("touchend", handleTouchEnd, false);
    var xDown = null;
    var yDown = null;
    var xDiff = null;
    var yDiff = null;
    var timeDown = null;
    var startEl = null;
    /**
     * Fires swiped event if swipe detected on touchend
     * @param {object} e - browser event object
     * @returns {void}
     */ function handleTouchEnd(e) {
        // if the user released on a different target, cancel!
        if (startEl !== e.target) return;
        var swipeThreshold = parseInt(getNearestAttribute(startEl, "data-swipe-threshold", "20"), 10); // default 20px
        var swipeTimeout = parseInt(getNearestAttribute(startEl, "data-swipe-timeout", "500"), 10); // default 500ms
        var timeDiff = Date.now() - timeDown;
        var eventType = "";
        var changedTouches = e.changedTouches || e.touches || [];
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (Math.abs(xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
                if (xDiff > 0) eventType = "swiped-left";
                else eventType = "swiped-right";
            }
        } else if (Math.abs(yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
            if (yDiff > 0) eventType = "swiped-up";
            else eventType = "swiped-down";
        }
        if (eventType !== "") {
            var eventData = {
                dir: eventType.replace(/swiped-/, ""),
                touchType: (changedTouches[0] || {}).touchType || "direct",
                xStart: parseInt(xDown, 10),
                xEnd: parseInt((changedTouches[0] || {}).clientX || -1, 10),
                yStart: parseInt(yDown, 10),
                yEnd: parseInt((changedTouches[0] || {}).clientY || -1, 10)
            };
            // fire `swiped` event event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent("swiped", {
                bubbles: true,
                cancelable: true,
                detail: eventData
            }));
            // fire `swiped-dir` event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent(eventType, {
                bubbles: true,
                cancelable: true,
                detail: eventData
            }));
        }
        // reset values
        xDown = null;
        yDown = null;
        timeDown = null;
    }
    /**
     * Records current location on touchstart event
     * @param {object} e - browser event object
     * @returns {void}
     */ function handleTouchStart(e) {
        // if the element has data-swipe-ignore="true" we stop listening for swipe events
        if (e.target.getAttribute("data-swipe-ignore") === "true") return;
        startEl = e.target;
        timeDown = Date.now();
        xDown = e.touches[0].clientX;
        yDown = e.touches[0].clientY;
        xDiff = 0;
        yDiff = 0;
    }
    /**
     * Records location diff in px on touchmove event
     * @param {object} e - browser event object
     * @returns {void}
     */ function handleTouchMove(e) {
        if (!xDown || !yDown) return;
        var xUp = e.touches[0].clientX;
        var yUp = e.touches[0].clientY;
        xDiff = xDown - xUp;
        yDiff = yDown - yUp;
    }
    /**
     * Gets attribute off HTML element or nearest parent
     * @param {object} el - HTML element to retrieve attribute from
     * @param {string} attributeName - name of the attribute
     * @param {any} defaultValue - default value to return if no match found
     * @returns {any} attribute value or defaultValue
     */ function getNearestAttribute(el, attributeName, defaultValue) {
        // walk up the dom tree looking for data-action and data-trigger
        while(el && el !== document1.documentElement){
            var attributeValue = el.getAttribute(attributeName);
            if (attributeValue) return attributeValue;
            el = el.parentNode;
        }
        return defaultValue;
    }
})(window, document);

},{}],"4SOBb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATA", ()=>DATA);
const DATA = [
    "7_dLVcEvW9U",
    "TqqSvAv4E3k",
    "ECWoLXGxB5Q",
    "58MrRNFpRK0",
    "K5q-1ycH77o",
    "q1RIUJ-LbfA",
    "MUFoMNNRvVw",
    "sbjFT7dSMjY",
    "c61Uj4_VqqU",
    "JQiTX1z7sjE",
    "e9qRC00dCa0",
    "vAMX0FMJ-tQ",
    "dYCjTwVXrIM",
    "zFqyIo6N8A8",
    "ltL4gbXlU6o",
    "ZMD3vTqwchY",
    "-mWPFO4TRQw",
    "caNERTvm3qk",
    "vWaKvebsf8I",
    "WeLRxQF7vJs",
    "bpv-2oI6DRM",
    "vdaYt-RLKIM",
    "OmaHX5E2-R8",
    "JndsWSbtP1I",
    "nYFnzTWDeMo",
    "Yyg3_cUQABs",
    "eCGgrA0ov9k",
    "031gw6L5vUE",
    "X5kS1lM5CyI",
    "BFUiPSFg-No",
    "Jv7mgDWKf5U",
    "FienrVODMLY",
    "WfbPL_zl3zc",
    "xpdOss6DRqA",
    "D4iIws67e84",
    "_T-MhdGOp24",
    "xEyKroSwtyw",
    "y_I0EaJAgzI",
    "ekNp4IGs7og",
    "BM3PACegse0",
    "OZrCXE44Zrs",
    "ChO6RchHcRk",
    "yXFdR7-PrvQ",
    "BXSP8ZDcN18",
    "q7Gr6Y_ngEE",
    "xTrwhRcVytI",
    "APWeVvCkeRM",
    "eTHYH3SycOg",
    "GAs8OLqCU9w",
    "h_z6TQUc9XY",
    "6EuUevifFfk",
    "HOr6uTvmzjw",
    "YAwGzZ-x3H0",
    "hCTHO_88g58",
    "fKKbvUoKbWI",
    "aFk_IeQivR0",
    "XIyUsEA89zw",
    "AOM8_jYeYBg",
    "uezNQ-otdig",
    "B51bDTeFlrs",
    "18StE3x0H-Q",
    "-7dtqPQdq8k",
    "U-a51cSQ_vs",
    "OPNCqsKxpH4",
    "A1zvmB7LZgo",
    "RzrtKAj5mGs",
    "qjUbF_-Vn4A",
    "Ulz_SHJQgiU",
    "_yfVv2i3wi4",
    "mWpKRGihVMM",
    "xjT5CTg3WlI",
    "svyhRJbUNys",
    "rgCyqWACWEs",
    "c5xLnDp1bKY",
    "rotH6JAQmxg",
    "TQup_zpEWg4",
    "t8csh7-H-2Y",
    "vnhiNvcIySs",
    "YjXRUudoFCk",
    "IIoTUNGRvaY",
    "IG49FvZGh5s",
    "nN4YRS_PDZo",
    "OCN_JOFwLpk",
    "zu15HKkUo4A",
    "2g1F7o9-ZMQ",
    "XYdbwmKw5u8",
    "NILZz79_v30",
    "fIA0wBHgwnk",
    "YRARyZRUV6A",
    "5bAwMlGuJUc",
    "f_RqdUAZW8s",
    "Zgk4FUdFitY",
    "SC9ArPj9H_0",
    "7wOhkBGdAwA",
    "7fIawbewHR8",
    "Nd_xOOSVCS8",
    "vmeXpI2DAbM",
    "OC-FTAYXINA",
    "rZ60zCU6aFE",
    "dwZhQEYH2J8",
    "HRRqtbZZoSM",
    "EPQKdiFuTOc",
    "A6Z434YYeYo",
    "qp4hCmAb1ac",
    "unJOxGLMLQ4",
    "nk8LD7t-Z-Y",
    "PWbtbr5hgcw",
    "6ti1UBgfxpY",
    "9EpSvWq-1DM",
    "px0v5PLxIH8",
    "g9C69nX7HIE",
    "HYtkd2cf338",
    "GUsCh1BCNic",
    "m0lKehRTibc",
    "mYpS99dVehw",
    "iSvBFUmBxkU",
    "eRorFe7WXMI",
    "8hBPxrTawj4",
    "ezc097DjJ8g",
    "dhCVMhHF4EA",
    "B2ocu12KnQg",
    "8SeVUUiaqlo",
    "j-sZhUTbYtI",
    "yyitRTB05fw",
    "Ysl3deAdsCo",
    "zevnnxet_zs",
    "1LUNW8iqo2c",
    "r-Jsr4aQ_Qo",
    "Ci_85ayBYos",
    "TzdYlrBoW9E",
    "c55FwRX9nZs",
    "ifPcHHgrjD4",
    "zbgtETrUV9w",
    "4Td7B5VX3oc",
    "9SV1a_Yd_c8",
    "Fz_5U13yn2w",
    "Zpuq_uVYwyg",
    "EIQ7GBv9y_0",
    "LBkzgFpOCKU",
    "82o_YH_RyEs",
    "I5ZfXSUnxi0",
    "-__ZKmDFM1k",
    "1FtmLoWlK8w",
    "ShBgnV-Book",
    "J9OS_fTID6Y",
    "xvr-cqgVF1I",
    "boBqVIml944",
    "JYGsBeybDUQ",
    "-SjXLa9fByI",
    "4g4aZMmwdOA",
    "W4C5Y2S2HRY",
    "uoslxSwdT_0",
    "w1TdkLoWgBE",
    "Ujz4qvJoN30",
    "CjI5XtyRy9U",
    "5prs2KeeaA0",
    "Lveed52zYF8",
    "QKXlGSNlgN8",
    "EZ_ly1-MRIU",
    "tzptCqpYCNI",
    "7yhYiD05ldk",
    "DOzbHaFeJug",
    "A-MP7XqmP-Y",
    "tz8WN4J6XvE",
    "r-cE0PK9TeQ",
    "CZQz0ul2Ksw",
    "GHQ2rupeUKU",
    "Jk4fiU5_wL8",
    "cxL0ZmcZQJ8",
    "4hlw8dGpBCw",
    "WNOhF-DNcWU",
    "Lu_gmXggyF4",
    "zIqp2L_OLmg",
    "p0ZALGPQi6E",
    "PpO7UMFUR9o",
    "8hARH0rS4v0",
    "KNZfWFWaiiE",
    "STh6ZICkn5c",
    "uvQmWo-WH7Y",
    "LmSbwJc-iTs",
    "Hvpc2j3o0Dg",
    "Zu9XwKThY-Y",
    "vFA7hCEBWME",
    "wRKkHfqUhVs",
    "ZisWZQftDjU",
    "lo_jmcdefPQ",
    "nn__WV-WxAo",
    "Hp9EnkquthA",
    "NLKHlG0IqKo",
    "JSHS6ARoo5Y",
    "rFPKG8QeKjk",
    "MDKrGL5j76w",
    "jgZYHQTETI0",
    "GURmSN-wuno",
    "gnNXRyfQA7c",
    "BTP3-DGh6oc",
    "O5th2X_ni3Q",
    "aK22d-BX0zA",
    "futFEQeVfzM",
    "-P3z3swliI4",
    "u-8MZqCEcRo",
    "YbSIt-VuskI",
    "I17KldweH9Q",
    "SvCTXFj3XWA",
    "5ZjRLyvYC58",
    "kHh2m0r69AE",
    "voiRgDhRkLc",
    "GGADm1yML8w",
    "4-jWyDTmxfo",
    "1Zah1QXijw4",
    "9ZWLVRYfxUU",
    "RdkHtIdlLeQ",
    "z9ASlIj41kk",
    "n9u6hD0BcFA",
    "jsA0UGWYOBU",
    "HQ98ys0apO4",
    "DsUmxL-nxcA",
    "TGPnW4Rtcsk",
    "OxiOWQl1XfA",
    "X2dTXYVJnk8",
    "kiZb5zGgghQ",
    "VdqolRKXjlg",
    "YxTaof9FDdk",
    "m9P3NlJ3pMM",
    "fvJu2hdo9qg",
    "TyvlqzIepdA",
    "WmxK9xf1MSQ",
    "WdOp7KGWv8U",
    "ytUc9eqBD2E",
    "fqxWu7J9VIA",
    "h-Ux4tu1K7M",
    "dHiBnyIAomM",
    "QBDj67nlcdQ",
    "mQoDKenrNSQ",
    "L1XQd_kRjdM",
    "8Qd6QQ2dyAk",
    "s_47J-6JP94",
    "saAEuT2gzOo",
    "NT4tFm94Rv4",
    "HmdTjTZrsFM",
    "17HH_ALXsxU",
    "kUBSIaRo4DI",
    "9HibzR2S2DM",
    "3VOzmreGtig",
    "B2ZW6D2waXc",
    "H52eRcgAESw",
    "gA0q5xAtRys",
    "-Tk4dTkMXT4",
    "0ymEJXe--kg",
    "IX_fkw_wcNM",
    "Xdb8K6Gxl0o",
    "KEahPyBYVDw",
    "Dj4Za44FQNw",
    "X_XllB0fKqE",
    "E6AHMDKXogA",
    "gKhBEcrvho0",
    "GHWLg92MTXw",
    "yxpzIOCj9X4",
    "fjNKs8aTwvU",
    "UUBDkvjafYo",
    "qWwcTpAcBl0",
    "Ij4b_12YXwc",
    "4I-PNiB8XZM",
    "_anltuYJcpY",
    "r-GE5Q05ovM",
    "DB-5jeIu6K4",
    "K-Fxapo8xXA",
    "GWIBdhZNE0o",
    "pUJklF9MaU4",
    "HcQZUE8OI6I",
    "8eGjpDwZhhQ",
    "PN7VOoeje58",
    "2qqm7G094GM",
    "xcDFIdDhk1A",
    "NpDC7TzQ_QY",
    "LUSCzYCAMKs",
    "0RyLiOQvgDQ",
    "h-ASCCvn7jw",
    "q_7uk1zCCdA",
    "oZOTTpDxfd8",
    "CbuCC8Uiifk",
    "anx1G8ykUT0",
    "nvJDKLXKr1Q",
    "nhUU2Oj7TwU",
    "ZOlAcrZXRjg",
    "ynLNpTGw6Tw",
    "2uY2ncTM4hc",
    "NxYDHJu12Ow",
    "MEI_BjhJdEo",
    "qlENEgt5Uu4",
    "5KT7hsnkNKk",
    "4ugWJitTFyQ",
    "9mB9eMcj8_Q",
    "_vyKrBl7jbQ",
    "3fHNJysaNcU",
    "9RBPd9rIT3Q",
    "wqwPFhimP24",
    "b51Exf3qF40",
    "q8CK3huxmLU",
    "2UdtwbrG3Pc",
    "bt19cHLdiIM",
    "EUbJUE4Tt_M",
    "85ikrZPF-HU",
    "_7lsjPptB-g",
    "IQUJgeDoqoU",
    "NYqV_9yfXP8",
    "-wVTYeID2EY",
    "GEuSbR9xwmk",
    "nVSCIuQlqII",
    "LBq4qFuo4Aw",
    "65M6DrKHHko",
    "StqQ9_WN3-E",
    "glkSATuyjQU",
    "RLPNbo0q5Es",
    "BTcPx5hO7M0",
    "6rfX_ngGsZQ",
    "DNl0U4Gf5c8",
    "5VHFkOCtVcE",
    "eMdp06h8iq8",
    "lKU0yo3xqiI",
    "7Q6sIlq-lqc",
    "NPZAJqJ0bAE",
    "FvGjXNDfRbI",
    "deMmlPGNw0c",
    "Yer1x7k2W4Y",
    "PubMbnalo6M",
    "FHACh-iju8w",
    "yzMct5MqTh4",
    "I0DriorlylA",
    "xQP4o2egolA",
    "Uno6JmRw3rs",
    "D4wQNGA7rpc",
    "WDQpRrh-DlA",
    "d2xrx5qfGYs",
    "OBQbIhA021Q",
    "LfOGnlvFODA",
    "WAjbJxuIi2w",
    "YmRBcdqdzMc",
    "vmj0w5K_ipg",
    "OlOLPISIKTM",
    "ZA7WAr26hmk",
    "mn_Zm9ZVnkk",
    "F2n5aTZrgFU",
    "qMwA7R6-G6k",
    "fKCY9YZ1ReU",
    "xJCLc-p3DRQ",
    "rXBbl6iASng",
    "yJN-Bvg_0VA",
    "N_0f0RduUr8",
    "C4eWZ8RbgPk",
    "W8Zvgh4NZ0Q",
    "tWXVM5DxPeQ",
    "_IljozaCe8s",
    "1Ji_8V8ZUcQ",
    "1Ts_e37KYTI",
    "SY-x3PYDUag",
    "-fXKPKijOuM",
    "iALp3trKHCA",
    "nyHv_JVJwUg",
    "SHl-A3FtUXs",
    "EiPsthqFmvw",
    "fc2UaQYt6RM",
    "W6HWNvmr9OU",
    "uVrWk2whVX0",
    "7x4IU8iPtUM",
    "5-nXQfMsGEw",
    "D9SvxabD_vI",
    "H92U-ED4Dm4",
    "pmiIQhGgWkA",
    "SjY7ur_6c6c",
    "UjY9kVF1qpc",
    "0d738Ijjt3U",
    "wo0XDvDTGW0",
    "GdpNvkRY_eo",
    "q0AXdJHWYHg",
    "bE5PKCHGeIQ",
    "E1VdD5XngFg",
    "SWG1L1o_XSU",
    "3yBDPfC5T2M",
    "yCO2W3ngioM",
    "FUeCIVv8-Dk",
    "RIbH7sf5Tf4",
    "shlTD11pq14",
    "K7hSuef0V6U",
    "-i577lc8IF0",
    "5vQwQhbm4Mw",
    "sismbLj8FAE",
    "9SZ-MkoLpwM",
    "HCGP04snx8o",
    "NbyWj28GUyY",
    "g6oB4MZg9_U",
    "f2dqser-MX4",
    "QlW4xoxcAZY",
    "N4GHGppkvyU",
    "TbdMLcn7-mo",
    "eCtIAdswdSU",
    "frEDSVx5gW4",
    "yeU6ozak090",
    "4zcAJXdDBVk",
    "ak0mExDQjg4",
    "FbMuPJVeD0A",
    "y6hjOak3j8M",
    "tamRpiFWYL4",
    "srGb8Df6IFw",
    "oDcROezT1rI",
    "OACKtK-bLb0",
    "oRSuRW3r8KU",
    "Wm-U-OPW3qw",
    "DUcdQzxZKig",
    "tGadrBbk71c",
    "48jYPIAdLOI",
    "kgSgcOaIuWI",
    "urw1hLps9ys",
    "uvsnKweOFag",
    "NtyKufK8MgQ",
    "K0nYhR5QSHQ",
    "I4cJleMrLv8",
    "gR_e4cBm-JU",
    "WF1Ov-7jVSA",
    "ERVZ-bp2V5s",
    "mRrf7Sojofc",
    "SmQbPpRN6UI",
    "PfpJUOrMNbQ",
    "Z1R4xs1bHBE",
    "k-Mzog4Yk88",
    "rXY1FnMMERQ",
    "v08q55QUfVY",
    "-3KolbF5C18",
    "sPqA7dvnSQ4",
    "lg2qiWztAfk",
    "qIgqlaWU198",
    "UPUOl_Tz6ls",
    "8BtOeEd_mic",
    "vnucyrKvxao",
    "woJ_lDZRS30",
    "fFY_Zou6hIA",
    "dKVXMr1pxwE",
    "dmphkIVz61g",
    "_YN_V9PMr-I",
    "Kzyv8M80ow8",
    "aH36G95mzUU",
    "9sTsm2-tA8w",
    "axUt9VYeysU",
    "81CxFX-r1SY",
    "hLy_xnU1Mpc",
    "fCL6eqJgRaM",
    "OTBTNVO4X3I",
    "diLp52J5kUw",
    "ZxBo5mqhIHs",
    "TB6TJ1KO2Y8",
    "hAgTu63haEc",
    "4Cu5w2m9y0Q",
    "DJxlQdPrkvw",
    "ljg-qdaHRhY",
    "6z-v27iSMPM",
    "4WDfBRPYPSg",
    "hIO0jgxffqA",
    "DQQpga2W97U",
    "7KBRcGDfPoc",
    "Z0Sb6tKgQ5U",
    "x5sAASIlxKY",
    "EMdMTIkJ4WE",
    "-jCpHSVmKs8",
    "4d_zZYDrcxY",
    "uiSREfO1YxQ",
    "akF8mo_OjlE",
    "adMSXcikX1E",
    "hgdQ_ehIhx4",
    "_nAqddbPm2o",
    "iI2Fg8Fio2c",
    "Nswu8iBdWDI",
    "W-sboPSEx0U",
    "C8dZ79KMies",
    "WCoUHb_FqQk",
    "kIz79cVJwGU",
    "s3m23IUs7q0",
    "Vr9Q-zFvp6E",
    "3oWsymlOzSE",
    "I_YhTthedBo",
    "Z2hxw5HRx6Q",
    "l8WvEZN5f_E",
    "mLl4w6l6Epk",
    "r4dbVcgzmXU",
    "q2MzS4fpJUg",
    "IFpOlb9_rdk",
    "2DBPPXAXCKw",
    "VnGtO7PlwMI",
    "NcwHZJQsTBk",
    "NF_6KJNBKVY",
    "nlmk44JnHZ4",
    "0IN7OGsVn5k",
    "6uYAHlQ_Akc",
    "AxeTA-3zhkw",
    "wpFg2m1cuWE",
    "O_OWSx647xY",
    "Os_YLAYhME8",
    "o7boNSTCI2E",
    "-36UCacL0-Q",
    "w-JyoDjlMa4",
    "-oHICCrz12E",
    "WZSiMyA9Xpg",
    "GWDFRE-k04U",
    "eFviTTENkR8",
    "o57fkfZXgJ4",
    "24Xi-5rLZvE",
    "KEuj4E052x4",
    "TzaUrmuGlXE",
    "WvRVFs-OYzg",
    "1wYN3i4Bn6U",
    "RJ6jIKGBS4Q",
    "JVE10G_QzJA",
    "qgO3Zgfnw58",
    "g9EMz4tFFmA",
    "F5LoIpAc2wM",
    "hp8aufE0Jso",
    "ViRNCguhO3o",
    "yi0XQQOjuTQ",
    "N_k3QWJ3HlE",
    "TrFymZlNqK8",
    "5VQNq9N2XZA",
    "o0t2r2HTqxQ",
    "9npK0LgbruU",
    "RPE06GgSEa8",
    "Ref-Q6p-hSw",
    "yUW7xxTkNtw",
    "B_Q2WPD3ruk",
    "gMZ0R9Bt67E",
    "M4QELdMrXa8",
    "0HMBl7yxnHc",
    "DYTtoM03VbM",
    "hmdC1SVE3DQ",
    "fjNGAxN5W9w",
    "INaLBE84C0c",
    "qCQW8ZZYr9s",
    "iGPGmrWAGG0",
    "1CwORrE4mVQ",
    "6ixbVCzge_A",
    "pKwDJab1cbc",
    "E0vm8rkY97o",
    "pYfANQKcdvY",
    "o305pC49u5E",
    "8HGbK8baiYI",
    "7l-RxvdVR1k",
    "hMtmiGYI-yk",
    "PlzZLggc_eg",
    "YiOHmQ4TNLY",
    "Byp2a56AAgI",
    "h0JO_vi5hUM",
    "dZUFWUZNllU",
    "3k5ugYu8fBs",
    "a7m20akWFms",
    "4QGkVmS29W0",
    "WnBU5Wt1vPI",
    "NyCz21XvliQ",
    "nPYUP-6nqgo",
    "bnfAxe9Qhss",
    "TPpGSARCDPk",
    "bgy1e1sVchI",
    "bCNTen5qm48",
    "TatO9rr-958",
    "dt9A43voAMs",
    "-2yvMh93XTc",
    "3GMTK4KrEqM",
    "DfDc6sOJh3E",
    "pIrZogXf7vM",
    "IV8UOw2Fsgc",
    "PBbZ_0-tUH0",
    "SBvtkFxfp2c",
    "UYx9RgY6mBY",
    "nEAsyTkIpcE",
    "iqEUcOuz9FQ",
    "T4EwtYzEJO8",
    "9ICJn_ri5cU",
    "Kcpc4nHp7_M",
    "k4Epndjvgxw",
    "OamTOU0Lc20",
    "MSCmEwTbsbI",
    "fyfN-tEfLo4",
    "DoGTiM8sgfI",
    "crFsOxEsYK4",
    "Vx8SMWbnwk0",
    "wpXHl_E5piE",
    "ejFDB7MvGsk",
    "tu1Xh9STZ3c",
    "weTNXhTDZZM",
    "GlX8wTVnkII",
    "DFpGnms2gHw",
    "tLlY7nut9x8",
    "H4RAG6NQGKQ",
    "YDAp-GzBuDg",
    "WlbBoLvfQtI",
    "rOSjifG6roM",
    "BtbihwNWIio",
    "fC86JraNfAo",
    "wQmgqkuvLdw",
    "WojiIunwVLk",
    "Ht_r_XEq8xs",
    "qyxu4J8EtnE",
    "u71xbc6Pg0o",
    "u2QQkP8NA_U",
    "DTj0A2VOTQA",
    "Ec9K73x1OWM",
    "WQJIi36DfCM",
    "--8dpvnG4H4",
    "7k68pgwQUGE",
    "6O6Gx0mvfvc",
    "ZteIc3fAvtM",
    "Y-LMalr9yeU",
    "7Mzg74ndzRg",
    "nPespVwMc0w",
    "AfQKBf0cLzM",
    "9a4rLItH4YM",
    "142RJnyNTRM",
    "bzsOCddTF_o",
    "I3IYFRJiYeQ",
    "oIetiUWb2Rs",
    "oaC4onwa5uI",
    "3WsjzxPUebc",
    "qLg7gsOFQhI",
    "_UEeq09H_O4",
    "uVicehwlj0w",
    "32fy6I-UuCk",
    "nyyxTV_CXm0",
    "_MVF3BLWgL0",
    "igUuuk5Afg0",
    "F7ko57V_WbY",
    "4b4B80lcoyM",
    "27lapMCSjLA",
    "as25rtMPMZM",
    "Royd_2V8a4c",
    "KzKr-NaaOO8",
    "kQ4wdAbViA8",
    "n_-kaFyHekA",
    "E43YDvDw4k0",
    "RY9HjrWcbLM",
    "i9fmE0r8ZHw",
    "rNrkBbOhWho",
    "gTE6WPuQNqE",
    "mSgwaP-_eWo",
    "G-YKMMc8gMw",
    "QgE6Jh3e2aw",
    "-GJ0Sui3qps",
    "1rOSgdG46Y4",
    "ru4qlj1Sxog",
    "5q2Bv91yl7k",
    "AKTscV3dfAg",
    "ChEZj80TxP0",
    "PnxTU7CtmZQ",
    "_fDaSkop_Zs",
    "iUIFcDv-lm4",
    "DcDbwiF8AXk",
    "Wyr8hDX-UnM",
    "KjCkka4AEaU",
    "L6lFw1kI50w",
    "SY_on3yy12I",
    "UUUyhUlfaQQ",
    "P3yhztUvo1Y",
    "1ii5W7JNtjg",
    "rLiY3EoBlsw",
    "XBESAgWIPS4",
    "hAARnow5_bw",
    "VFkWgv-Dg7g",
    "GwYMkIm9PqI",
    "ayzOe064Xeo",
    "FTInDZ4MH3M",
    "59VLjm5F-Mg",
    "mjXINsVgEqM",
    "UbD8FyeZsJY",
    "76VASlLNLf8",
    "rlGtcOB6CP4",
    "TMNg2jQrmB0",
    "DQmF48RGQA8",
    "rSZnn0M3gyo",
    "nPjrtbRgJRU",
    "TeDiAhemK20",
    "pKQgW2HdpY0",
    "Coi-BqjmY2M",
    "ncSThG4f8LY",
    "Ig8RPw7UIaQ",
    "1gnBejuLe6Y",
    "tWzxyQ_DHa0",
    "6yq8Q9Nygqg",
    "NDPcqeCDVVU",
    "jUAJ501XLFw",
    "NkZnFEEuOrU",
    "-EC_2vixn2c",
    "3mocM4SzXM0",
    "lvFXYjC6rPs",
    "WpTWRji0rRk",
    "M0Zr3zp9ZYE",
    "ivp7IpMmGRQ",
    "JFe-2r6xj8g",
    "lHXL0vqbKQg",
    "q-o5gW7JbVk",
    "KL6SQengzlU",
    "p2WWxSvJGlY",
    "SUtCJqh_uHw",
    "xmYiZOlz4ZU",
    "pz5BkKK1ztI",
    "2ht0RB-4mbY",
    "Nez-soW0nkc",
    "XWe0bKFdMgk",
    "54H47XYDQuA",
    "yqIHSNTT-1Q",
    "dxdCYkQZy9M",
    "SEpV9GngPgM",
    "JGkQJvbWivY",
    "UWDk3fR3A-I",
    "ghSp6ZFMH9I",
    "v16vVd65vMU",
    "RJ5xiApOut4",
    "_hsgAadZU60",
    "6TZBr02RcWU",
    "6RF8T9DPHK4",
    "mVECEh4IuS4",
    "UlqhWJ56bJA",
    "omYZtrKtpXc",
    "Qi2MfDbb7ZA",
    "nIcXay4DEW0",
    "WUcM0o1nb3g",
    "BjodywhLxr0",
    "1g6ezCtlsBA",
    "QaT_OdmyvEU",
    "AiqhflZ-1ps",
    "SFvwwoIaDZ8",
    "tVbbV9nykEA",
    "gBuc1bpCdDM",
    "B5jgIkILC8s",
    "FG6ESocHUPc",
    "1l7ixxMMKus",
    "msoiPX33b_A",
    "kHMWByGqMME",
    "SLc7dTSnIKk",
    "OIuzkL-7p2E",
    "KjB5EKcDIIQ",
    "7utrhHY4L3A",
    "cPHfv1gBW0Y",
    "u0cqjUy7HIU",
    "AbzjrxqHpsE",
    "3cKzweGvukE",
    "DbWQlB6iJP0",
    "6zLyBDoiOFc",
    "gtqhGv3-93w",
    "yE_gjuo38BI",
    "A-pXqMOdcRk",
    "WlzIu-auM_E",
    "9MEsfhzaiXU",
    "ZgdWccjaDoQ",
    "Pk4SkEfF0xI",
    "U2Zg7AC8lvY",
    "MfjLSAUIuwY",
    "lIwKnqKOHew",
    "21OUgJZqocU",
    "MqjFhLwK-D4",
    "FVPX5EQx3fQ",
    "NeYsqTgQMzE",
    "Ll0FpY5asfQ",
    "VTSQuP7EBGs",
    "3r_AOEU2r9s",
    "zh5oko4CucQ",
    "kephgwKka-w",
    "b9OdTzp6Uoo",
    "xugsDQotCHE",
    "3gUalLw7PDM",
    "Ws1naMo8_wM",
    "7KV5CuwNwCY",
    "-0_Bp89p0ZM",
    "3_vkaFyHv4M",
    "07-MhiLF5I8",
    "jygA1djOieQ",
    "PaCKB-1rXiA",
    "6gxRLZklIwk",
    "zQMD2tJuJko",
    "poxyhqZmEE0",
    "h6bo0a5XtvQ",
    "6Qhj6fTFXzo",
    "JlP9UqGKq38",
    "bRu8Ms4qqnQ",
    "3M8HwALvmrg",
    "iC3USx5AP6w",
    "SYUWS0H2tXE",
    "3AbxdF3YFs0",
    "oH_O-VQvbRA",
    "q6s21X1JgSI",
    "AIPPp7HH1ms",
    "ewO7NuFmI24",
    "6ebvLkQ_V8E",
    "pZLqpKCsCFA",
    "NA6bt-97ZMA",
    "kHrZLIQ7qQg",
    "KNC3bpvEZGc",
    "j4Na2TfI-Sw",
    "znw77dFk5c8",
    "K2dbDkBZMSo",
    "8B6pZNUwIsw",
    "F-10f7knsgo",
    "EL3blKZPAE8",
    "QmkWiAgfq5U",
    "tVeyBa5Mios",
    "UI8_qT4V464",
    "tvqJSK-ZfsY",
    "EgnvbiUQpuE",
    "bi-3IGo3UO4",
    "_iC7hA-0W1U",
    "yOCZo8Tr1U4",
    "3Mof5A7_Zlg",
    "6q9N15FrQkM",
    "SqS2nhE_cIg",
    "9NBrxt1utgU",
    "NfL_oe_MppM",
    "hTht2tCKD74",
    "HgzllMeTAs8",
    "JdgmL4IbaIE",
    "E_6j-TxbtZ8",
    "LNz9yJpXHvI",
    "qVrO3weHMFM",
    "VcoX4Wdh0kw",
    "N2s0mgzz7i4",
    "fkp-cVQxPXo",
    "6tNs8DITEns",
    "K5LkuRnF6JY",
    "6eO5SHafnGk",
    "Zqy6_OhOsrU",
    "uX-fBBIa_Ps",
    "FFYSlDrzlVI",
    "bkt3iBQsxw0",
    "-CEo_NVLlYM",
    "Im_RLrj5iQU",
    "7Z9ssAtJGfs",
    "EeztkRLO88g",
    "nDwIaVP87_I",
    "L5kz0FHhv8U",
    "V30PBHGS9b4",
    "eSVn2ZL5qkk",
    "YWfnysUzqho",
    "XcCh296j1n4",
    "BTA0Zl7p-nI",
    "HBL1-xBBbv4",
    "t-HNiwgmpHU",
    "tnqKELLDwWs",
    "FID2zr3GsGM",
    "_ueQ3k9olz8",
    "XSpxU4wS3rw",
    "fS_jKsBSwAY",
    "1BFaVjMLZWs",
    "Vx3oJDOwClU",
    "-viSFdzAU8I",
    "jpGoE19nysI",
    "f0xLaxDPj6s",
    "nw7K1iURJ-w",
    "5Y4DJCONIRc",
    "vsRpyrRh6W8",
    "_IJSAp3MKy8",
    "1kM4oG25pbo",
    "-X2rd11ulMI",
    "-OAXcMKa1lA",
    "taPa_mL_hDA",
    "ArlgyHpym5k",
    "QHyWqsPm2iI",
    "YNLbArfOspg",
    "IexyJEioSc4",
    "Iw4F4Ohb-fg",
    "em-6TyuGZBk",
    "4a-6WYNdnqI",
    "yA_O-5jm4uc",
    "ZOSy0mx_CL0",
    "xrVntjV2v9o",
    "xlF6RPLC_gU",
    "LT82uJ35L0Q",
    "KGA-FJuprU4",
    "goJabj4yh3k",
    "jasIu2qr8RI",
    "mWplJN7cBrw",
    "wCvH6DxKCFQ",
    "MWYi2-_2Yi0",
    "pgZ9z3YgitI",
    "jMNHiTUpaqY",
    "pjeVAru2s7E",
    "PXO_rt47Jyg",
    "Gd8b7uvDRyo",
    "QFibIamp7EI",
    "aUOrVPadycE",
    "jxF66tap_KE",
    "XmD9Ekkm-5E",
    "XNDLPNSSpPE",
    "87QNfTFHyoI",
    "oTw36usFVlw",
    "UblSj_1a8VE",
    "NmgtilEDYjA",
    "bmS6V2hGtus",
    "DKGfnwWvMh8",
    "pjLfDy7VSak",
    "EGp5IX3VeA0",
    "q07fcdnFyXc",
    "D_Bf8iliVJs",
    "z2NgiUT3Tv4",
    "xGakc58zZRU",
    "TsZHn_oysJo",
    "ojALjAGI4v4",
    "5tSDUVg2Cjw",
    "OW2VRJOcmBI",
    "-UsorLJ3Ppc",
    "GrTL-Z05j_0",
    "qcbvlcbzEk0",
    "Q-9sitwwrGw",
    "pDPnb-qEfnE",
    "gdlX63eobsk",
    "fDWd9PHL2UE",
    "5DN4itxoR0I",
    "7Qdqit0HWLk",
    "MgatqHSxsoM",
    "CIoZq9k24ns",
    "19P6eXcKYM0",
    "OSL0EMoCL8g",
    "dFaBDc3yRco",
    "-jT2IFyA-2E",
    "ZLDAvrPFfDE",
    "BLLdgmGXHlQ",
    "YiP1JvbzXC4",
    "94ZKt6udb0M",
    "9yFG2Z0GNPk",
    "VRdZwBrzrgk",
    "1UmJBw_493g",
    "3skCJrVRqqo",
    "asBAofuqnHA",
    "0JT7rSYeQOc",
    "KGuXaJS_01E",
    "rgAoHjwRHpo",
    "S8OeKg31axU",
    "EsQDPaNkE48",
    "6NYIltvs4Vs",
    "emuItMxtOs8",
    "ICWisnv6gyU",
    "DRM9Mu3hnIs",
    "ZTTbMhCsYk4",
    "QKGXHWyzJVM",
    "pdm3KERZzVg",
    "MxrVRqTqNMA",
    "YayHT_yRam0",
    "XFaohN5BkF4",
    "NKL8Leb1EOo",
    "j1VEXzEYog4",
    "at2h6FRSjPg",
    "V21npaSQdPg",
    "ebdIkK0mX7A",
    "PfnSUuqEH90",
    "bYRgRmi6wEo",
    "8sItsKl4LHE",
    "bniG4TOhzf0",
    "3mqUYqjqALA",
    "7mwBPld3TT4",
    "zQoiCKbyKLI",
    "Sd1CeRTvoPs",
    "cX1LIDvfJeQ",
    "wpQy4z3AEoo",
    "ecPm-qKHf3Q",
    "pfrZHPf-k-o",
    "Q7VXxOCErmI",
    "swaaLHO3T3U",
    "G63CF7dEEJc",
    "VIZjW6pCLeg",
    "DSXdxRH-RpM",
    "LT6hfwOXzaQ",
    "WCE3xlqLVwE",
    "KVVkhbJv-t4",
    "1_Cep6GGEGE",
    "xp45aOxa-SI",
    "7cb23hbJfwo",
    "4r86N8cBmCI",
    "p0MiySSlFv8",
    "HR8_SyfUZMY",
    "rd5_H2YPoBA",
    "iFuwQ0h_9_4",
    "0skQweIXlXw",
    "T15m5NjAtX4",
    "jcj5eQL2u3Q",
    "jqO9huJB9vY",
    "LIYiah2uPvs",
    "kSwCJRNU48w",
    "PfToNSGchao",
    "K4y8U7GhQxo",
    "JfXpGnWaM60",
    "SijEXgzIA3k",
    "h4VGZUvvwYM",
    "_fIcBZHBLgw",
    "VjfhHMgDlJI",
    "KeK0nRA2fIU",
    "SNoIB0nzoyI",
    "R4Kec0O8pas",
    "oOSM05gWZx4",
    "MoReJ7whsKQ",
    "ff2Z-a1TT1Q",
    "rVvmMK3NnZE",
    "T1OirV_FCbk",
    "ekImSba9joE",
    "iXtbO-VHKxw",
    "IjKstPHIEE0",
    "GNTl7GA2xQk",
    "4kosBuROhmw",
    "K8YLK75D96Y",
    "YksW1wXP6rY",
    "phWSUPlSt-k",
    "rS6Sr0L_duA",
    "nHJXYXKPDv0",
    "R-1DKiuCido",
    "PYAGa_CkVkw",
    "jbGZc7gEtG8",
    "TFRGYyoJ2pA",
    "K6jVQnR8TF4",
    "qWnSnySzJ1U",
    "mgVoTF1X11M",
    "5xSmPLGgM4w",
    "0iL5FMf16Zo",
    "ngpLgAl9wQg",
    "WwJix6OW79I",
    "zbU7FPZE6KI",
    "SJXX2oXeGLE",
    "PcvF_EjvLG8",
    "BPbEe0PlFrU",
    "TN-ZkOUAwtA",
    "tmvUXlAHUqo",
    "s9HS5u5y8kQ",
    "4kzoaSvqlrU",
    "y1BrDixkqiU",
    "AE-heLt0zaM",
    "0LAHlR-2_bI",
    "_1v74ez-FgM",
    "BfOV-HKZdwQ",
    "G3rY1HQuVZg",
    "aVXN6b3Er3A",
    "UmdSNGTIvnw",
    "uEzG7HnQEVM",
    "_RCcwQRJJAk",
    "DfvGOTOdbtw",
    "sUzvE8lTnnM",
    "7QvbFTW-ozY",
    "kamvQn0B9RI",
    "QqrCsiLDf88",
    "PJDvzsI36QE",
    "fRs5U7SD4Mg",
    "23LLy0O-tEk",
    "f-i4fIVLRVQ",
    "hNIT3ZgBFPA",
    "xCiO2qoU8os",
    "u58BANN1-CM",
    "cD4BCciBnB4",
    "hswqFhQux2E",
    "P7KnoIfsHm4",
    "n_I3vUqyQDo",
    "W0qvZapaEKo",
    "OcbE5Ab5QrE",
    "GUrnYrz0wH4",
    "vEpoLGYBb-4",
    "x_m5BErpTBA",
    "RyIEUJEfkQk",
    "NVRrbol-lks",
    "bKwGwZSABzc",
    "pNuCZ6B_X3E",
    "zUOTkxnyK9k",
    "3GNvyMCicss",
    "7uK9ky8lZGE",
    "ncAUbsvN4v0",
    "bsPgXk21sGA",
    "yTpSTKQeLrA",
    "NrrvUUNItzo",
    "JK4nfKUiKgI",
    "Ole2rNAQBS8",
    "slNHMlwuHA0",
    "RMA2MaRAPvo",
    "x4CTttT1abc",
    "A1D7mA6zAJY",
    "Mcpnfgr9owM",
    "5yNHvBMZBVU",
    "KpxjDrRZKZM",
    "QkpfPK-wEtw",
    "g_7z10EUb6A",
    "qeMU-iV8dBc",
    "cr96qjV40Jo",
    "i3AexMWPNTk",
    "d4xKXoWZxO0",
    "UuMsx_b7mbY",
    "u5b8PbTk230",
    "5n9Zeic4TWI",
    "TKpex8plB1A",
    "tHsF6lga31A",
    "J-5KsZLI9UA",
    "174rH-8hmTY",
    "8Yk_JR_uX3o",
    "D6KprLt8u3o",
    "0qRyo_wmWeQ",
    "-BrKfBMfj70",
    "4BcoWMVYc2g",
    "Htbi7lDtkdM",
    "bKbsHYgwvMg",
    "SGkNdOwncso",
    "I6ImoQDoWIA",
    "7o0RpDnm1DU",
    "OlRvi092zYc",
    "FCWZjlgA4eI",
    "ptZ_LTti9hI",
    "SoPQmumW-DM",
    "Usli42rH71s",
    "cYExE7A2Vow",
    "YXL5BnjB7uI",
    "BZRLR4C7xFI",
    "y6A_fCWGfE0",
    "nduiuesPktM",
    "F9f3BvIBKXA",
    "MXeszlRO4to",
    "aHBfhkVhLN0",
    "0t9lpvjT_gc",
    "mnUVpaQpPoA",
    "72Xbs1ftCw8",
    "VmfMd2A2qJA",
    "tK92-rAy7cU",
    "s3bCEnBmlho",
    "wASbgfjuzps",
    "HR3T89XhmdA",
    "yy_iCkHlclQ",
    "-cjVYuSlC_Q",
    "c4bu4x32fNM",
    "M50o66Gn2x0",
    "keUlucyo_BA",
    "X4rIBn9zIIM",
    "x4vN0AUivDA",
    "L9NeFWo7L3M",
    "SQvG2hJ2dIk",
    "zkpQ-ln-In4",
    "sOO8LZDjKqg",
    "_LGLWUs9z_0",
    "LvYH0DwG7CM",
    "fQl94cf_mlA",
    "pQ1VH76JQ8w",
    "Fat7EZZ3af4",
    "QY2OWGApXIg",
    "M6yXINLvRfM",
    "u24xrYmxRyg",
    "cPEfdJsfgW4",
    "UYDd5Im2ctE",
    "5mOua2H0obw",
    "9-_4D1WjG0I",
    "ZpO9SnVChyo",
    "pNx38P11ts8",
    "_jL9_SF772M",
    "gjfsjJpFssc",
    "yqGVntHsBVo",
    "ucGkPyv8OXQ",
    "Gy1f6iyR9X8",
    "TNF-U6d_rvA",
    "0hoG6OQ4fDA",
    "4icvmhe91P8",
    "Xm2Lr9AMPlU",
    "xAx4aIgeUwo",
    "nvuQ2VUcgCc",
    "gytTM9n-wv4",
    "glOPtpIbEzw",
    "tvGFIZP0nnE",
    "LCXFyzVJrg4",
    "Aq8ToxOb0yU",
    "vXQlqizpQrM",
    "gQFJUIgWid4",
    "FxV17DPRtSI",
    "xPfvDQy3ouI",
    "R2Zzj2XIDYQ",
    "gxxkRLZZqLQ",
    "fH6vO9ekhPg",
    "wx1_opkY_o8",
    "j07m7zdR4Nk",
    "OuV9c1AOEJY",
    "FQDJBBH0Bts",
    "kyCdfymjJdA",
    "VY3hI5Tc-wQ",
    "e8G7trvV0Hk",
    "ixlI516WpzI",
    "sOD5j3b4PoA",
    "w0P_bIP2pGI",
    "qCgYcyNq9h4",
    "Rei74hoxTcg",
    "FbKhqKQd6bo",
    "vtZj8v3-tUI",
    "Jv_yfdbpFJQ",
    "tuFZe5mI0Y8",
    "CkroHtn3qWU",
    "fcnMUrvjEDU",
    "1uWQYpVoNJg",
    "7BnYWR5GqYg",
    "ULB8NSKDN70",
    "9NVZA6cyEpU",
    "e2wvMBlzK0o",
    "CHUsKOqcCPk",
    "c4JjY2gZ2xY",
    "KhuiAnTziZs",
    "agxvFSfzz7I",
    "nNMMmr9vFAA",
    "wZMzZybJ0Kk",
    "jGxcz6hz7ko",
    "K9Ba884q0wQ",
    "ifGAu8tvwws",
    "9DOdKBF82FI",
    "x-RViUwSImc",
    "SS3ZIa9mJ98",
    "cl89x1ciqEw",
    "ld88IK1Ik8E",
    "XpK-DNzjGQU",
    "YUApjMW4hnY",
    "2XFVKVFyX0k",
    "BhaC3wwF2XM",
    "-80NJ8GpMEw",
    "e0aR5GJ1RAk",
    "uuMxxYEroQE",
    "1oaHeeXYMA0",
    "TS8kvaDWzlU",
    "YFnILpegUKE",
    "hbzpou6wEFk",
    "ropHoqfIMXw",
    "Q81a4nrioNQ",
    "kl24jLoCbk0",
    "oaHICSKw2bQ",
    "hV3MwSe-Ihg",
    "CM9fPEPKkRs",
    "ZJjm5rajEE4",
    "j3lTutyym40",
    "jdT_8eqOCEQ",
    "Qapd0StP3Gg",
    "YnfA8j3n_hY",
    "4sMraUbp070",
    "e2zhFRKPoN8",
    "7JXyaX9PDc8",
    "OqNE0tQnATc",
    "WCGKjSp45LY",
    "ysk1xtdqDEw",
    "v1wZ8Y8R7t8",
    "RzhVg99CXRs",
    "2x8fC7MsSk4",
    "BAddlGx8jUc",
    "iBl0g1rPzb8",
    "kRUECHeIgoQ",
    "8Z9Hwpu-f8Q",
    "u5gCyXFkEXs",
    "Jr1t7RQz7ZI",
    "jvjHtUg0G0c",
    "yOHrnsMFLHg",
    "MSbty7Jpd5U",
    "CNhQBxe6arE",
    "HDublf-q5zo",
    "1cOjZZarr0M",
    "2wJ1WeuWP1o",
    "bcyvNl70a6U",
    "qSpwjFhd11o",
    "gvEmoQTq6Hw",
    "GBfTBF1EsiI",
    "1gzG12aJA6Y",
    "uPJScKBoIRg",
    "ibf3qpmJKc8",
    "Drsi7INvNS4",
    "wcNTquiI4zs",
    "ohuQ2CvQHrI",
    "nfjknp-Khoo",
    "2qgDB7Jk2T0",
    "ptV2HIRUo_c",
    "MBjl-_aRqsY",
    "W7LwgdgvdI8",
    "Cy7FFEjOn5E",
    "W6c7JJFRWjY",
    "AhYy_7sbIkE",
    "v8Mho50HR9o",
    "urXpH3AHZ-U",
    "XYipyYYcl74",
    "_WQ4JXscgqU",
    "JXp1cR8IDnc",
    "N1bQMtf_N44",
    "8boD8k8I_kY",
    "opOmIBIcDNs",
    "MfN1h19BQkk",
    "fXdoUGzg7IM",
    "B8X_XA-O5rM",
    "XPeS8sKliso",
    "ukQd5FRpndM",
    "KYUc1tCkKk4",
    "Kh3pH1Kvb04",
    "9mYfSYME6No",
    "TazLqqLkmm4",
    "k7srdlpvCWA",
    "dnW5sVciIKU",
    "D-sPwgoTfhA",
    "qOnJ27cRMCI",
    "t8zrhvZeL_c",
    "QO7hFejO8g4",
    "RxawfxpxL-E",
    "DRFqxnUa3gY",
    "ed7Cphu2IqM",
    "txMF_xU0c9s",
    "SfZzDIoAu3c",
    "NKINpbJIl_Y",
    "0AMMK22Exwo",
    "-Cw3mHfieKQ",
    "kOL1Wz1ujU8",
    "EbXaDXTsIH4",
    "CgCoN1MeZwg",
    "c7JxABHVlv8",
    "pbzmsnZcWjE",
    "JXCmD7OKMng",
    "S8FCe3Jq-xw",
    "usM87S4IGeY",
    "1E9XPN4aBC4",
    "nQJtoWipDOM",
    "2AmDKjoZBaU",
    "IJK_zTo_jeA",
    "sMrb8iyV4nk",
    "KYbgOUaMaD8",
    "QfNP84ZcJ7o",
    "alpyN91SSRE",
    "SxmgXZwGqa0",
    "n_b0P0uq948",
    "jeH8dvaCQv0",
    "4DgHFQ3Vk0U",
    "2lB8eBYya_M",
    "2IOh8ISwTWE",
    "AZOubbUw4iw",
    "SYxzJA71A40",
    "7AeTFHxEW-o",
    "WdbXl_o_85s",
    "Thw9z3mauS0",
    "8HcStQYcBSc",
    "xIe5Ime_nhI",
    "YgjHD7FiaBk",
    "FLd-h4s8FaI",
    "dzGX8naTAUE",
    "gwMCfLTWm7M",
    "3Ygrf72saRU",
    "XaJo4Bn9avw",
    "06Y8nOzIj9E",
    "xe2ye8GyPxk",
    "wnx1f6U4ZDA",
    "dYiod4XQoCw",
    "SfxDougtgNw",
    "sp3Hg5ZRR7c",
    "ddwgv4yH75M",
    "5-jNH9NSxCQ",
    "TQ5fnxYJ2Jw",
    "RQckDQwriJA",
    "UyonUlXJtyc",
    "136GZSBa4ec",
    "fId6BUqjEMM",
    "iUHRYcJTFhQ",
    "XRN_RQaU3PA",
    "2ZujrWy8LhI",
    "HAm0NkoEOMg",
    "6wZUCCuKeAA",
    "J0yEEVnXz68",
    "a6088OH_tA8",
    "lhyS-RCu6EQ",
    "R5NjmvPBDQg",
    "RGblBCsB1r8",
    "0CLzMoR8ZKI",
    "lWovKcc4XWE",
    "8RILvTaixQQ",
    "6vSjF6T0--c",
    "cSJD_Gy5TCY",
    "KyEDe0ynBxI",
    "bdflUVpMmsE",
    "nIT6QUGyfYg",
    "1gyFEt2zekA",
    "RQ7pvPOkzf0",
    "s_6hlFgQ2_o",
    "kVKYqLa8QLc",
    "QUlutSrmXow",
    "AUcceEexCR0",
    "gIyojYMpwVM",
    "-ML8yclv3i8",
    "nb66zUyR4Z8",
    "D4aLJt2gfG8",
    "tWCoL9xJxQ0",
    "nb0oucCpC4s",
    "mG0SZMqgNHU",
    "DhNOHIU696Y",
    "Le6WSJiHXrg",
    "u3JZW1uWxpM",
    "UcDis_FM4rw",
    "D5avCQWPK2k",
    "m5bEjIDz8u4",
    "97gwT4dUJS4",
    "DtrcpWZjoIE",
    "iGSBIpiWT1M",
    "LigTD_SX23w",
    "T0UBng3amPg",
    "e9m4zBO-odc",
    "GGyxWYR2ruA",
    "PwRx-c-vciw",
    "ihI7uugHM_g",
    "VP1-5YOzpX8",
    "9d3KSZp_XuU",
    "Y9isv5HQwkU",
    "yVsXe2Qnfis",
    "XJDnQTuCoMA",
    "Dzgqy3Y35iM",
    "7TDi7I6bWb8",
    "JMaYKt-vcjY",
    "_kkArjVX1-Q",
    "d3sOEf2UNFk",
    "8v8G_mT45hs",
    "n5aCuuDdDAs",
    "pFSBfieazrs",
    "73_v4vSZjl8",
    "Aq-nodzz6YE",
    "dsk-lV2G5LY",
    "Rulwmtb4g4c",
    "HrTlgcH1Xrg",
    "qguUsGr2snk",
    "vpSXw9g_lHo",
    "CHwrHT_Fz6A",
    "1dpfIRZlgT4",
    "INu_z8Zn2R8",
    "EWxH20fHIx8",
    "_Xyujl6_Rf8",
    "aU1BLMPQ8P0",
    "PcPLqZFJek8",
    "gDyLf-jDf74",
    "otsi1nPZaAY",
    "z6cFg2ASJzc",
    "FPUADBKGJ74",
    "1LdfweGwgPs",
    "9rklYeT9tQQ",
    "m2K_Gp24T78",
    "CaeBl-WDOUM",
    "kgiMy0_2xbA",
    "yqxsGb_2tGQ",
    "Naje85wYxOM",
    "CK58C3ph7j8",
    "1sXTscKR_EU",
    "x61nLZUr-qQ",
    "z0FQUfH8V7Y",
    "2ybFyhkttTw",
    "8yeQrrrDHao",
    "7dihX_OhLVA",
    "Ymos6O871a4",
    "ExZwJ6kiJnk",
    "E7y7BqonfAA",
    "PkxoEEavPZc",
    "DSlphvKLTlE",
    "d2GiufDAGn4",
    "x4Kbw7K2sOg",
    "Yvv6bNhYejI",
    "HMJOyUerMJg",
    "gTb92SAw0kc",
    "k2VHCEyVW4s",
    "-3h4-SlkBeU",
    "cDRSXEWIw7I",
    "a0crb2oEsSo",
    "EKaxw47fRsQ",
    "0Xnc2ea6vPk",
    "vuw7ti3IP5w",
    "NqqCRoGH1-g",
    "sZ7fhBDPf54",
    "DFxAp-57buo",
    "Qk-9LJa7I4c",
    "T4ZarttLEcY",
    "5w9anDxf8GY",
    "NcRPUAcpuu4",
    "D0oRSZEWFdw",
    "Dk58gGv6NZ4",
    "0zF3hhJzji4",
    "OT37H2Jx7Vo",
    "6U57NSOvXVg",
    "DRk5VfndiH4",
    "C8Fmovh-Z7U",
    "8C-AR3RcOxE",
    "yzyoK9g0e3A",
    "OLKeS8uJUJQ",
    "Nc7TrW-JD2I",
    "f0vJO8qffZw",
    "5H1cETm_aPI",
    "G2vopy2zMAU",
    "1-puHkg69P4",
    "foDkWDhNnlY",
    "rRrWG2J-31U",
    "v2tuHawN0Qo",
    "ItTGYDBn7Ik",
    "YVVSJ_WpR-o",
    "GozCND-zP24",
    "55HbPS7f11o",
    "YD2rH9rnQAk",
    "NQqqQrCy3Dk",
    "H1TS804L7b8",
    "76c9psSTSjM",
    "JkLiQd4Hm4A",
    "187M5HYPdxA",
    "Don3xbjOcn0",
    "KOGA6GW7BTU",
    "Blk4nbbSrf4",
    "gFya6wmfzhM",
    "4r7v1bLMSE0",
    "e1l4T7h7U-c",
    "jKC2F0tdTls",
    "kOKO7Dp3Zgo",
    "gwMSVQN5Les",
    "ueZ0gQTQJBk",
    "20SPJVNtJfU",
    "K0xWvVFuHFA",
    "oeqkucHBRiE",
    "Qa1lXvgjRO8",
    "3f3rvSs7f1s",
    "UzmLry6ITUo",
    "VCnJj-ZNcWE",
    "Z0f32Te17EU",
    "R7wXgeLikxs",
    "J1aREGMW5bs",
    "Pfpj4xiq2E0",
    "izgFHGlHhqU",
    "zH7BeqYv4mY",
    "vhjis76_k_U",
    "Qgu-h2xGm7Y",
    "tG46m_R9Mzg",
    "eo7Rgmlx4lE",
    "ko0uVAB42dE",
    "9P6MGYa_SEE",
    "S-qzyzMNeJQ",
    "9QhAOQ2wHVY",
    "zNgDe0rUoIg",
    "m09_NKEwDEI",
    "6a6bzODQjzE",
    "74mv6ekBLR4",
    "dQ0w5y_c3KU",
    "0d3oZKk-Xfw",
    "U7qx9Hu-Eos",
    "j2Xr5oV42_w",
    "xtFvUDQQeY8",
    "KYhbSxTYucU",
    "lNs66RTC3K8",
    "C5wPodu-lBU",
    "CZYOUAOgtIo",
    "eC9p92UZmTY",
    "cVdPxmi3FRI",
    "HRJ2HlgLIso",
    "o6pWQ6wrMSY",
    "bNyx76_i22w",
    "3iWa5kfDtPI",
    "57JRyao6rUM",
    "gzIa0VZ_Nco",
    "lEpI0t_Zq08",
    "d0CtUrTBYdM",
    "sklkOQwLU00",
    "TsitHg4Zncg",
    "howte7OajD8",
    "8w3sfHtTaII",
    "CMFhsElmxOs",
    "dH8nujNobd0",
    "s_6WUbBoi6Y",
    "4Hs22m4hPUM",
    "wDCZl-Ul_hg",
    "MP1mI6PM9Bg",
    "H0E6pJ13RnM",
    "0wlPQePqk0E",
    "a8iXCKQUxj4",
    "IRwZWHBdRqU",
    "YMhkBUrqDEM",
    "YcqLKHYS9z0",
    "j93OpG6XewA",
    "_gNWBBXvmYY",
    "7vkcfgCeTgc",
    "C1HBki-GFr4",
    "xqD4Q1BhSWY",
    "ho9FIaF9zSg",
    "YT0CvDRbm6s",
    "djq0H26TXaU",
    "iFDZ1Sy-UYk",
    "YI8ZhI58xsU",
    "OdGuEdGGpN4",
    "vvzB4qXrhD8",
    "gtEgtyaIbnE",
    "2FVlQwUM6OI",
    "Mm7Puzls6dA",
    "cPthitQPdsA",
    "68EaeBishqQ",
    "TpA7LHtEIG0",
    "QS_YAK3_yAg",
    "S5MBYfbC8Y4",
    "Yu864tcVfE4",
    "hEmG-iCG0P0",
    "5Xiih2lTFSk",
    "kjz9J2Y5hP4",
    "_goeSsgwTB8",
    "nabL0ibgnv0",
    "119IKk72pb0",
    "SgYEPKGU5jA",
    "-ksnF7eJ4jc",
    "32H5Snk18dg",
    "SyfuoM5ZZYQ",
    "Z-bpYNxUjEo",
    "zBqY9K-YHto",
    "JPEqDGI4wdY",
    "yEwXk28I6s8",
    "hI992jhRue8",
    "BA_aZF_rEy0",
    "Y7H9fu1ODTE",
    "ociiOJsJRGc",
    "GSfR-S3tsxM",
    "lASJAYRowuk",
    "oQVAbhvEPTI",
    "x9DOWcSSV5k",
    "8zkBB8zUyS0",
    "0TG9E8DYuzg",
    "T2xXnvxD9ec",
    "r6348aATBlM",
    "uh7vHGaU1XE",
    "MvNusRoeHRc",
    "UQjaKyPKQt8",
    "JNpOIyZibsE",
    "UyTEZ4UFFDI",
    "T5LV7B_0RX4",
    "NKkBZstp3ks",
    "fi2vCt3xrHQ",
    "qjGmuuIm7-k",
    "ZVKvhRL6Mx4",
    "TZo9gq2RmEI",
    "6zZmVx3I0-Y",
    "kMj8KYrcec0",
    "r_NZWYBIj38",
    "fcJUrO5rCCY",
    "JAM5z5MpfaA",
    "FwLrhojKB68",
    "JFVNdKfgieg",
    "62LtuNTNScQ",
    "1N3J7XkNDhI",
    "_YWb9mlBUoo",
    "soTkPV4-8YE",
    "Sqwbk6U3suY",
    "jhclD9jkv1c",
    "PcQoXNH4iWc",
    "6jPz60LsOxc",
    "X1Em4_4NWOk",
    "K_S5W7acUEY",
    "MZd0Gy09wSc",
    "BA_y7XEmAoo",
    "e4AKRYHpczQ",
    "sGx1b8iiAzs",
    "TsF0kdafExc",
    "MzVcbEXCMbY",
    "Jk4J-s5YuUg",
    "j5bhPNY_wc4",
    "p47xkY6dnWo",
    "bO-AMbX0IU0",
    "X6yLg96mOyw",
    "QpaXypQI6-0",
    "Opw7a7Q4isU",
    "AypH1MF3pDg",
    "5QthGYI2__I",
    "z6Xt5S679SI",
    "C7-k985ewFw",
    "gaaEXbWEE_8",
    "rIz7TJlfxUc",
    "hAivsjts0xw",
    "_GqlgDZh3EM",
    "-ylsS9AzVGM",
    "PRu1iWxQHHM",
    "InwFM0pWH3E",
    "7ZXdDqkvkSY",
    "BSx0WToTab0",
    "WNaGTsDpwc8",
    "XeGGqvu1au0",
    "MlzAwoeLQ1Q",
    "T98GF1Ox8uY",
    "oosW_zrLFfc",
    "g661uzsBLvc",
    "GbOndQ4zJ_k",
    "deYPI-otUY8",
    "4LnwtQ1Vj40",
    "kAopWtnqJAA",
    "2jzxqXkONg0",
    "58f_La0z_e4",
    "9CIGkk0fzmE",
    "9493HzkdTbo",
    "nhdXC5MiX6o",
    "mLXO_pIRv7o",
    "3GBppO0xkCE",
    "iugvWRXD3rc",
    "NARsMqOCBvI",
    "SxfWq6dQbjI",
    "KtfDev323fo",
    "Mg-WCOg53zE",
    "S8bbCSzyINE",
    "MNA2bA5ltuc",
    "tsCUXwligMA",
    "VHrv-ATvaNE",
    "4N92ajI8qo8",
    "A7dXcO2encY",
    "3r99k8eKQdA",
    "3z4Zr0kOflY",
    "3CyIwHTzHOU",
    "YtfLrdYDv1o",
    "jQhBY7iE3oo",
    "bzIvbCxqoO8",
    "ImiGwxqCNs8",
    "9brYGDSkRD8",
    "3_cQBL76gvo",
    "R64ZmuiDgyk",
    "axiIy04jaNM",
    "JYJUpKkBE0Y",
    "S0ZlE2PKvGk",
    "ivc6DY-FIdI",
    "jujh3qPurWI",
    "F3eANESJqeY",
    "tYRMoqHIkCs",
    "SPCjpe9na9Q",
    "t79Q7iIO80s",
    "AAbqOMV9CLw",
    "MOpzQSm2_g4",
    "kLlhW86wMGA",
    "LovV2ukvjiY",
    "6JodG_yD8kQ",
    "j6Gcba0hETU",
    "KAJgeDdHtQ8",
    "nUZAEF6ZBXs",
    "Dv5Bv9vXMYk",
    "ajmKrI-6J2E",
    "Y1D7PNMMdKs",
    "oHTyrzfzLf4",
    "mGYDBmTngRc",
    "ODyObSoKmAs",
    "HRP0eeinVGA",
    "KBwFCp4vblg",
    "rz0N6sLFGPw",
    "KTCp2x6Qmms",
    "1BuCGj-ZGoY",
    "hYYyjLa6RoU",
    "NcjFq48L5xk",
    "VgGTV7wtSRg",
    "LlTucZWtYwk",
    "CWxkX3ikUls",
    "oifPJ3YO9UM",
    "nppedrW6C8w",
    "uMjxWVt5u6w",
    "bzIUjiPUj50",
    "GClVB5kstOo",
    "TCWdzrGX2ic",
    "s688i3QPedc",
    "9BmmdjHWx38",
    "J3QIRC4nO5s",
    "JkBnqxzgu3A",
    "w5WloM73EAQ",
    "AcQhUZQwB3w",
    "I_aMf3NLjJk",
    "LSWYue7ekfo",
    "6heUtR3GZaM",
    "VlF3LQtwCjs",
    "mnHOKIcs4l0",
    "fqmm43NUfl0",
    "I-_hmzu392k",
    "UoyK1NsXONU",
    "94Ip-MWqVrQ",
    "mv54gRpremk",
    "6ZPk1BuUdhE",
    "XhFfNgA7mZw",
    "jCDdxVvEIkQ",
    "tlgsXMQuED8",
    "RWHXpHpQWLs",
    "YQO6VxQdVC8",
    "M1rV8Ymxbaw",
    "bQPMNpuRirk",
    "K-0o2r_3aC8",
    "5dQU4MKE28s",
    "gvgjkR6k2nY",
    "WK8P9jj7XkA",
    "cgpMTd2-MA0",
    "AP0ygzKW13I",
    "qlfvGGFCFg0",
    "tFzDTbTk5xA",
    "kpsHCQxFkT8",
    "U-vo6dxajLE",
    "HmH4LKYUoQ4",
    "DivojxUz9bA",
    "kAGEVCLlCMY",
    "rjxbGIx82xM",
    "Qse66hIeHh4",
    "qdWEN1uzyH4",
    "teEZpGAZzAc",
    "ShesuTI-BXg",
    "qwoJVGkHQeE",
    "EFLTUZLdhX8",
    "rl6nwne_cPI",
    "JqHFwkb4fDA",
    "3q9s1dBDZyA",
    "hrKZ_-JxHe4",
    "KSYOyYNNYvs",
    "8zNxEaQ1WiY",
    "kjkkN8RnehI",
    "sC3DeQExqQo",
    "haEkhKXN2e8",
    "wmsNiNsVaQg",
    "kafasnLu9Y8",
    "XFRbYo1G4S4",
    "Px_Ft7L9a1o",
    "g1ZA2luTX5w",
    "_l_-R8Xeco0",
    "EwO7FnClLXU",
    "Yi0ERENViF4",
    "xnDgYKbw9I4",
    "besbG7XGYQo",
    "dx4y78w5BRo",
    "FAl9Dnt1G7Y",
    "wRyVPxyPg9c",
    "QNv5-D9S-hs",
    "ogyChFcRcVk",
    "TIbob0_nZho",
    "G3Fujj6GoMY",
    "GR3slYhJHEc",
    "Zzy33pKVIPg",
    "pt_sACJ6LJg",
    "da72UjWtQVY",
    "JHowd0Vza_E",
    "yWiV_CMi1FY",
    "ps7emwNPsCY",
    "6sJ0b4eMPJg",
    "ZN8S9CesJ0A",
    "8Kq9B8KxRwQ",
    "mS3uE5MPdEU",
    "g5f09_Pk5CU",
    "4QpAgmuLYp8",
    "05XBMmz3DAQ",
    "yCnlaGpGOM4",
    "D5Us2SHbb7U",
    "-4X1vbLb9LI",
    "MhgByug4dvE",
    "oOyh8YLNnQI",
    "OdQpkjZjXwg",
    "D5RcuPMBvTU",
    "WtLaRdBsnqo",
    "yPCGdbgIeSA",
    "oKDMSU81kKI",
    "BkYUSPotbB0",
    "8IZxbMgkevQ",
    "kGWI1-0bNPs",
    "Oil_Fh6G3SQ",
    "yNLH7HyEcRY",
    "bdCVydFfeCI",
    "OzXbI9bmFWM",
    "jZ0OPxOlC5Q",
    "QBwqA30W_E4",
    "NuJirhBHFs8",
    "2sviiqy8GJs",
    "nwzbKNRymjM",
    "HoCEeWaj70Q",
    "EQiiz-xQD2I",
    "BOce4-Nbm6c",
    "RN-pnCav-VE",
    "vRgbrshH00o",
    "viRlWWojch8",
    "00z75tAZ2zw",
    "7Ay2ArDdLiU",
    "UIfkIlKim_Y",
    "VZYBTYIG404",
    "2t8t3wrVzpo",
    "Gne0rPS0alk",
    "5cojkp5rJ2c",
    "34JTZVrUDrs",
    "dokoUtlWpLc",
    "PXkiQmBW4rM",
    "1yac0OkJigo",
    "sivDMz_W3lA",
    "xrrWmlvi5nQ",
    "OXKPT9YH53w",
    "ek4hIYuIqVI",
    "ZSZAjhH7xzo",
    "sPISo29QgYk",
    "B4Ifz3UTWAA",
    "rpgrDEhQgzk",
    "DArRi_PooDc",
    "t6jtyWeukAk",
    "TNIShsbnpVE",
    "U8odxB9G09I",
    "xm0B9JY8myo",
    "VrQRC7GdqbA",
    "zGqvN-vLWiQ",
    "t8Xx4DMOwmc",
    "BKqp8bLiv5A",
    "KpqEqUnlWGA",
    "ymiqsiLUvLE",
    "2DxpnScsnR8",
    "F9R1kAPHtm4",
    "BRWS8ZcHGnQ",
    "0yMMJ3SnZV4",
    "Y5v-16EIHMc",
    "PI4l3siBuMc",
    "Dpy3tJ0zewM",
    "FVbHHg-hMHE",
    "9FpGEO_FBcs",
    "e_J91hFDW-g",
    "TsMQaHTG0VI",
    "2bTDCBK4QJ8",
    "R5w7OtZuzTY",
    "ktm8LcW6BvI",
    "lJrkVGsnIr0",
    "NnCeWgSlBeE",
    "QVqWh6CrkHE",
    "LTPdHw8SLV4",
    "NoLuNVD8en4",
    "jQZr9-lhiZ4",
    "oR9ygW2PkxI",
    "iQVI4elV3RU",
    "LK9FCcMqQW4",
    "-4RzgrC-bEk",
    "XsDWhbMBkFw",
    "mwEUwwgR1VU",
    "uOCx-zQ-2CM",
    "Co0mVqM1x0c",
    "UFrbiByXq0I",
    "hLG2uWvjsag",
    "Ik-8IHvJDZU",
    "1DvsvcElJnU",
    "VdLmhINUtRQ",
    "obvWWHa9Qso",
    "PvohsKYDWS8",
    "jTEEiar24vY",
    "O5-EgsZ1ZYg",
    "0b1CcRQx_W0",
    "403G2MOPBXU",
    "PVCigQELKfY",
    "h8wELKO7Hd4",
    "gKRnLaajMB4",
    "Eb88UpZqz6Y",
    "BXq20V_swFE",
    "c5yAVPciLUY",
    "7dfyEg_NZBE",
    "2t9oRHpE9jk",
    "RQxroK7btKc",
    "rLvY8s3rHlI",
    "79Q-JpjWVGM",
    "mAX5ESqT3Gg",
    "2KckCNG19_o",
    "vCVhutT4kJo",
    "MMI06TlnSes",
    "q_Wuf4X3EIM",
    "DJGoENOopyA",
    "ByDWzXtdqqA",
    "NL4TE8_ZTd4",
    "rEO_rauvOlc",
    "3MVRZEgO-Jk",
    "So6Svj5Dum8",
    "Y8yWMe7GacU",
    "N1B1lKHIfQ0",
    "gekncqbW2pA",
    "W_t7S_Tfrm0",
    "INOo19S9lwU",
    "JHBGeV4JRzo",
    "cliwMjwqHts",
    "Q1LvHIp6LXM",
    "olqFXy7aaLk",
    "yTUw8XexXfA",
    "R8gCA8Mz3HM",
    "yTqNCj59XqU",
    "SjwxXIXX-1c",
    "_peBDGxL2EQ",
    "nR0B0LHP92Q",
    "X0z3XmEJNKc",
    "cOULawsDr-M",
    "Bd8F5DMexc0",
    "BjM0wLTlUyA",
    "YRZRey64new",
    "S2rc1ypu1r4",
    "i6qZE57bZYY",
    "6XBFzsTgUZE",
    "B3As645bwLQ",
    "sI3dyUM3NfY",
    "mYdUcnXeokI",
    "411M6YDpuNM",
    "DQv0Y9pjY4g",
    "tNphK-Y229w",
    "fvIYHRYUz2U",
    "WwzZlxSBxpM",
    "klAsa2TrfJs",
    "mco9EjLnDrY",
    "9Vu4pFkhONQ",
    "y8zfWStYFEA",
    "__A1BmLWdJs",
    "AByMaM_lWoY",
    "UXuQAPcPI60",
    "gOHfVGPe5M0",
    "QW3dCihmMWY",
    "skAFz90wvcw",
    "eL-3BgFQtd0",
    "8E856J_MHh4",
    "sxv7RUZNS-Q",
    "4ug3MCbZFvU",
    "Sgmdjg_oPlw",
    "yTRik4H01sI",
    "Wu7EbMdX8ag",
    "PznefrEgScU",
    "ULGloS_cPEc",
    "jg3DcJsO4hs",
    "zv6EWY1Qf1E",
    "kjEG5wt7De8",
    "XAlBejSjKQM",
    "YuwDPneVovQ",
    "-PB_Pw8c8qY",
    "Q9INN-lupM4",
    "isa7BBueOac",
    "mair1qP3Eg8",
    "ztrqTyOqB5A",
    "ufl5rXZYq_U",
    "pyXYNQRevls",
    "TLlvuc52HL8",
    "PUz_nel4FXA",
    "Ah8GNeS_jvw",
    "gi69i2LcEFA",
    "5MwKeIOvao0",
    "IhM1mKfDK9w",
    "cJkqx24hcXU",
    "pdoAoQV8wug",
    "6RTaUMJeCgc",
    "ihg5WXmCZNE",
    "wpthBvRy8nE",
    "Y3KnTvzaIWc",
    "UtBOD2Zqk0k",
    "vPtfClyN-x4",
    "9uRKg8eii0g",
    "ATTOc_w8YJQ",
    "T1ENXDa1YBA",
    "UGfY4E7fh8Y",
    "Z2hj_QBMBaE",
    "qmHM2TKLvUI",
    "tW_enJNb9y4",
    "3V0LULT0VaQ",
    "dvAgmld5cDc",
    "QgA-wkaxXqE",
    "MH3QzyNTW10",
    "nm_e7cTO_kg",
    "ziFrUBwcTYE",
    "Y6YdAbdbs7I",
    "To-AatGIrdY",
    "yDjSPYXMr7A",
    "tqG8O_OOkJI",
    "WEmVrAT825s",
    "BBP0QXKZ3Ng",
    "CR3Ue7TkG0Q",
    "elr0dkluQVo",
    "oTDLwE0ct6Y",
    "wQZxuuy8fAw",
    "HvnBxzrpEWM",
    "zqMz4PU248M",
    "NTyayF_ZhuU",
    "Ser8Fv6iE9c",
    "NS9BJrZx-2A",
    "dHFmj2Rsb20",
    "XWq2erM0B0k",
    "weWxb6VrH9A",
    "o2xMUOyoodY",
    "3RJfSkw5lq4",
    "q0K8EoJE1o4",
    "Vz72F--iF6I",
    "3p5eE3u54eo",
    "xMm47cT_qew",
    "D7wtzeneaAI",
    "bnAWvDayyK0",
    "pu91di0HKMg",
    "cZFhVy9Z1Lo",
    "e7_7SpZagbA",
    "u3zViqqg_cc",
    "cQLx2oO0UUk",
    "RAO7-EMjJoo",
    "qir-R7P0V4Y",
    "hIW8ACFtbGY",
    "daTwEmBN10A",
    "WdvBznKiOd0",
    "uYscquI5ZME",
    "8accgRg7_KQ",
    "xano1rpWsKw",
    "r7QJvkIF8V8",
    "pcWSzMnQyVs",
    "Nq5uRbcd2CI",
    "l9IPQMxJen8",
    "R0eV8vsYTeo",
    "Pr8JXwO4C7c",
    "UuwGBlq9rQo",
    "31nvwtQLBLI",
    "7yNEB8COiHw",
    "lhc5hNesDTk",
    "grWymjch-Wk",
    "0tZb0Vm_Dr0",
    "-VHrrGxwAWI",
    "OL01R-_Nq1Q",
    "PbpM32RTDK4",
    "JEWRPYBmt6I",
    "7hD9eaf6hk4",
    "xU1ok1CyyAo",
    "hvGJlKqGOY0",
    "MXsz_vivWyg",
    "mJzN1xq9Q3o",
    "ZbGUuDdyVJw",
    "jVbfiw54VEo",
    "u1HPwMotbOU",
    "CC9q46pwGlw",
    "8Q3QKbv3Ef8",
    "g88r15ojHSg",
    "SmH2Xz7AShc",
    "LNa8aYWj0FM",
    "taEJLBxg1_U",
    "grTlC8M7Sjg",
    "fgZJp0uhiEs",
    "4pbAD3DA_SA",
    "kha5CPdMZzE",
    "DNGw7fr1Jbw",
    "bkZ6G56guUw",
    "fcJ4XIMbrrg",
    "fkXuEW3nlEc",
    "DCaTlAtwJ_c",
    "sv1joLlmQuk",
    "4Ya-uGx-mHE",
    "JzoEEz05pjE",
    "6xVSdb9aCOI",
    "nlWVKt-Oo7E",
    "cwwWtBwsHMo",
    "lAonJvj6sj8",
    "wSF5-znNaJU",
    "V1mRhQ9J5Xk",
    "LtE9QiEn72E",
    "wjgaNJMh25I",
    "OMeU8_FmSNI",
    "bl8qucw6J5Q",
    "AsMfBFwue7c",
    "6qWnbPjbE-Y",
    "mZluzO93jkU",
    "jhKKV7DrhgA",
    "8kR6FNpFuMA",
    "iA7PY3knE5I",
    "gLah2UTuoXs",
    "5l9d4BPSSPQ",
    "T61zS79FECg",
    "-gLUwNDlokw",
    "njGjK3Im1Rw",
    "rJEKshzDhN0",
    "Y5PSu8BMuKc",
    "b6WfTwX_3oI",
    "KnvrWweMUvI",
    "gC2-_UEPIwc",
    "yxTc0r_L-0I",
    "VQhStgPBvx4",
    "1MK0fH89vFY",
    "fGp6BbGGGVc",
    "Cwn-ovf9N8s",
    "bjNuF-S29zw",
    "CfiW52NV9QY",
    "SYem0btHLiw",
    "B7esz49Ot_w",
    "mY3v7vMjcMM",
    "GM3CNjhbipA",
    "UMBJhkgKNus",
    "iZ4QEnpM5ww",
    "ATDBCoYdjWM",
    "Y1OVVgetgqc",
    "nshHIgw2_YQ",
    "bic4pEc14Yw",
    "T4porH72WII",
    "potQE5hvgxM",
    "40-UFsRku2c",
    "-G6OhrdIoOc",
    "V2XBORFOuyU",
    "lcp0m8uexI8",
    "eutyQ32TCBo",
    "4Z98SK7DjtU",
    "Z3clnsL9Av0",
    "ygq6IiNRLNU",
    "ZW6vMTVxJdA",
    "wlpD-41Y6ew",
    "4MnUSLt7HaY",
    "8PVecn76-As",
    "cn39C_alJWU",
    "-JB3-WnoZtI",
    "nHMxOQZQNJ0",
    "1_E2PrJ7R_4",
    "D5SLYh4bmLk",
    "XIANrgf1djA",
    "G4-fYXvJGZE",
    "zGiW0-_PPv4",
    "VMcbg5yibIk",
    "iISK_XwbclA",
    "kI5xyIrdpYk",
    "fcv7BgqMZjI",
    "CA4mrTiihlU",
    "6iWnTO16MUY",
    "Hg7t47QpHVA",
    "0yJn2fToufY",
    "iSjN_dja2ME",
    "fKv8gP9asms",
    "gkyvn3Sbaq0",
    "_fEe1u9ZDvk",
    "h4iFssxG9TI",
    "8bQiC-eFHcA",
    "DFzFKtgwySQ",
    "-tJByCTSeJ8",
    "4P67VY6CejI",
    "OAbk0Y6Yw2c",
    "zDVmuwWgHtE",
    "nNzOGGsB6DI",
    "vC1Sowwu-Vk",
    "ZQbTEU2JXMM",
    "LaO_V9U-Bec",
    "hRKoFgP7lDw",
    "uA89ZcGK2Xk",
    "fx2NLAFRX3A",
    "hXf8cHHIz6Y",
    "50QP7U4vUMw",
    "_Q7vIjVRSgE",
    "b2suwDxKrtA",
    "72M-GTGWoJ8",
    "rRcR2uNdFfc",
    "zfV7OfIPqZc",
    "3GAsgBhgHnk",
    "Lj2gdGF7d5c",
    "05qGQ4d0Ego",
    "Q5H1H3Sygaw",
    "DRoxcNh100U",
    "DmYs33mDnsw",
    "msDY1nfq-0Y",
    "dhO4xiHCmxI",
    "79wGjxP6tok",
    "ZeIjltwzw-w",
    "QTgHp_KWMzA",
    "hECOg121A5s",
    "I9Yog7f6EnU",
    "tTqi2jhmgAk",
    "s-1xtYty2Zo",
    "bkTlyKN-hGY",
    "Nfzdum8yJLQ",
    "h8_02WDEJHo",
    "aoeo3Z0D1ok",
    "gi_-seGqzeM",
    "GpDomP5jJz4",
    "IHFI2h6Q8Bw",
    "Qtg3jF62E_Y",
    "YDGC8sEw_xQ",
    "ujCHsO3pLfA",
    "uf44hIkjduY",
    "HzhJIfPqDFc",
    "E8-VSQVYARM",
    "pqj7ZJRe_n0",
    "F0PoqNYju1k",
    "T1HPE7v0Pzw",
    "-AQ6LI167Rw",
    "kcjst5yxE3w",
    "HPbjULkHUuQ",
    "rZ-zL-2ehWo",
    "31YntCIdRVo",
    "izeAFyuWmUk",
    "KEvxJ6xdnPM",
    "aqVSP-rEIDY",
    "r25x4DFNSnU",
    "TnWD1RwqO6E",
    "H8vtjK_vR8w",
    "GCB3qNdAIMI",
    "4asDH0ukfwc",
    "8WdDXc0YhfY",
    "VJLnn7AmR3I",
    "e7-GA0yFFMQ",
    "y9nvxdgbLWA",
    "hPmKTgxNP70",
    "W7OAFX2JzC0",
    "0C2vCqBOuFc",
    "AH_DPQryANY",
    "dkxPbtH64iM",
    "5ZX01dUAu4w",
    "Rai55Gj8kmY",
    "xhCtjYrMHTE",
    "nulbE400e9Q",
    "IkpGZEYbT4M",
    "hmrWFeh2mwc",
    "1R0efcP-4uo",
    "BBIfDsG3F2I",
    "gbaHwFV-3L8",
    "bZ5HBqsRvsk",
    "UvudYxpnTNU",
    "7034pxu3VKo",
    "e_de-99E-28",
    "NB0jYnJryN0",
    "IO9sUg0Lab0",
    "qrm7-VgxrHQ",
    "CMcFvZSUE3g",
    "hwhtaZNUVoY",
    "HD8zgwANaks",
    "EqaMr00Y19w",
    "4a8y09rdg9w",
    "snwsIhJPd0U",
    "_VBKv5z3dj8",
    "8Jh_gh6ybdY",
    "pdQSetf-pOA",
    "q8M0OY67p4s",
    "TyLxYM3XHRM",
    "hLP6CTvWNjM",
    "lvX8th8p3BE",
    "57cvg7hos2o",
    "bUvNt-tpS7w",
    "WMrRPD3IXi8",
    "qJLMyHZsQ4s",
    "W1xV4xL3HZE",
    "eab5Ix5MN3o",
    "jOnQoExgCDQ",
    "HCKFHn0w6TE",
    "rNweMdjFFww",
    "dh2J7uSex30",
    "vB34XtOY2Vs",
    "Y1ZhSgokyAM",
    "HuIehnC-6B4",
    "QOaTuRA7X24",
    "cvpAPWjooaM",
    "5Su5vOiH7b0",
    "VPT8SiwWlow",
    "uYB-MgPnRGI",
    "FuCjZG3IpBU",
    "gDangoso568",
    "DVi6gwV_-JE",
    "KUg1oZuzC1k",
    "cSG3Bg5BGJo",
    "TsYWZulsCLQ",
    "a12ZKP_wQ5w",
    "3SJ2PtKazx4",
    "kb0I9U56SRU",
    "RxQVk9O7qSA",
    "in6cC013iuM",
    "B7Uw24kz5-k",
    "WCoBGfB51NY",
    "JDZGejApjvI",
    "7Q4ycBD4TSE",
    "HrWWYS2SvVw",
    "KBvFw-dc2dw",
    "eghS3hmETzQ",
    "6hwDF6RSTfA",
    "JGztYjg9mZM",
    "d4EGLkM_jn0",
    "ZtiDrG1DdPc",
    "CXlfqoYjYTs",
    "Obg--Gc8Wcc",
    "7zC3Q0ojF_M",
    "8OmzLgkzXoU",
    "z_cSX4ZaySE",
    "wXFE5UloWDQ",
    "hh5vYSn5Rqw",
    "YGaQ7EI8ueM",
    "NxfHELdlosE",
    "b0Q2gWYOw70",
    "2suoU4l8v2s",
    "A9eZ2XLf2TU",
    "BPD0oBbQrFg",
    "ce8gPYqsB8o",
    "KJbifMsWOZQ",
    "c6XJnFyyIQo",
    "1STQA1KWesA",
    "1mptdlfRJkw",
    "Z7s3qp9kZHo",
    "nBJHOs9oBbc",
    "LS89qc-3fos",
    "VBTH9rtmV0w",
    "HjbutNw0HbE",
    "3Y66BqUKuJg",
    "corXQERdDvY",
    "AZy5oHxPky4",
    "Ps3jniNXyus",
    "hseAEqKqc7w",
    "601GGdFqKdQ",
    "Fboi7vILqis",
    "EuohzrrbN7Y",
    "BggF8J5e-oo",
    "A_GIws61L0s",
    "rKDIczvxk-k",
    "h-fC5yP28T4",
    "upnh_qyRyLU",
    "09yrI9tupnY",
    "qMyUsE521sA",
    "rpztlLlaLdk",
    "zB-3298zG_k",
    "10tSLV0-V94",
    "gSOboBqNUW4",
    "o1Ol2vCwqbQ",
    "6EBz-GXZ6vc",
    "iaXqInUZ31s",
    "MTHjbn9tu0o",
    "3qy5Bh8rEfI",
    "GBv1weAdEio",
    "IDleDIuTw24",
    "6LmiNMwjTy4",
    "_gW-sUhBXd0",
    "CAxWQKs3GC4",
    "mNCeFaYI4y0",
    "0ePIbPuoPqA",
    "uNWYkt6JNXY",
    "42YnJwAHBMI",
    "xMGfdHodH50",
    "MSG3nXUs86U",
    "uK-WejyUxKA",
    "CU22YDMKrBc",
    "_ObXflO-9ZU",
    "vr0l2BNww1U",
    "lxI_IWEZzeg",
    "TIfJc70PO4o",
    "slkqBDryEKE",
    "caDOwRiMZus",
    "eATdXl8h8Y4",
    "cg69_3BZSrs",
    "UVF4j47MuOM",
    "WvpQxKjfvAA",
    "xorKlt0j82w",
    "S1Pea3JngMo",
    "aC53HrNbYn8",
    "ehUMiIBPqQo",
    "qNrrfvQtub0",
    "BKdmRY41SFA",
    "CoGW8kPdYX4",
    "rDQeW2wZSQ0",
    "KtZs0Alz7Yg",
    "MZaqBqENbD0",
    "LZC2QhdM9Wk",
    "kGIJkR24qM4",
    "5C3coftzrK8",
    "foakDJOblgA",
    "SDD3Ux-AK8I",
    "AvMUoLRiot0",
    "a4jLLy2oF2c",
    "8VYojJP2EL0",
    "IghEbRRe3Q4",
    "sIQC5uhubFQ",
    "fidMFcORdlY",
    "bRwHGHqpOU8",
    "uzDqhSdQ72k",
    "9nB4t9Q3wAc",
    "8IQyDXeR2is",
    "mtaEpO8bNjs",
    "NI5tGKT3ojM",
    "ynaB-56KOcw",
    "8JnNPEwaFFA",
    "9MpT-tVqvtM",
    "_t_Wi7QQ7UQ",
    "sCfL7FkRwJE",
    "o3M8oxjqt7c",
    "cnnQRNs37XI",
    "bpjJhSsv_0k",
    "LNPMOIFi5B4",
    "8YrI0euRSKU",
    "nX68VC9sEDk",
    "EKJzA5N5vuk",
    "5ZAUNisMqEA",
    "oCs4dK7_Wo0",
    "szYlGYxcWwk",
    "NQOZ42wlu2s",
    "vVfH4ZnU7lo",
    "mskFH3jJHS4",
    "aLdqwo-q0u0",
    "yyl1PA5gWfI",
    "fveolaoca60",
    "sszzhIS6TYA",
    "fHDHUIQWlIw",
    "i2uKxvlyIEQ",
    "O-Zx3azyaKM",
    "E0Dl61q3K7Q",
    "4dZD7Hx4HCM",
    "IrjQGwfbtf8",
    "w8yShik00jQ",
    "o1ibWaYjGI0",
    "OePNetfCoYc",
    "hcuL2LweyV8",
    "Gkhyn4EBAEI",
    "wwS50vfdwLs",
    "RgAtDCSl_Hk",
    "-uSSf8Of2qY",
    "hme_3fr4erM",
    "ZOCUyBlZ_ds",
    "2wfq7eU50yI",
    "kRmK-kRBYEI",
    "m33u9UMaWOE",
    "6BYN52ViG9k",
    "p-dOiC0fUSE",
    "y5AO9EimV8w",
    "jrL6GW0Y0Rs",
    "j2FyI-Qy1-c",
    "zd5Hqt99J7A",
    "0TRoSjjZtIE",
    "aukVaq4TkJY",
    "EMXDQh8UQvM",
    "jI-nOIPEEWE",
    "yRC3aPquYQE",
    "8vpHgHUQ5s0",
    "A9naI-Pa_fY",
    "4Mv-nRxpjRc",
    "Sv5owq_Sg4c",
    "KnJJIdsyf1A",
    "v7EAxNQtPds",
    "zuk3TalDQgk",
    "k91EnHNfnmY",
    "kJHAGD1qt1U",
    "6gWup-fb-fc",
    "9sg6PUKbrwA",
    "7ep5jFZxsp8",
    "-BbjTyF8Uys",
    "ymcTQQWGJC0",
    "8F24zpw6oRY",
    "dNIbTmEKono",
    "TSa0kmrhSMc",
    "7jckKlcyw6c",
    "EVIeA5M9mho",
    "Jm8DTEY5Pf4",
    "EfKhD8hYTkY",
    "xGUApLsT0js",
    "icpT_oFYi0w",
    "BvLy3xW44LY",
    "Iu4BJYDdBZs",
    "iu3Wsqk6IY0",
    "Rgjy26P34rM",
    "bSrDTLK_zVA",
    "MyZtZIUdoa4",
    "hAhKbGEuPxc",
    "Y4Hxc3jXeog",
    "kIHpnFpTpp8",
    "8v_TEkv6hsQ",
    "jw2eo5XCGr8",
    "3zMEjdNZ_nw",
    "qa8dHhp_VfE",
    "48TA-Mcl8dM",
    "7JjrVMKOvTg",
    "-rSzvrVxRGo",
    "7xCj2hz_X70",
    "2uYlW61PyOA",
    "VPRhe-vCYWI",
    "dTCQtrusqco",
    "3xepLfEr5LQ",
    "pFIrtW8a3eo",
    "58UX8REAJy4",
    "Nhblf2YqO-Q",
    "Ce8eXOPEKqA",
    "wsrFhF8BYKA",
    "6bgibhwjSC4",
    "NBeH7O9BVCQ",
    "nwSEDIs9ojI",
    "X4Jrq0vykEU",
    "nI8vk8aPmFI",
    "boCM4xn_yUc",
    "MGJyFkgj8Xc",
    "eeucbS-Oppo",
    "LGbGpzp1k8I",
    "_pQtH0KizQs",
    "2xfLyMmFWow",
    "piZ3TKS0Yk0",
    "XuENTzNegzo",
    "hFt406EySpg",
    "lFQuQa_s0Is",
    "YRSh4DNZfQ4",
    "5T71UdmIfbo",
    "ZLB7Od1nk_0",
    "9e2MoTET0_I",
    "O1qPIIWqQ2M",
    "FW_yMNZe5-w",
    "ZHPv6a76JxM",
    "53CukdGuH5w",
    "XPCdNDBDGrI",
    "mAcwxNq7JrE",
    "a_JIspjuntU",
    "0tnE4JBfmVs",
    "GrkKxiu_ujA",
    "x6ABRTQdeZA",
    "qDzhK-8nvSQ",
    "m6ZFF1taXPo",
    "WU8aKNPwiVk",
    "VZ5eiHVzq8A",
    "eORBn3gSBfk",
    "YC_lbwXzyn8",
    "zTWpnu4AEQ8",
    "n-o7afdX6Ow",
    "LFEB_p24soE",
    "ZXNY1ITrNPs",
    "2jZwI7zIyfc",
    "rtJB4TauF44",
    "Bl18jgX2e3U",
    "c-cbFhKIVS0",
    "BQSoC9PMRmY",
    "2IGL2CARjzE",
    "34ChGbRfdwQ",
    "ISFfTiVs2z8",
    "TZgvYCbG5Zg",
    "wFfkTV6g1OA",
    "BA2lIgaA0qU",
    "rCRnlzc-zCU",
    "Eb5v_z9EJuI",
    "mTVvhk7wsHQ",
    "-GFb06yT-as",
    "jiw2tG3wlh0",
    "7Y4b20mwzy8",
    "zlIxHKFlUMQ",
    "EJDYlIRuthg",
    "BCm-JgTK7oY",
    "9XTgk1K5ljY",
    "QVTdBB0bv_A",
    "yLhgQK-zKQo",
    "zTCn_pbnmD0",
    "0YqeobEZ6po",
    "WV5__ZwjdLM",
    "_QKpfThNpeI",
    "BdJZqMFK1lY",
    "YWW3J2OnfGU",
    "FHvzr61luNc",
    "DIwses6z1tI",
    "x_BH7ACRgAU",
    "SrosrY0FoOE",
    "8fmeT5x54rQ",
    "4TYUdsS__sc",
    "SgpYZqpm1qk",
    "7hd4pLOULXU",
    "TYONE8kVwqU",
    "lXs4J99AogY",
    "d_ozIHBXlc0",
    "vNY4oRnnN5E",
    "A0Y9Yd_gCO8",
    "nAExGmjZElY",
    "xHAPDGyI9TQ",
    "W8AXQLZWpP4",
    "ya2QXvJmd1o",
    "2Maak5mEDY8",
    "UacoCa7lqKc",
    "_8OHqYeByK0",
    "qQFH1Py0H3I",
    "C8e-oOJdVHw",
    "CGq96R91Woc",
    "T3dpcgnPO2U",
    "WrYvzjrsFqQ",
    "klg4947OTEY",
    "my_m1t3badw",
    "h75XcasRQsI",
    "szv_NFjBLHg",
    "1QlZTWhkrwg",
    "fbaT-LW-3es",
    "BzcTvwfaTbg",
    "_NxMuR4jnuQ",
    "yQHpjUP6VwU",
    "udXbcgMAfNU",
    "XmFihU9oTKw",
    "J7uaali4eBc",
    "X5V4n11aOQY",
    "DniFAUIclVQ",
    "_knlEu2Q5D8",
    "FBc0upKs678",
    "5fVeMH41dpc",
    "xsuG7-0Ke3w",
    "lxa7ig1xZgk",
    "CwYVCcHWUUs",
    "ZjvZgKX4yeQ",
    "nOgJUJBL7W0",
    "D3qeNWQ175w",
    "Wc1irKJ2HwU",
    "Zqdf1Rsmup0",
    "w2dJf-uFNl8",
    "U1w6bcfVnAU",
    "M-42aWsxg-s",
    "BAR7V6XhmKU",
    "04BwszSDM1k",
    "T69wRjfPgVU",
    "aRMHw3I6cpM",
    "2J6pfsgudyg",
    "_fqF81mlCxA",
    "20E5ozS3l_4",
    "cU_CJmFx0No",
    "UtXozBcUsr8",
    "M-VqQROc7Z4",
    "yiRErP-nB4c",
    "dGF3EJVnO_U",
    "sLuuPd287WM",
    "NmO_IxSxeqA",
    "5MYNwi4IpJg",
    "4eq7MzCC7D4",
    "8B3DslGcUC4",
    "kHBgvGspQXo",
    "4gJF80bpRdc",
    "FNQZUMP0TWE",
    "5GDM0UcKtgM",
    "srRzrpMh8-8",
    "vketK7w96Ns",
    "V5WgqZCsfQg",
    "jYvQ6b9mqh8",
    "3GUWz-aW5-4",
    "KbF3sanLLeI",
    "jBKoUw4Nfu8",
    "Qq7-DGvOM7k",
    "-cklnfEbqdM",
    "X1nGruAaAcI",
    "s9A_v1i5gik",
    "YIzXjJLhiWY",
    "UisAzkI9YBk",
    "U92gXduKW04",
    "4ETZoXwMySU",
    "zBcXgV6xHJc",
    "NFhxSk6e2XY",
    "yCquqYXr-mU",
    "VutTB3vNJoQ",
    "Gx_xkPBOJqw",
    "gDTWT1Y2A1w",
    "EKwY1MF_Mmg",
    "XgeD0RhtP9I",
    "7y99QiMLCNA",
    "Qc7BUgxAsJ0",
    "58yueo9hMv8",
    "XJWl_IpRQPE",
    "HXj5UVtPOGo",
    "bmVZcUlOJzM",
    "lGIOC8Ock3E",
    "Pa55L4diexg",
    "SPvA7_L4dmI",
    "np8GhbG-FTw",
    "tVFX_XOB3J8",
    "snstoXKL7q8",
    "Iuz27m-WHus",
    "RtFGI-FX5wk",
    "0y01uBQARdw",
    "xhauYdKd9S4",
    "MhNoe83df6k",
    "PVtMhBoylXM",
    "Yv68_DYR4ww",
    "vl0I858V7xU",
    "uzISdinSUX0",
    "NMhGB5lWtg0",
    "FtuyFh5EGWs",
    "nPPNBwspxJ0",
    "3bIZM2Ouv5M",
    "8SXv4odckvI",
    "pVEpGwo6FL4",
    "fBvA73aqhm8",
    "ZGTjXePG904",
    "nmZ8RormV8w",
    "BAG__bD5tAU",
    "wia-ZRvUTY8",
    "trbBZmlw8X4",
    "-Xoax7odm9I",
    "GS1Hr86sK5I",
    "S2ec_zH1F2U",
    "11cB7SS02SE",
    "uMasPjFxQwc",
    "SJKlaoSmCbU",
    "S8fw4s3cYZM",
    "mcLBF5tfDhM",
    "Bcmrv58-TjM",
    "0Lv38Psi5J0",
    "yaspvhjcBME",
    "HY54AJJ2O8I",
    "EYXMkB9u0dc",
    "gBnAT77YRgQ",
    "bpIvOzIEgFA",
    "JGh7odPWWTY",
    "QDyNHFJBP2E",
    "OMFBC3p5epE",
    "5i73pZe4HQY",
    "d28QsTiv6qM",
    "26ftGgwfPSc",
    "CmNhg0_KWXc",
    "oQRJLFTHCIc",
    "qL3jtEGX6o4",
    "jF-jc5seN2U",
    "RIYFN1keht4",
    "xau3wsFX5kw",
    "yLwnMS65Agg",
    "OdDRguodnIA",
    "2NQ_lte4Yvw",
    "WM63h8MzecQ",
    "aE3m9oCjBIo",
    "uOEiQPAIGpA",
    "J-oamQknw6o",
    "Bn-PxnjcWVo",
    "eQa6MlXAE1c",
    "JfmYNTuJHWY",
    "6Cl7-Hv82yg",
    "3arxbxXcDRQ",
    "0EPnhq6Vlts",
    "XuSJ8hhdD30",
    "yqv1bEFZh1k",
    "HyAnbODFXFU",
    "tepek1fawJs",
    "c9e1t2BvgAY",
    "dndyrLskKRk",
    "5eIiqYWvXXE",
    "G3HId4U_ehs",
    "L77Kw32bkT0",
    "7zusUXPgn8w",
    "_Fulw_CgQTQ",
    "PabB7aO6lO0",
    "r_ch8IFiRZg",
    "L1smm6vdrYk",
    "pzN23qUssBQ",
    "w1mEch31SFg",
    "vpA3osR04io",
    "ooc2292tFvY",
    "3QgN4R7SV2Q",
    "3LVrM9fSH8Y",
    "GIOaPr9mmD0",
    "_AMWhyAJGEA",
    "B4dUWmLuytY",
    "Dg9VfDtT74o",
    "UY59Qh2U9xQ",
    "tuCggWjy2JI",
    "RhriQMfUj6Q",
    "l8hmDQ7ByF4",
    "zMAPiGeoZo4",
    "FJG1bjQEp1k",
    "-zLOocMm3FQ",
    "rk3qLS0qqdc",
    "xpwSMtBN0hs",
    "8TmmERMQW40",
    "jkUU60OUPfo",
    "FnGbLHPX5eQ",
    "4g8-J1B9vUU",
    "2L8iCjePhOs",
    "e-9hn0W7nK0",
    "jSc5zqjRmUA",
    "5h4CPc1YzO0",
    "cDGmhh6ryic",
    "kW8MCpjmRaM",
    "tLIhgSUE71U",
    "szuNbvVHrOs",
    "V0l4vdTO3tc",
    "6QWBEdDJ6aQ",
    "stuJ21fW8lM",
    "D_UNrQ8M3PM",
    "gNpvc25q6MQ",
    "Txdo_Q7kURs",
    "DmjzXmHnJsQ",
    "IYUhl91mEB0",
    "Gm2zoFzX0Ww",
    "BhOB0BsVAa8",
    "IOUlZRqvwpE",
    "ol-C8hwr6pE",
    "OBMUdcVcmHo",
    "Sru77bu-rB4",
    "2tkebouRkJg",
    "Gl_kYXn9dJk",
    "vVE3MqihOzY",
    "nczic386czo",
    "CKtIkRZ8yYE",
    "CubyvnVxOCk",
    "slhmbxkXnc4",
    "s3NkHdKexdk",
    "PbGuu2bgXF0",
    "7-PNFEoJXyc",
    "3TBr39sUTqE",
    "BvnwhxiC7ZY",
    "LRzxnWMPTGI",
    "ndey4kGngwE",
    "aDRlbsMaNzM",
    "ulkBmUySwUM",
    "w-Lq_3-iTHk",
    "8-PHbKNLVpg",
    "aZtkvCPsx4E",
    "coMjbG5TgX0",
    "QEjmPWEYQm8",
    "lc62WAuzhlM",
    "v-emap5NaTk",
    "okZ1zMadNUE",
    "CfDLL0hOsTk",
    "ZcwIid-rrxE",
    "oR63EM3-GO8",
    "lwltVtlQhqI",
    "dhdyGIDlzo0",
    "p_bkyhn_L1c",
    "0FCicWTyZ9s",
    "IW7ZDIBlLFM",
    "XABUmJEVZcA",
    "PZ26CLY9Wko",
    "iU1tcIlhNnY",
    "ql2MC9FrKvY",
    "LD6OYCpi8YA",
    "rTX3YRwI-uc",
    "B8VivgX67Fw",
    "u10mG5sLaRw",
    "M8N5fm3mjzM",
    "fxHPfoXYvy8",
    "a5PgBETZoNU",
    "F3yaXF5E5Hs",
    "JZksIEqrGDc",
    "hnuQiASW_H0",
    "Bdmg5x2mRcE",
    "oCAkk8Ok2eA",
    "7-lV6H1qtgw",
    "xr5J4rVBNoc",
    "Kc4-DuoYjqg",
    "_O-lgdz0VkM",
    "VKhhQfv4vXU",
    "7Rto4HT3V-c",
    "CtZVZ14XgJ0",
    "rpJQT49-Eew",
    "p6Zrcv-pkSY",
    "GC0_BB97-Ec",
    "CJM5nLxMFCU",
    "qaQdGsKLP2M",
    "ZJ1jcCHzvjg",
    "QvVtzaiSJXE",
    "y6OlYLu9KJM",
    "Q8ijH0t3oSY",
    "zfKiI1UL5p4",
    "cS571Onx1Fs",
    "-jZZ7jUbLec",
    "SUOU0P4-vg0",
    "NGgf64ac6HY",
    "w91YyI4inTY",
    "PGRQo1p1k8g",
    "MfT9UvHo16E",
    "81vF3iKkTlE",
    "aUEYmAlDH5w",
    "f7aveJnHogc",
    "j71d4rfvXew",
    "7khkCs2Uv8I",
    "dgLp12Dl7CU",
    "RgY67haW7zM",
    "6YOTN9O2VOo",
    "mW_E1WRrg8A",
    "XvXzjMLIIFo",
    "k1qcEt_Pcpk",
    "-MBFjOdODMI",
    "97WH-lPC-_c",
    "0fR6joplKOM",
    "uaQqKNjB6ZQ",
    "Twr5-iSLXSI",
    "MvvbCU12Fng",
    "bH64Jc4gkno",
    "9sh9qUqpvp0",
    "Bdx103nafMw",
    "E-XxfRa8rsY",
    "WO_O3JoDCyE",
    "cbmVCN9kswY",
    "pcsZJMETR7o",
    "ITOnSJjxTIQ",
    "eBZ96IPc0Eg",
    "uY_br-QOQSw",
    "d6qq5xnfSho",
    "rGqrjM4EDyw",
    "W-ugm-xPvDk",
    "hbgyBh_pBWs",
    "PhmUna2UnCY",
    "zXiAf5XLtMw",
    "DubGaQJ3L8c",
    "uLqFboQ3lEg",
    "xpfMDWEkjPg",
    "IJdKZh69e6E",
    "ma7E9adu4ew",
    "_bWlClx3scs",
    "SP1KKHfEq6k",
    "K5sqzw8FKBE",
    "FmSpGzwfQ-E",
    "qVaZL0Ar84M",
    "wq922L8OX7w",
    "vx2zNZgu8UI",
    "SE10GyqUSFM",
    "v0wfzXhKRuA",
    "dZkukYcrimI",
    "03tJ4pfVS9U",
    "Pr1kNXbwUAQ",
    "n8RG3qQ0Gfc",
    "Bs51fpqbhGs",
    "7UuZ5d_xnHo",
    "AlwyEu_JlF8",
    "T9KXsEdHgPo",
    "VHjq4DD1amM",
    "NRSykxs7gNo",
    "3dnsmmwdRXA",
    "JukHtDiK2a8",
    "X-cgcEsuKI8",
    "OjK3tnLq0VE",
    "Qoh7Nl6-rGY",
    "dkEHs8FVirQ",
    "o1HAdcc624M",
    "w1rc8G-_mJo",
    "WK0P6gjpcq8",
    "YLpJ2fW1HSk",
    "g9RrkDEsbms",
    "JVXL-Zp3jkg",
    "86rZ6pW1Ka4",
    "P9cemm7hoIg",
    "Vp7burlarfc",
    "Oiqcm_2qRj0",
    "32HyiuztvSU",
    "6gbvOLf68M4",
    "KJO7x0q7fuQ",
    "zB4K-86hEG4",
    "RrgXCedOZCA",
    "dz9rO0IvZzs",
    "D8y38cFTmuI",
    "HRuSrKFWUrs",
    "aJdcZ0lmgSI",
    "toQbJ9u7sW8",
    "ZFtU0UskejM",
    "8AuWRSuoHzg",
    "U9h3WHVGVto",
    "T0QFQsuZYSw",
    "ZdpLVBzWTss",
    "HEl3jpW9CZ0",
    "-CN03nocw4Q",
    "7N-bm1P8D1s",
    "UbI_12y0TPg",
    "HAmmeWQa-w0",
    "YGGe0l_kP8k",
    "k2NuVQW8x4Y",
    "FZivgpEpALk",
    "uD3tue28Dsk",
    "TRSXIBv5GqM",
    "I3M4MKoQEuk",
    "hzV7JVNbH3g",
    "bCUDCe2q75M",
    "eob7i7Nntro",
    "BGBEW1-WjmY",
    "hcgedbQjQoc",
    "Za0tfv-OsI0",
    "VkO3IcnA84E",
    "Ylus9dJz02U",
    "-zhVFObnJfg",
    "yd-bFYsZ6O8",
    "S-fTtTbHcw4",
    "Yn_WIXnLyZc",
    "f3etg_fDlwI",
    "phLITVgTbXA",
    "R0hHRTxlp1A",
    "Oryh2I63JI0",
    "UWFV-kxZoFs",
    "G21w6JCbq8c",
    "g8grOFvUNkY",
    "RLkJeBfWtlk",
    "lz2FzMK1CK8",
    "9_glfu76qi0",
    "_o-He8dvrZA",
    "inPbIqmPGvI",
    "9QDc5LwLC3s",
    "VzmAjV0I4ec",
    "Kldy0Yt27h0",
    "B4dPzWSY_dc",
    "ISTRgo6DFM4",
    "brP-kRKvR1Q",
    "AzyRP2EhhUM",
    "6ESXYWCaor4",
    "-Pl127g7V1U",
    "ozLxxLb48NY",
    "9afED5OMe5k",
    "Vv8XuzNJ5Ts",
    "G2UQU96tn4E",
    "q1WRy9LFs58",
    "n20Qp5QILgc",
    "d-FDmwYqAUg",
    "LbDc2mBJO78",
    "jHfATKSGHD8",
    "063t9uzJm3Y",
    "0r88BRvETaU",
    "PdfRFaMwn0o",
    "jQEfkg749pM",
    "pZXR3xCGRCU",
    "dk_URt2OQYw",
    "Y2iSFzWbm6c",
    "44oQpuB2EU0",
    "5mNm9bYXymM",
    "0ZNimTFOxBw",
    "9dv-GG9Nrog",
    "p6sRfNK51L8",
    "Orl2GoVUFUQ",
    "WFm_UyGuIbQ",
    "l37ADofVAFg",
    "sTOzsSXZIC0",
    "lhTT050Vq4c",
    "v_OGTd96nIM",
    "HWSVcocw6vY",
    "YseL7yc-qFE",
    "VIdPxPSLoXA",
    "ALL6E3w13t8",
    "fQQlfAtSWRo",
    "Buov65Lk3JU",
    "mnwMZ_tEfiI",
    "_JUqM1lh7BU",
    "FEiuO9sdQLQ",
    "lenwouRqgYY",
    "muMfO0qL7nE",
    "4S5UC1ffwsY",
    "DtbBhcuadT0",
    "9IbTeE1OAsM",
    "kmye9ZrxKmI",
    "XvD2qx6NNUU",
    "bmmThWo-utI",
    "2_BzlwKgoGw",
    "E9Rp5w8otxE",
    "yMxeWbxsRNw",
    "7jEO0eKCpV0",
    "XrduED2pxgM",
    "OFoNx0zgnzE",
    "rQMVJSi7NxU",
    "zqDsNGFst40",
    "YVnlA12uBOc",
    "qy08mlb4PDs",
    "ALMQMlwZCbE",
    "hpLtWWweelw",
    "4J9sJ_tUfkg",
    "Oo_PAKsNoVw",
    "FlNI8PauHMI",
    "QsH6mqaMhsY",
    "NI5Pea7Rd9g",
    "fONwQ5o23jY",
    "CQsFgPPeE_w",
    "reUxtOgc5d0",
    "RuGU1U8FZiQ",
    "RCudVUhdCeI",
    "tBsVXGWV7yI",
    "B-aGgkI4ANs",
    "Explvt8c6Eg",
    "2OopkFF_DiQ",
    "u_H-eGQds-U",
    "b7pujeAZ66Q",
    "rTX4ztRxUBE",
    "xHHL8Ly6rkc",
    "23-8ndevIiw",
    "nDadKkQ_HIc",
    "74aSxeEWpac",
    "KeqO6ExKiWo",
    "nPWoBx2yHWg",
    "Q2QOZ0NtiM8",
    "hhAug2-5ic0",
    "3c9xcDDrY88",
    "dnKwi_Ij6bk",
    "1HMe__BL7rk",
    "HAXb3PFW8WI",
    "UBsyCdgvbqk",
    "6fmjeJFgB6s",
    "J3_39C3OQPk",
    "JVJTQAFq-ZQ",
    "vAxXwhkd6lc",
    "qgKW0hL2Evc",
    "semi5a_fofs",
    "5N-dPEjnLj8",
    "t7V2iixmTw4",
    "kMDebiHbYj4",
    "EDqA6zO5baA",
    "6_80H4tGEFk",
    "4mzSi9VeUyw",
    "SJvsRrtnkTM",
    "BTCjcn-Hcpo",
    "wDuZRDQEvSg",
    "yUHOSyPdA1A",
    "g-yLuwX9EDE",
    "fw5h3rWU8xI",
    "iQ1kmVe5_6Y",
    "y8ZzhaRt7QA",
    "pxwnPiW0a7c",
    "pYU-VTcVu8E",
    "_CG6D8JUOIU",
    "G4UJWwVfPQI",
    "PQuCggjBAXQ",
    "fzKkSPQqW-c",
    "IEpGNoE9Z08",
    "aJT_RFwuvgc",
    "D78d4Vh7dZM",
    "F8cB9cFHt14",
    "FGQmyfG0ZHw",
    "8CJ_ovQUYnM",
    "Jnpp_AVBuPc",
    "MxnBrcFQQtY",
    "TCi8acBg8TM",
    "YYt0VaqDVQQ",
    "_8J5GhX3ekk",
    "LJ6G0f1D6ug",
    "vfmHe-9CLaY",
    "vFiML6whsIQ",
    "fXekKrGzieo",
    "qmoU-bNl91g",
    "LejpJuaO61I",
    "a7YnXI_hS28",
    "Cod7FYc9J30",
    "ez06djrdsA4",
    "fllzREC3F6c",
    "5KvBKU2n3HE",
    "ZEWXYVrTF68",
    "FaCrNQ3p4ZI",
    "7zTrPhJv0Y8",
    "tGgHVsli-dI",
    "4cgItFS2DR8",
    "VIJBJF8YTEA",
    "6HRvd7nS3x8",
    "vTEHbyceLOM",
    "z4JE90VclcM",
    "zy-v5dv9fc8",
    "4MWgkyWJ-N8",
    "wPKssQP8D-A",
    "3U9F07qBdQs",
    "_oG8vU1Sf0c",
    "OWgdiLTljiA",
    "1u2LRKpu7mM",
    "EJA8M8oqfOk",
    "SSO9AljS9pQ",
    "tnQS6-rs8f8",
    "gLEpm-YzGDY",
    "OOwfsA-ABro",
    "0VtUVjNLdqQ",
    "jsgGAKq1nhw",
    "gZcXCc7N50Y",
    "Smv6oqhoQYE",
    "48oo46ZvkjY",
    "FeFe-gQ559M",
    "JCmFsvR5vVs",
    "w6qe42ixZmo",
    "8qDQX5Yam9Y",
    "22d79faxlxw",
    "L7XlB7tw-fM",
    "wN-MpM3Zlkw",
    "tIbYk8OG1BM",
    "aRogxttPuzo",
    "PEVSTWaQeP0",
    "hdwt1mB66yA",
    "cVjGLYbj2nE",
    "aW0wlN8L5I4",
    "Rpd3Ex0U8ZE",
    "in223IoWO4E",
    "gVJvNtvWYTQ",
    "cCbu0tS7XXo",
    "iyc74zkEIXM",
    "kq-lUFuNRa4",
    "4SFndo-VmrI",
    "_lFy7Bavv_Q",
    "H5vD2Upu62A",
    "E-0X7lA9MAM",
    "OQCFzCCdi3M",
    "UzUMmMYpQ-I",
    "-0nnJzy6U-0",
    "WqY-wmLRhl8",
    "3jawaNNeo6M",
    "__-f9a-Y_dI",
    "VgiYfgnJKbM",
    "9BZ_WZpSDZU",
    "bCSGbu2ApxQ",
    "Db1F9e8SdS4",
    "nwVNUZoDfNI",
    "9-sSXmn4J_c",
    "2OlZ_Szvy9Y",
    "yTetMvthx9w",
    "dHratijMe7k",
    "dpOUwGTjmL4",
    "dbQ-Bq10x_4",
    "nLX-XfYLYP8",
    "MXl7dO5WeqU",
    "Gg6JgegPYqA",
    "5SYe-wU9v00",
    "MOOZJX99Jx8",
    "7wh34DFsQUA",
    "peTMiiPo_kM",
    "Rm2Az8v2F_U",
    "AVT0EqOB3SI",
    "QvseMZ0oQzs",
    "lW2YMip3a30",
    "6WEABLudldE",
    "e7cWIy7Ms3I",
    "HPGXiAjs49Q",
    "7oVUQvY7QR4",
    "YJq5HbCJ0eA",
    "HQ8NwxhZzKY",
    "MKEWso1Dshs",
    "4UyDlCtCScc",
    "AckR3KryyxM",
    "hceNykSGNSM",
    "NUrytCLvKPA",
    "YiUsAMgz-Bg",
    "n_1f26QqSCI",
    "AK-jWPEngYs",
    "erV2p83docg",
    "ROlQq4MfJPs",
    "7Gr9CvgU3qg",
    "Pkoz-PnNvXQ",
    "SmnQWpAGw9E",
    "zn6KaAkMczs",
    "PWmHafzZFOA",
    "hkAsI0G4kzo",
    "qRwv6Kn1AYA",
    "Vr5QjiS7gU8",
    "7pxqRH-hO8o",
    "EW91NKZL-AA",
    "g0rUYTwOx4E",
    "F6DJBMwh84g",
    "Lhd3YV8uwKs",
    "LXLu2-lJM-k",
    "iaTBBvst1S4",
    "2VYrzkOWV_8",
    "dPaAl4LNHeQ",
    "mA8CpJjFFI8",
    "aMINJY6Xq14",
    "rS7Zf2L0arw",
    "3XNIBCo-JMg",
    "6oAD1p7oosQ",
    "8ObXe3GYWCA",
    "JBiABQtZ-b8",
    "gZ_Mkt_j78k",
    "v2Zxwm5lWWA",
    "W9_Na9Nyrak",
    "pin0QTlU1_w",
    "pnhFu6eEjGM",
    "jsmF-8z-3Xc",
    "nEdC9gg57_M",
    "j2bh5dwarcs",
    "swrBDSpvkJ4",
    "qY36P1ecE0A",
    "rYqttr66i2E",
    "kLDhg7uwBcU",
    "SQgh6u8BSss",
    "z6c9KeWYfr8",
    "5t9Q2LU9fbU",
    "f3wOVyoaQMw",
    "UbNWshnaiOI",
    "1yhc_3MVUuQ",
    "dVY1FCwaoUk",
    "cOeVE1G5IHU",
    "a12ZOOInGW0",
    "Ps9Tau85LqA",
    "zeIHu4aUMxo",
    "vg9CmuzHxkk",
    "jQd59utaUzU",
    "KQFjvak1O0o",
    "n3rNGnxXsD0",
    "P6bgk6O5XE0",
    "Ygizwi__OCU",
    "1_h1NfaSjMQ",
    "js8MpUI1RHs",
    "kSMn7jjiGbE",
    "Go4pAjEq0hI",
    "ZHat43fBCIQ",
    "0NhtWiVhz9g",
    "_3qUOMyZzOU",
    "P-KItnogZJ0",
    "052NkGGMZXg",
    "yIiJZUpKaoE",
    "lPv7x_ohcHQ",
    "DJDB9q7N2Gs",
    "qdc1gHFEh_Q",
    "ji48mjYLpa4",
    "FFTO6Z7tQGQ",
    "znkpbMBbPhU",
    "zB8AcVDxSkk",
    "hmKN25YnywI",
    "DKhrCx1RqYo",
    "v8sLXHA0iRM",
    "5lRTq5V4zCc",
    "JE6KbTchvN4",
    "B91NRNIlulI",
    "S_qSoPG54xs",
    "0g_vmnu8Yfs",
    "vT0DbEzsgcw",
    "Etisz3vUKfA",
    "3bLZ3V_SAi0",
    "hCNnik_yKK0",
    "G6rA6JyLcbQ",
    "bmvD4XmxxLA",
    "ouPyDvg8k7c",
    "F2cOFQieCe0",
    "qYueP1m-5ZM",
    "oXINDhlwxzM",
    "rBdBD7NKvL0",
    "lQx2U9MG6V8",
    "sc943xLAx30",
    "LdKKlJv1eYM",
    "p9jYgaMIt-k",
    "o34b0wIMeLA",
    "l9_RqDvfuSg",
    "BGpSYx7r9Qw",
    "UbXoJOoO1yc",
    "NilgdPiQYfg",
    "qrDGphpmLN4",
    "nxfngkBrLMI",
    "TwSeieER_pQ",
    "kv0NVb2n-ck",
    "EWifNjWPoMI",
    "hUbS3owxcoU",
    "PR_OpPUjaNw",
    "2611ljaFSZs",
    "2u6nd1TcpWI",
    "fkmaTy7UCBk",
    "2ow9oVnTSHw",
    "MJQBrkOtbq0",
    "zkAaj758omk",
    "9y0Y8iihJso",
    "KpO6SBlmjWI",
    "f9KV--4bKX8",
    "1VyYu5Us-ho",
    "x285zK76I04",
    "AI4q_ApHpR0",
    "B3ZylVRwjJM",
    "w6NvUqSaYI4",
    "m-iHPX5qeyU",
    "A6fxDYSNeAI",
    "ycDxS8tDYPo",
    "LDebKwM5Ukc",
    "Td5FF7Nw9gw",
    "T3jg9TfvKX8",
    "89LARvUnZwY",
    "I3sXsZOEepg",
    "PJ_fFrdSKlg",
    "7E1u2kKdIbE",
    "UJz-7rlk-tA",
    "EpA0G9mQgI4",
    "DJEIKUfOCm8",
    "pI3F28O15QQ",
    "UE0q62oZ1Gs",
    "St4ms4mm4Y0",
    "YPAXCgrL5Ak",
    "SLjzaceY6ms",
    "KxxSSfjqb3M",
    "6s7ow6QvcKc",
    "0EXRD3x7KRk",
    "J7k4VoKCuMs",
    "E2-ehFLlEAg",
    "bZmRNQ78L0I",
    "oRpUbw7NTWI",
    "wMayTRMZgtI",
    "vhdDDD1ZhV8",
    "89fR66Jd_UQ",
    "BBgcSqaRqXY",
    "HLV3782b6uE",
    "KLV9xfL8OVo",
    "efIGzdlAP74",
    "0SFG0Kp_ygw",
    "YADNMhOmFfs",
    "fu7faM3j5ms",
    "8MLjUnjgwx4",
    "uMw5D7t4K2c",
    "1dHj1SjPVyQ",
    "KD7MIBlsDCY",
    "SIVC8JKTaiQ",
    "A-6JfZPypIE",
    "7nLEm_0IbCo",
    "caGy_2WQ36k",
    "8U-7Ojfke3g",
    "EYOmrWt7jvc",
    "0zmF4yAtPJ0",
    "GgnufEkR2Gg",
    "3DkU7mRIhgI",
    "rJrruN7_n2o",
    "nSnIJRHGXso",
    "iwDODp2GxfM",
    "lIUktKtircI",
    "MIgRfBEt688",
    "XIF9-5AZLEE",
    "lK-cvVUUxLg",
    "geyG_iP3zPA",
    "442VGazwzYs",
    "fBKsGFXQ4d4",
    "iP9To0KfvHM",
    "uWVhnAlSQDg",
    "ngpAZh4wwQM",
    "iQo6Av5u9hM",
    "P1LjshHkPtI",
    "ujWorIU_0HY",
    "a00FDzQarVI",
    "rMSjHDX4RKs",
    "UQkrcNFrUfg",
    "w1OEbgRbr-o",
    "Fm336QvVrsY",
    "QDQQ5OApdmg",
    "DN-5VVy8bNA",
    "WB62RQR5r6Q",
    "GoDsYayohU4",
    "k04-BeniB2Y",
    "NBb9taTzWqg",
    "CJERC_B1RJ0",
    "mfPzbFvpvyc",
    "aegpMZg65V8",
    "lz9LgF7NoNE",
    "maz1rS7mk3M",
    "cXGkuO9MIpc",
    "kh_JBbgE_lY",
    "5t_fCif0yZU",
    "vV19ARuGdmg",
    "0U8waqvGj-k",
    "CnFbcm9utqo",
    "bsVN3Cq86Bs",
    "b0dWq-nTXng",
    "Idg_GH6ECVo",
    "zNLITIlVitU",
    "B7oj1hs1sZM",
    "uaIPGM6cypc",
    "dYtUvSKDpLM",
    "IVF2k7I-eoE",
    "LLglLdBHvJo",
    "GMME91bmrvs",
    "ugA0cEqOiME",
    "FOb7IyHJC3o",
    "b40L6t_FsVU",
    "02Kwizi4smQ",
    "IhL59Bp0aGI",
    "jUWn_fOjS1c",
    "KPAB0OBsNhE",
    "UdfQR1YioLc",
    "OVpexF10XVw",
    "ee3LQaR8W8A",
    "o4CRjmQgRds",
    "1QBYGc5YWmo",
    "uJUTh1q72EE",
    "CNlWJMRUYxM",
    "0cCk6n3Ohro",
    "hkHGNZwwRJg",
    "XbklHuqnv1I",
    "9JSbdo_-cEU",
    "elSQDAyuEZQ",
    "6Fu97rllesI",
    "NVtkyRBOeJg",
    "WwbLYen937Y",
    "YDZuC-ouRhg",
    "IVD6bALrGCM",
    "m7mLtUjAnXs",
    "6y1cB7ylZM0",
    "mfPqJAXnpCE",
    "3VPI3fYq4s0",
    "uRO8N0mrR8A",
    "UWOsNQmiVEY",
    "JIr1fK2T2Ak",
    "jdO1rkP9-84",
    "P8iv3kbbmx0",
    "x1Xtln3JvTc",
    "JFiQEbLZn8w",
    "NKJjJCe03Bs",
    "nDFJDUGL1_Y",
    "dJ12qs8cJYE",
    "Rl2I13a7skk",
    "4gPlYmwua6o",
    "ySbiSDHDBok",
    "X5IWrJHtaBY",
    "mW0Vn9dq62s",
    "V84oV2sQdp8",
    "e-2vnGyY9XQ",
    "OSXIUDDgskw",
    "SeALpLFsxcA",
    "M-qcUzUXwRg",
    "SWhO50zN7Vw",
    "xMVSQ83c_P4",
    "CrCbygfA_vE",
    "IR4VKcqWbwM",
    "THjDC5BBy2Q",
    "vslQLSQq3CI",
    "bxXurBLtQfk",
    "BxLimWZh96c",
    "OGxgWVcumHI",
    "EqdgnFHIs94",
    "rDilC69UxpI",
    "Y26Pl-xoqBA",
    "XFZksKWBgyU",
    "iALL1Mp98Io",
    "W4hWm2CdpoU",
    "eKu2Y0OFH-I",
    "Om1M13Dmc5I",
    "jgOwwS5_qzc",
    "25FfkxjyzJM",
    "EeXT3QbJw-k",
    "tcaxS-R1rBo",
    "_90H-8c0fIY",
    "U5HcJ2a2EgA",
    "xA15yhQaWIo",
    "9syyOLWazL4",
    "ai1UeXlgNRg",
    "KK6guuRSNPw",
    "Q_Gs9NMl8NQ",
    "3VPn1SqWnZs",
    "h8Kv5T0ZnVw",
    "sZnbZiXtb1A",
    "3MvKW4Q8y-w",
    "-26o-jPs1X4",
    "CjMwVMAzjcA",
    "Lp1RBfPVR7E",
    "Soo8eLH9-Ec",
    "78rgjTSRQEk",
    "qSDDsnUmUa8",
    "fZOh4N8HCCE",
    "ImEmuWCq5-4",
    "Rlh1UjlQCYs",
    "D6BcQg5Ck8g",
    "beeZ36V1soU",
    "M3jzmZoIAls",
    "aINdkyjZOYE",
    "E5AsCztu9no",
    "-RbP2S-RDaE",
    "wFn_nd8Qgso",
    "kxvV07j59Sc",
    "CRllMlbzQUs",
    "UMNRsnSpq2k",
    "4ySNb1Mg52Y",
    "HLG__Uh9Wvg",
    "FRRAL987mo0",
    "d2sxEJGmICk",
    "0Zd8INHMc_g",
    "8eo6epyWKzs",
    "SJ73CTFUuQg",
    "dwHENawdZ-4",
    "do1MXuCDP_A",
    "bJAyszxHkRc",
    "YVyUmoSnt1s",
    "sKpGsJBBR8E",
    "3wUCNK10-Mc",
    "zdMI1TwuXcY",
    "o6hDOIGkpV8",
    "eGNS8YRJJwI",
    "7C7rRw7KJUg",
    "AnNN8qHMi6g",
    "bxFEC60ts28",
    "l0NKIowwOVk",
    "R3CgctDeCJQ",
    "5pUgkvXb3LY",
    "7W_Bu2VP25g",
    "k4QMGEBQjtE",
    "tH0yPBH1RPg",
    "v82O8B_JvGU",
    "bn4_Fw0Kjsg",
    "7v0BO0BvurE",
    "AhGIwqac5DA",
    "N5QMy1jmc28",
    "Ivh9VWtrYvk",
    "UN86YWjWjQ4",
    "lisAtBtGtPQ",
    "x5d3qB7m2tE",
    "wKHRAvNXqzk",
    "BeIyC6J7K7I",
    "lFF4XuEBvmI",
    "cR4LrqwXdKw",
    "_stAc4Uh_YY",
    "w3zQq4wSVAs",
    "4WgxKOZeYss",
    "n3uzWehfySc",
    "v0moVdxXmuk",
    "D9jkwwRZ8oQ",
    "uaU30bovGyk",
    "I3zFy45gTr0",
    "oCQIR8RXeNs",
    "W_rTVJFe2i4",
    "cGEHjWTIrzk",
    "mSAtEJPFrIo",
    "FqCzkDxhfoE",
    "YHdrh4NARlo",
    "8W1KxWBbZhY",
    "96ERxiYSWdQ",
    "C7gqPVtAZ-g",
    "cCoju1Nfdcg",
    "VgS4SCTiVDM",
    "RAQUH3Fg5xI",
    "R_GkKoNmr5g",
    "yxXLxAJRtWo",
    "gtFotk3qEUc",
    "HYpRj8vDjeA",
    "cB75Y7PIUMQ",
    "RTnqqgOQmkg",
    "vEbBfaKS7BY",
    "qNdXfbH3ALA",
    "sya79e6na1c",
    "LmhLg1XKgxo",
    "Yw_oY-DKFR0",
    "dC0C0rZQcHw",
    "0xzr7vue7ik",
    "VC0u4SQLpa8",
    "UuFi0gcJ31Q",
    "yD1D45Hn-DU",
    "1q2yllZ0uLY",
    "1IJT1Lh7XOY",
    "yVa2pzpt6GU",
    "oK1sCe_Wb4I",
    "cnMr0RUnizw",
    "_Jv5jUkZjGg",
    "a3XNNkcV7Cg",
    "94fV98pVy1U",
    "f1oudB9fvgc",
    "Nwf3XjPU9iw",
    "Y9GTjsi3qO4",
    "p9SnzgMlu_s",
    "U4gwNWG3Pbc",
    "lw7ZtQtvF68",
    "AkUB1UykSIQ",
    "2-b59_rJqFo",
    "uqC6I7QrAdc",
    "_gCkheUVmZY",
    "4uJanJ09MdM",
    "_cd0RS8H10E",
    "5i6Wg_LOdN4",
    "4Z6pOSugSNQ",
    "VpIrpe7IaXY",
    "8bDlko8JveY",
    "zRFgl66vRHo",
    "XglkNIcaPO8",
    "_F2nvSes6E4",
    "fpAnWeHMl7I",
    "p51XOYCN7V4",
    "cfgVLQAQJ7g",
    "gOTZvH7MX8U",
    "bcT6VCvkiYA",
    "QWqw0fLV54U",
    "GMKZd_r7iCg",
    "8qB72BSZv8I",
    "HlQFjXPmqo4",
    "2dINQ7voMaI",
    "RiJJVHb95wE",
    "kmlSpU5PX-8",
    "LX1NPQDwXuw",
    "wjaeAMwN1bE",
    "ckNa0d_eTbU",
    "pwjet1OeKns",
    "n8nKyhaN7QQ",
    "sfFHKqMWc-8",
    "lwBtHnX8dqE",
    "F-AC14lG3cA",
    "IqnswgMM4-o",
    "a7VbGota8rc",
    "YvrrJ2U8AGA",
    "aIlPjWzXr4M",
    "a1RzfdJfqC4",
    "MJXOQTQiuYk",
    "IIigNMBiOME",
    "ZheXmm3QfA8",
    "93y2JFrSAG0",
    "eOaV3BXrVCY",
    "l0ok2lj4uCs",
    "FJpGrduT-uA",
    "wHr4JL8W3HI",
    "l1jCbuKmg6Y",
    "KD7a_bTqyRw",
    "STcL5aX_Dfg",
    "Ih-izEb6_Qg",
    "lAuVD7wsA0Q",
    "6p-qXnC0i2A",
    "7vJAtSM6Dd8",
    "ebrYSU5xZQI",
    "4ami9ViXknc",
    "28DaAxAyOaM",
    "bCoFQ1eXueo",
    "Vy0NwUB5pC4",
    "ntojJbM26Mo",
    "aMY8ezNdcFw",
    "rD9EDsayyyg",
    "-KpANdy4kfw",
    "vQ3QJfGittg",
    "H4pjOsrm8rc",
    "OfumzK1-Y5k",
    "aOxd5v2S6tI",
    "0lMEauAVnpc",
    "Cb7EmCAmqxI",
    "J7uQVOhybD8",
    "2HpjE4ROEiU",
    "2AMm4on6qJ0",
    "JvZKgGDaH_I",
    "3pjOBBLc284",
    "ZN0Gs55Y5g4",
    "Py31LJtWyLM",
    "LUuT7a5B0gM",
    "tLW76UsebVw",
    "G5DTD-58Ua4",
    "t6RMNTi-_D4",
    "kdVcx8oyMb4",
    "kwQIpg1gh7M",
    "iJ6wTkdYDOo",
    "6pJ2zvF-ta0",
    "n-QTwmELjME",
    "WEFAvnJrJDQ",
    "5M2H3W6mSKM",
    "ta5t9T0cCZY",
    "cl2I-tWcl7I",
    "9ihSAKSgUBw",
    "kJ2vE_rUStQ",
    "DICRdn3gF_A",
    "wCYfNzpDOj4",
    "eCiJnIbcaHE",
    "fnRtmNXKN1k",
    "GX-49syS8Yk",
    "x8sV_JZpEXU",
    "NxNinaGrc00",
    "7YVx2r_cKFo",
    "J8oEawZPQTY",
    "wbSylC2LnvU",
    "mRm2ySWh87s",
    "ZfY6L2YHlHw",
    "JbmR2nGoa04",
    "O4OCGmkyPU4",
    "VbNF1kD93Os",
    "kpWqFZNKzdM",
    "ChnidFjLW9o",
    "bMxG0veinNg",
    "sP3QzjFmG5c",
    "-V7DEL0NZac",
    "jE5ZQeAXuqg",
    "XUwVgj0DlIg",
    "hRKxDL_x6qc",
    "_8lPc315y9g",
    "o_ELYzpjo04",
    "bi40q72ln6k",
    "jpRYMrDDEHY",
    "6MT2JDdPOsQ",
    "Zz2VqcUS3nQ",
    "9801S37ZZzY",
    "A25XKirNTeI",
    "p_8km5ZZwDg",
    "9jPPQss8bJc",
    "NX9m8aaYuwg",
    "IAL4eafuZQY",
    "Bsk5htOzQc8",
    "IddulYAP0TY",
    "4CwN3e_MiTg",
    "bDL4yClNbqI",
    "qTYFn-USHMI",
    "m19OFgDs3Zs",
    "D4lIN0Fn3MM",
    "01M7ONRt6xI",
    "7Ayn-FEexPM",
    "RgQnMMgDIsM",
    "ro-ZIteFVQY",
    "YwiEfcBHofo",
    "tl4lBJgVWn0",
    "ci9QAOmLajg",
    "-vp4OV8Z540",
    "jjMQjRzib7c",
    "U2vZ6t6lTYQ",
    "y5qqaLZnVvM",
    "GbeLRAV7raU",
    "_ZpE6-XI8gk",
    "-iwmKTdp79o",
    "hrl8uLhkzC8",
    "3LvfWVXeZiY",
    "n8Rkgbgtl-I",
    "57Sn-P6poP0",
    "leXKMqc6KIc",
    "Rj5rGmxYj0w",
    "lVT492XlA5c",
    "6L0mSx2HZD4",
    "zIfMizzqFT4",
    "7xEPVMhme5k",
    "QDL5ZKKme60",
    "sDmoBrp4rGc",
    "XCHjFTWCwIk",
    "nu8FMiPt7HE",
    "n-WBV9z4aN8",
    "ST3UZgoQ1DM",
    "CdAtFfukMTs",
    "SjlfIhG1uxw",
    "ezx9BXf8LO8",
    "q9j6PzT2JcE",
    "AOE886UG9C4",
    "AXZOaERcuq4",
    "3EdDmgwIO0E",
    "dahvy3Wvgxw",
    "dpb-wtyqSyc",
    "_JGRYKz8OeA",
    "N5L_dvA_MNE",
    "kO85quP4LGQ",
    "mrQ-Xc_uEUc",
    "b29zuC31YGg",
    "b72fdUKOKno",
    "glaAT-gPLy4",
    "CI9OaYWUsZQ",
    "tZNbWYArj3Q",
    "mF-vs-cjBR0",
    "UAJsI71zpbs",
    "c9uN3RMmiv0",
    "7WIVVw-QBqk",
    "nRyFWIO-lyo",
    "HrlxGdJXo3g",
    "F3IEZkcyL88",
    "jNd8MbgtsT0",
    "oNApda1BPGI",
    "3XRoeuxeOx8",
    "haL1_LVHxto",
    "eLJ_4ld78tA",
    "Bf28f7IsVc8",
    "1k6J5QfXvDk",
    "Mm37wMcuOLE",
    "tCdHOI5670w",
    "T92dnBrXDCI",
    "tbNKhcBQtQg",
    "Y9g_RHHb84I",
    "ESClKgzs6Hs",
    "r1Gh6aEtb9M",
    "tgX8xwmAqjQ",
    "Iw_4A4GgtZE",
    "AGkc4Fg5H6o",
    "Aoi5bVMsxQ0",
    "-QYc2sfHnSg",
    "hRnmxPFoyHQ",
    "SOR-FPzfyGk",
    "JZyjYuGFGWU",
    "nB5h1eGOf0A",
    "Zp6CmVXA9dc",
    "xTarqoUj2gY",
    "E3fZMTdeZDQ",
    "wqiJZft4cYk",
    "NF_lQ0mkae8",
    "K8bS4F8-zKQ",
    "1779t8BHG5s",
    "aPknFiGQQ4c",
    "rHMOzkcOyOg",
    "elM92uB28Nc",
    "3MXhaSyJYgc",
    "QFMJGv2pxgI",
    "O2pSZQ57Rvg",
    "w4P-FA-79AY",
    "jsP3aDzfdU4",
    "tcK7W6tpUV4",
    "wXoRe1iHwzE",
    "G_RmjVR11E4",
    "EE7RHjwovXI",
    "f7Y8Ll5c26k",
    "eiPIhEwxQQI",
    "0fZsEaZIvBw",
    "emAFzWRQaNU",
    "vfWRoKkLdmY",
    "Vis1Pb0AggA",
    "r7LI_3KE74Q",
    "RSuDaVFcoTs",
    "m2OXBGPYI6I",
    "iKiFKCEaF0Y",
    "5zYa_kvptuI",
    "AkfTJFWXYM0",
    "_mtrXBd2FDs",
    "aQFdyfBNID0",
    "KzeW_SwSj5A",
    "L4to5OyqLcs",
    "pfOyHvlcBbg",
    "Etszh8vg3qQ",
    "xLsV7MYAsdg",
    "7YbfIQbBy4w",
    "qa9PzeW7Nd4",
    "s42xiLfiCMg",
    "sdz7sYZjJ3Y",
    "unfdUGIfjpA",
    "oGnmMOhCw6A",
    "JKW9sg2PWCM",
    "oTj7tA2-30M",
    "2gE58bQWLc4",
    "pnrcgiRvBmU",
    "hsTtkc6rTfo",
    "lFL1iKR1JS4",
    "oaopK4vDjE0",
    "D5ZZvXKger4",
    "ON1TLJ-Vois",
    "Tdmj-ffI2eg",
    "AlxT-m97T7c",
    "JXB22Zbp9yk",
    "sv6GP3UL99c",
    "lott6SCRfGE",
    "WqbfpO6q7RY",
    "afq0vP8pqkM",
    "PCAn7BkJOYM",
    "efjnMztkRSg",
    "E76fUVvvtuE",
    "13s_duN64rA",
    "FYTdjguXqa0",
    "TDPxB1AMBS4",
    "NySKBZxqEZI",
    "h-_R2FIRhaE",
    "V50TCnzQ5aM",
    "eqzwQJl9nsA",
    "6W3dBoMWNi8",
    "tic92n1vv_A",
    "12WrDTcVhtQ",
    "R0aTJGJbEko",
    "XjoznqbLe3g",
    "O-gUy4_ebcA",
    "kiss_pLTIoU",
    "kYh0SLBj5SI",
    "UZmrbYJjdPw",
    "g3bQfhUDaUE",
    "fC9VTyJ-jfA",
    "JRn9QKZdfn8",
    "qEq-jVJ5mCw",
    "X1zxwCznb9g",
    "v8QnKt42KHA",
    "7xgdwOFQqkg",
    "MVjdhLkppGc",
    "fckQom8gTvA",
    "ccDCuQQ4ZaI",
    "-H43XIBlIWg",
    "QoL8X2909GM",
    "71ygwSnclk0",
    "fHqadL2zt_A",
    "XtPR1gjiHpg",
    "PSqfLb8VWIQ",
    "72_cjcuRdyk",
    "sOf9DQ9CUg0",
    "LivKwfT8oic",
    "OpwUYTsSfV0",
    "U1XNU4SdpFc",
    "N-_hl_KPdlE",
    "iCWNbRNQlYQ",
    "S6dfuJtltKU",
    "l5REl3V2LcE",
    "j0lmVeOEQto",
    "CYOdXhMfdRk",
    "TkkAk_5OdOU",
    "hwgBMt9EQ-4",
    "9tX96U0uwBw",
    "WLDU7F0_9zk",
    "vsKrpbBT8YM",
    "SKrlMZ9mfEY",
    "AfUPemYeqEM",
    "qhqE2IFeCsU",
    "vg-VGaFx-Uw",
    "MgvQJvvn8wE",
    "l63N5icA-DY",
    "mlYZkYohXnQ",
    "KQfAHGjMWTQ",
    "tW6f3Jdnvmc",
    "KX-IBEYeWTY",
    "feK4B9dca9U",
    "Cd8rC15SXE8",
    "R5KCfv8SZXs",
    "i4VDi8YDagw",
    "fk5eQSXyieo",
    "_dzFNjJ8ufw",
    "c734HZQmgZw",
    "bQYEjvKmFVM",
    "uTUS8zpA23o",
    "mIJ1EHmvsTE",
    "y3bsR7jhMjg",
    "4JuF01MDcH1",
    "emOGFg9uYOk",
    "isBANg4amos",
    "Bx1AGFgpTbw",
    "lXlYVfd_RbI",
    "hco0rO4Bm50",
    "HS-xB-oKJqw",
    "yTiTX3Sa6Eg",
    "sEgD__RwhhY",
    "-tHATYj8_Rg",
    "XASwnetLJa4",
    "VwgVZ7Ciivw",
    "hIMZbW0EIzM",
    "u2Q3theYjsA",
    "1S1VTYsTz8M",
    "IOeM1YLIBOo",
    "DZxQjyM6mR0",
    "7-Xbh0ww3Ws",
    "sObeW0UbxIs",
    "weVlK0j-00o",
    "puI8R3gkNkw",
    "fajsGegvDmM",
    "SsgvmfcKn3k",
    "IZG_m74JXJQ",
    "--nUPWensU8",
    "_4WsBWLkEjY",
    "6UmMSHTJkWo",
    "M_heKLF8sH8",
    "scE5IzLd4cA",
    "bnqo1L96Q1E",
    "pr_eJnALX2s",
    "UPXb4P81Yv4",
    "yeRn-XRaRhc",
    "h5dSawLEqvw",
    "cUn481N7JAU",
    "71lwV5tCPys",
    "f4v7EHY2dnM",
    "s2YWQ-f_Z9w",
    "mFpgt3BL9gs",
    "VrnvUEYm89Y",
    "nt912IKBkSI",
    "XhSLkIxNIKU",
    "jp1oYiJJ5rQ",
    "msXANCPCLhU",
    "NTVADRqLJ5Q",
    "7oon14KdgpQ",
    "XU_loH4pXLA",
    "stVKh6hOveg",
    "heUDWR77Dyk",
    "CLHII7HOmOg",
    "CHN8BtsCUyU",
    "X4lxR-lfssw",
    "bKWiG68_OBA",
    "25Tl79nFJIU",
    "ab82It_iha8",
    "tsNJRrKRQjI",
    "ba7uZLmw3JE",
    "ZZ_2mKgPIts",
    "mN8J5JJmuZM",
    "OjgFu-KWS2M",
    "2b0-Iy6N64M",
    "1yI2lJOMNt8",
    "he_cKmoly54",
    "ENbt2WUZcHM",
    "M0SLa90QOso",
    "_phifLe9X0o",
    "0nQwHoAPJEE",
    "bLkLXw0QhNc",
    "tU4Fj_LSzSA",
    "5DzE_5IKBcA",
    "GoAsBLmVx90",
    "Wm6kR1AnLc4",
    "n3cujahYGSU",
    "PMOH9j0x5gE",
    "lboVpLmLUV8",
    "JZ6GbeIcCAc",
    "N5-uFsUqNs0",
    "_RmtAWLxZ_g",
    "wkDmrwzDnWY",
    "yBb_hB0IfYc",
    "uP6L-96yz1E",
    "K-tOTeUou70",
    "V_QJE3Lif-4",
    "vZXaeY1Q4gI",
    "EKHbnr19wEs",
    "jEhot1DsnzQ",
    "giquWp0c4DI",
    "DcmG9LYKccw",
    "k_tLXK_fAJE",
    "caEFbC_KH3Q",
    "HLyddhZS7N4",
    "ppAW-qKb2y4",
    "tbi3MrsRiiM",
    "xtkQJmXjFxY",
    "AYNbck7eens",
    "u8JZuJ_vc74",
    "C7EdAGcqzrw",
    "tHxZvShw5w8",
    "898s-ULFALg",
    "gJAqK0ohJUk",
    "xG7xTezbzYM",
    "q1CfolOWj0Y",
    "Sp2LHbjXjXM",
    "HwpmAP6Rxms",
    "VjZXy7AgTRw",
    "7OSCeoScCLI",
    "0rx4_-Bpnr0",
    "AOuS6hTERvA",
    "B86PJ5iOyK0",
    "gYOHEyWBJcw",
    "8HVygjVXPlQ",
    "tceYpc4F4t0",
    "GQzAv1ScFYM",
    "hmJhHz2n7wo",
    "6AKnNTW_I3I",
    "dasQRIaHnss",
    "JWcPgy020tk",
    "Ens2DNY7mnk",
    "PdKZ9CiynvA",
    "yf3Cx_kLrNk",
    "At9KT-7-9Iw",
    "l8eU88dU5yg",
    "FiX_BWRo7rs",
    "Pnq2dH9sXXA",
    "03b0d_HoVgw",
    "7_5WLLrgp28",
    "cbPot5BNCc0",
    "jbHq__LNkHU",
    "XdQrmS54Ys8",
    "pwxSpXKB0IA",
    "A8dCVd-Sah8",
    "ESaYg4ANAfk",
    "8ChvjLbi9Ek",
    "zxu5kP5wA9A",
    "vYsxXCL0R4A",
    "J32K0zWUPDo",
    "wZSDT210bG4",
    "znidPiNxYnE",
    "Sb7-3bHP_Wo",
    "C3dL5PTbNbM"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"26le1":[function(require,module,exports) {
let workerURL = require("f30cb4eae74e7ad3");
let bundleURL = require("dfc95596b7e0546d");
let url = bundleURL.getBundleURL("eSPxa") + require("bdcff3dd37e35663").resolve("5DAVI");
module.exports = workerURL(url, bundleURL.getOrigin(url), false);

},{"f30cb4eae74e7ad3":"3OKNS","dfc95596b7e0546d":"c7Tr5","bdcff3dd37e35663":"fyJL2"}],"3OKNS":[function(require,module,exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["8CgKt"], "8CgKt", "parcelRequire10c2")

//# sourceMappingURL=index.0f3931aa.js.map
